window.typingJsonData = {
    "nm": "ready to render (3)",
    "ddd": 0,
    "h": 1440,
    "w": 1440,
    "meta": {
        "g": "@lottiefiles/toolkit-js 0.76.0"
    },
    "layers": [
        {
            "ty": 0,
            "nm": "Animation 2",
            "sr": 1,
            "st": 0,
            "op": 600,
            "ip": 0,
            "ln": "34287",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        720,
                        720
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        720,
                        720
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 1440,
            "h": 1440,
            "refId": "1",
            "ind": 1
        }
    ],
    "v": "5.7.0",
    "fr": 60,
    "op": 482,
    "ip": 0,
    "assets": [
        {
            "nm": "Pre-comp 5",
            "id": "1",
            "fr": 60,
            "layers": [
                {
                    "ty": 0,
                    "nm": "User chat",
                    "sr": 1,
                    "st": 150,
                    "op": 750,
                    "ip": 150,
                    "ln": "34286",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                720,
                                720
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        858.75,
                                        1379
                                    ],
                                    "t": 165
                                },
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 0.667
                                    },
                                    "s": [
                                        858.75,
                                        1259
                                    ],
                                    "t": 173
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        858.75,
                                        1259
                                    ],
                                    "t": 202
                                },
                                {
                                    "s": [
                                        858.75,
                                        899
                                    ],
                                    "t": 231.997
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 1440,
                    "h": 1440,
                    "refId": "2",
                    "ind": 1
                },
                {
                    "ty": 0,
                    "nm": "AI Chat",
                    "sr": 1,
                    "st": 176,
                    "op": 776,
                    "ip": 176,
                    "ln": "34267",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                720,
                                720
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        740,
                                        1160
                                    ],
                                    "t": 202
                                },
                                {
                                    "s": [
                                        740,
                                        800
                                    ],
                                    "t": 232
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 1440,
                    "h": 1440,
                    "refId": "3",
                    "ind": 2
                },
                {
                    "ty": 0,
                    "nm": "Dots line",
                    "sr": 1,
                    "st": 238,
                    "op": 838,
                    "ip": 238,
                    "ln": "34197",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                720,
                                720
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                720,
                                680
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 1440,
                    "h": 1440,
                    "refId": "9",
                    "ind": 3
                },
                {
                    "ty": 0,
                    "nm": "Isometric",
                    "sr": 1,
                    "st": 256,
                    "op": 856,
                    "ip": 256,
                    "ln": "34180",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                720,
                                720
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                720,
                                720
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 1440,
                    "h": 1440,
                    "refId": "10",
                    "ind": 4
                },
                {
                    "ty": 0,
                    "nm": "Text Field",
                    "sr": 1,
                    "st": 0,
                    "op": 200,
                    "ip": 0,
                    "ln": "34144",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                2506,
                                898.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                26.5,
                                26.5
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                729.5,
                                1152.5
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "h": 1,
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        100
                                    ],
                                    "t": 0
                                },
                                {
                                    "h": 1,
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0
                                    ],
                                    "t": 198.996
                                },
                                {
                                    "s": [
                                        0
                                    ],
                                    "t": 599.989
                                }
                            ]
                        }
                    },
                    "w": 5012,
                    "h": 1797,
                    "refId": "12",
                    "ind": 5
                },
                {
                    "ty": 0,
                    "nm": "Window",
                    "sr": 1,
                    "st": -269,
                    "op": 601,
                    "ip": -269,
                    "ln": "34106",
                    "hasMask": true,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                1732.527,
                                1732.038
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        50,
                                        50
                                    ],
                                    "t": -269
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        50,
                                        50
                                    ],
                                    "t": -69.004
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        100,
                                        100
                                    ],
                                    "t": -24.004
                                },
                                {
                                    "s": [
                                        100,
                                        100
                                    ],
                                    "t": 330.989
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                744.5,
                                671
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "h": 1,
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0
                                    ],
                                    "t": -269
                                },
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0,
                                        "y": 1
                                    },
                                    "s": [
                                        0
                                    ],
                                    "t": -69.004
                                },
                                {
                                    "h": 1,
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        100
                                    ],
                                    "t": -24.004
                                },
                                {
                                    "s": [
                                        100
                                    ],
                                    "t": 330.989
                                }
                            ]
                        }
                    },
                    "masksProperties": [
                        {
                            "nm": "Mask 1",
                            "inv": false,
                            "mode": "a",
                            "x": {
                                "a": 0,
                                "k": 0
                            },
                            "o": {
                                "a": 0,
                                "k": 100
                            },
                            "pt": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            1771.5,
                                            0
                                        ],
                                        [
                                            88.575,
                                            1221.99
                                        ],
                                        [
                                            729.858,
                                            3205.51
                                        ],
                                        [
                                            2813.142,
                                            3205.51
                                        ],
                                        [
                                            3454.425,
                                            1221.99
                                        ]
                                    ]
                                }
                            }
                        },
                        {
                            "nm": "Mask 2",
                            "inv": false,
                            "mode": "a",
                            "x": {
                                "a": 0,
                                "k": 0
                            },
                            "o": {
                                "a": 0,
                                "k": 100
                            },
                            "pt": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            1771.5,
                                            0
                                        ],
                                        [
                                            88.575,
                                            1221.99
                                        ],
                                        [
                                            729.858,
                                            3205.51
                                        ],
                                        [
                                            2813.142,
                                            3205.51
                                        ],
                                        [
                                            3454.425,
                                            1221.99
                                        ]
                                    ]
                                }
                            }
                        }
                    ],
                    "w": 3543,
                    "h": 3542,
                    "refId": "14",
                    "ind": 6
                }
            ]
        },
        {
            "nm": "User chat",
            "id": "2",
            "fr": 60,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Shape Layer 2",
                    "sr": 1,
                    "st": -411,
                    "op": 5942,
                    "ip": 0,
                    "ln": "34285",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                89.761,
                                90.154
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                622.242,
                                559.41
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            44.559,
                                            34.521
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.098,
                                            0.6039,
                                            0.3373
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            388.357,
                                            -241.811
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "What\xc3\xa2\xc2\x80\xc2\x99s my current subscription? Outlines",
                    "sr": 1,
                    "st": -94,
                    "op": 5940,
                    "ip": 0,
                    "ln": "34284",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                714.765,
                                325.105
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "W",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -254.407,
                                                    -22.953
                                                ],
                                                [
                                                    -248.407,
                                                    0
                                                ],
                                                [
                                                    -245.141,
                                                    0
                                                ],
                                                [
                                                    -239.813,
                                                    -19.031
                                                ],
                                                [
                                                    -234.516,
                                                    0
                                                ],
                                                [
                                                    -231.251,
                                                    0
                                                ],
                                                [
                                                    -225.219,
                                                    -22.953
                                                ],
                                                [
                                                    -228.628,
                                                    -22.953
                                                ],
                                                [
                                                    -232.955,
                                                    -4.27
                                                ],
                                                [
                                                    -238.155,
                                                    -22.953
                                                ],
                                                [
                                                    -241.516,
                                                    -22.953
                                                ],
                                                [
                                                    -246.705,
                                                    -4.305
                                                ],
                                                [
                                                    -251.031,
                                                    -22.953
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "h",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.948,
                                                    0.802
                                                ],
                                                [
                                                    -1.167,
                                                    0
                                                ],
                                                [
                                                    -0.51,
                                                    -0.917
                                                ],
                                                [
                                                    0,
                                                    -1.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.469,
                                                    0.927
                                                ],
                                                [
                                                    2.427,
                                                    0
                                                ],
                                                [
                                                    0.906,
                                                    -0.594
                                                ],
                                                [
                                                    0.667,
                                                    -0.844
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.229
                                                ],
                                                [
                                                    0.948,
                                                    -0.802
                                                ],
                                                [
                                                    1.406,
                                                    0
                                                ],
                                                [
                                                    0.313,
                                                    0.573
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.646
                                                ],
                                                [
                                                    -0.864,
                                                    -1.698
                                                ],
                                                [
                                                    -1.354,
                                                    0
                                                ],
                                                [
                                                    -0.531,
                                                    0.344
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -220.903,
                                                    0
                                                ],
                                                [
                                                    -218.091,
                                                    0
                                                ],
                                                [
                                                    -218.091,
                                                    -8.875
                                                ],
                                                [
                                                    -216.669,
                                                    -13.422
                                                ],
                                                [
                                                    -213.497,
                                                    -14.625
                                                ],
                                                [
                                                    -210.622,
                                                    -13.25
                                                ],
                                                [
                                                    -210.153,
                                                    -10.547
                                                ],
                                                [
                                                    -210.153,
                                                    0
                                                ],
                                                [
                                                    -207.263,
                                                    0
                                                ],
                                                [
                                                    -207.263,
                                                    -10.734
                                                ],
                                                [
                                                    -207.966,
                                                    -14.594
                                                ],
                                                [
                                                    -212.903,
                                                    -17.141
                                                ],
                                                [
                                                    -216.294,
                                                    -16.25
                                                ],
                                                [
                                                    -218.091,
                                                    -14.469
                                                ],
                                                [
                                                    -218.091,
                                                    -23.031
                                                ],
                                                [
                                                    -220.903,
                                                    -23.031
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "a",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.811
                                                ],
                                                [
                                                    -0.87,
                                                    0.488
                                                ],
                                                [
                                                    -1.019,
                                                    0.135
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.54,
                                                    0.146
                                                ],
                                                [
                                                    -0.344,
                                                    0.22
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.562,
                                                    -0.76
                                                ],
                                                [
                                                    0.989,
                                                    0
                                                ],
                                                [
                                                    0.593,
                                                    0.468
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -1.07
                                                ],
                                                [
                                                    0.513,
                                                    -0.291
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.519,
                                                    -0.063
                                                ],
                                                [
                                                    0.541,
                                                    -0.147
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.727
                                                ],
                                                [
                                                    -0.927,
                                                    0.457
                                                ],
                                                [
                                                    -0.813,
                                                    0
                                                ],
                                                [
                                                    -0.594,
                                                    -0.467
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -199.126,
                                                    -4.447
                                                ],
                                                [
                                                    -197.821,
                                                    -6.785
                                                ],
                                                [
                                                    -195.523,
                                                    -7.425
                                                ],
                                                [
                                                    -193.823,
                                                    -7.643
                                                ],
                                                [
                                                    -192.233,
                                                    -7.956
                                                ],
                                                [
                                                    -190.907,
                                                    -8.505
                                                ],
                                                [
                                                    -190.907,
                                                    -6.243
                                                ],
                                                [
                                                    -193.251,
                                                    -2.514
                                                ],
                                                [
                                                    -196.126,
                                                    -1.828
                                                ],
                                                [
                                                    -198.235,
                                                    -2.53
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.968,
                                                    -0.853
                                                ],
                                                [
                                                    0,
                                                    -1.55
                                                ],
                                                [
                                                    -0.984,
                                                    -0.941
                                                ],
                                                [
                                                    -1.553,
                                                    0
                                                ],
                                                [
                                                    -1.073,
                                                    0.551
                                                ],
                                                [
                                                    -0.573,
                                                    0.75
                                                ],
                                                [
                                                    -0.23,
                                                    -0.364
                                                ],
                                                [
                                                    -0.969,
                                                    0
                                                ],
                                                [
                                                    -0.23,
                                                    0.031
                                                ],
                                                [
                                                    -0.438,
                                                    0.125
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.156,
                                                    -0.015
                                                ],
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.119,
                                                    0.176
                                                ],
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.218,
                                                    0.75
                                                ],
                                                [
                                                    1.966,
                                                    0
                                                ],
                                                [
                                                    1.285,
                                                    -0.81
                                                ],
                                                [
                                                    0.052,
                                                    -2.069
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.343,
                                                    0.44
                                                ],
                                                [
                                                    -1.466,
                                                    0
                                                ],
                                                [
                                                    -0.681,
                                                    -0.434
                                                ],
                                                [
                                                    0,
                                                    -0.962
                                                ],
                                                [
                                                    0.124,
                                                    -0.251
                                                ],
                                                [
                                                    0.645,
                                                    -0.083
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.573,
                                                    0.198
                                                ],
                                                [
                                                    -0.969,
                                                    0.853
                                                ],
                                                [
                                                    0,
                                                    1.416
                                                ],
                                                [
                                                    0.984,
                                                    0.942
                                                ],
                                                [
                                                    1.291,
                                                    0
                                                ],
                                                [
                                                    1.072,
                                                    -0.552
                                                ],
                                                [
                                                    0.094,
                                                    0.666
                                                ],
                                                [
                                                    0.437,
                                                    0.688
                                                ],
                                                [
                                                    0.396,
                                                    0
                                                ],
                                                [
                                                    0.229,
                                                    -0.032
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.178,
                                                    0.031
                                                ],
                                                [
                                                    -0.157,
                                                    0.016
                                                ],
                                                [
                                                    -0.386,
                                                    0
                                                ],
                                                [
                                                    -0.12,
                                                    -0.177
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.584
                                                ],
                                                [
                                                    -1.228,
                                                    -0.75
                                                ],
                                                [
                                                    -1.696,
                                                    0
                                                ],
                                                [
                                                    -1.285,
                                                    0.809
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.104,
                                                    -0.869
                                                ],
                                                [
                                                    0.613,
                                                    -0.796
                                                ],
                                                [
                                                    1.268,
                                                    0
                                                ],
                                                [
                                                    0.681,
                                                    0.434
                                                ],
                                                [
                                                    0,
                                                    0.471
                                                ],
                                                [
                                                    -0.219,
                                                    0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -196.798,
                                                    -9.566
                                                ],
                                                [
                                                    -200.61,
                                                    -7.989
                                                ],
                                                [
                                                    -202.064,
                                                    -4.385
                                                ],
                                                [
                                                    -200.587,
                                                    -0.85
                                                ],
                                                [
                                                    -196.782,
                                                    0.563
                                                ],
                                                [
                                                    -193.235,
                                                    -0.265
                                                ],
                                                [
                                                    -190.767,
                                                    -2.218
                                                ],
                                                [
                                                    -190.282,
                                                    -0.672
                                                ],
                                                [
                                                    -188.173,
                                                    0.359
                                                ],
                                                [
                                                    -187.235,
                                                    0.313
                                                ],
                                                [
                                                    -186.235,
                                                    0.078
                                                ],
                                                [
                                                    -186.235,
                                                    -2
                                                ],
                                                [
                                                    -186.735,
                                                    -1.93
                                                ],
                                                [
                                                    -187.157,
                                                    -1.906
                                                ],
                                                [
                                                    -187.915,
                                                    -2.171
                                                ],
                                                [
                                                    -188.095,
                                                    -2.874
                                                ],
                                                [
                                                    -188.095,
                                                    -12.515
                                                ],
                                                [
                                                    -189.921,
                                                    -16.016
                                                ],
                                                [
                                                    -194.712,
                                                    -17.141
                                                ],
                                                [
                                                    -199.183,
                                                    -15.926
                                                ],
                                                [
                                                    -201.189,
                                                    -11.609
                                                ],
                                                [
                                                    -198.564,
                                                    -11.609
                                                ],
                                                [
                                                    -197.893,
                                                    -13.572
                                                ],
                                                [
                                                    -194.774,
                                                    -14.766
                                                ],
                                                [
                                                    -191.851,
                                                    -14.115
                                                ],
                                                [
                                                    -190.829,
                                                    -12.021
                                                ],
                                                [
                                                    -191.016,
                                                    -10.938
                                                ],
                                                [
                                                    -192.313,
                                                    -10.127
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.469,
                                                    -0.672
                                                ],
                                                [
                                                    -1.312,
                                                    0
                                                ],
                                                [
                                                    -0.349,
                                                    0.042
                                                ],
                                                [
                                                    -0.323,
                                                    0.094
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.156,
                                                    -0.007
                                                ],
                                                [
                                                    0.136,
                                                    0
                                                ],
                                                [
                                                    0.218,
                                                    0.115
                                                ],
                                                [
                                                    0,
                                                    0.584
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    1.073
                                                ],
                                                [
                                                    0.469,
                                                    0.672
                                                ],
                                                [
                                                    0.406,
                                                    0
                                                ],
                                                [
                                                    0.349,
                                                    -0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.209,
                                                    0.027
                                                ],
                                                [
                                                    -0.156,
                                                    0.007
                                                ],
                                                [
                                                    -0.51,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    -0.198
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -181.099,
                                                    -16.734
                                                ],
                                                [
                                                    -183.365,
                                                    -16.734
                                                ],
                                                [
                                                    -183.365,
                                                    -14.437
                                                ],
                                                [
                                                    -181.099,
                                                    -14.437
                                                ],
                                                [
                                                    -181.099,
                                                    -3.359
                                                ],
                                                [
                                                    -180.396,
                                                    -0.742
                                                ],
                                                [
                                                    -177.724,
                                                    0.266
                                                ],
                                                [
                                                    -176.591,
                                                    0.203
                                                ],
                                                [
                                                    -175.583,
                                                    0
                                                ],
                                                [
                                                    -175.583,
                                                    -2.234
                                                ],
                                                [
                                                    -176.13,
                                                    -2.182
                                                ],
                                                [
                                                    -176.568,
                                                    -2.172
                                                ],
                                                [
                                                    -177.661,
                                                    -2.344
                                                ],
                                                [
                                                    -178.255,
                                                    -3.516
                                                ],
                                                [
                                                    -178.255,
                                                    -14.437
                                                ],
                                                [
                                                    -175.583,
                                                    -14.437
                                                ],
                                                [
                                                    -175.583,
                                                    -16.734
                                                ],
                                                [
                                                    -178.255,
                                                    -16.734
                                                ],
                                                [
                                                    -178.255,
                                                    -21.406
                                                ],
                                                [
                                                    -181.099,
                                                    -21.406
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "\xc3\xa2\xc2\x80\xc2\x99",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    -0.553,
                                                    0.932
                                                ],
                                                [
                                                    0,
                                                    1.333
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.006,
                                                    -0.057
                                                ],
                                                [
                                                    0,
                                                    -0.073
                                                ],
                                                [
                                                    0.3,
                                                    -0.552
                                                ],
                                                [
                                                    0.578,
                                                    -0.094
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.125,
                                                    -0.136
                                                ],
                                                [
                                                    0.552,
                                                    -0.932
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.021,
                                                    0.073
                                                ],
                                                [
                                                    0.005,
                                                    0.058
                                                ],
                                                [
                                                    0,
                                                    0.718
                                                ],
                                                [
                                                    -0.299,
                                                    0.552
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -170.353,
                                                    -14.812
                                                ],
                                                [
                                                    -167.837,
                                                    -16.414
                                                ],
                                                [
                                                    -167.009,
                                                    -19.812
                                                ],
                                                [
                                                    -167.009,
                                                    -22.953
                                                ],
                                                [
                                                    -170.353,
                                                    -22.953
                                                ],
                                                [
                                                    -170.353,
                                                    -19.547
                                                ],
                                                [
                                                    -168.635,
                                                    -19.547
                                                ],
                                                [
                                                    -168.595,
                                                    -19.352
                                                ],
                                                [
                                                    -168.587,
                                                    -19.156
                                                ],
                                                [
                                                    -169.037,
                                                    -17.25
                                                ],
                                                [
                                                    -170.353,
                                                    -16.281
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "s",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.049,
                                                    -1.13
                                                ],
                                                [
                                                    -2.521,
                                                    0
                                                ],
                                                [
                                                    -1.144,
                                                    1.083
                                                ],
                                                [
                                                    0,
                                                    1.49
                                                ],
                                                [
                                                    1.094,
                                                    0.718
                                                ],
                                                [
                                                    2.059,
                                                    0.489
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.424,
                                                    0.259
                                                ],
                                                [
                                                    0,
                                                    0.726
                                                ],
                                                [
                                                    -0.56,
                                                    0.405
                                                ],
                                                [
                                                    -1.087,
                                                    0
                                                ],
                                                [
                                                    -0.661,
                                                    -0.735
                                                ],
                                                [
                                                    -0.054,
                                                    -0.632
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.708,
                                                    0.937
                                                ],
                                                [
                                                    2.555,
                                                    0
                                                ],
                                                [
                                                    1.156,
                                                    -0.979
                                                ],
                                                [
                                                    0,
                                                    -1.584
                                                ],
                                                [
                                                    -1.228,
                                                    -0.76
                                                ],
                                                [
                                                    -1.451,
                                                    -0.354
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.413,
                                                    -0.229
                                                ],
                                                [
                                                    0,
                                                    -0.718
                                                ],
                                                [
                                                    0.808,
                                                    -0.453
                                                ],
                                                [
                                                    1.063,
                                                    0
                                                ],
                                                [
                                                    0.723,
                                                    0.907
                                                ],
                                                [
                                                    0.085,
                                                    0.938
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.074,
                                                    1.667
                                                ],
                                                [
                                                    1.049,
                                                    1.13
                                                ],
                                                [
                                                    2.341,
                                                    0
                                                ],
                                                [
                                                    1.144,
                                                    -1.084
                                                ],
                                                [
                                                    0,
                                                    -1.541
                                                ],
                                                [
                                                    -0.701,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.827,
                                                    -0.198
                                                ],
                                                [
                                                    -0.736,
                                                    -0.436
                                                ],
                                                [
                                                    0,
                                                    -0.664
                                                ],
                                                [
                                                    0.56,
                                                    -0.405
                                                ],
                                                [
                                                    1.632,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    0.518
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.021,
                                                    -1.083
                                                ],
                                                [
                                                    -1.129,
                                                    -1.479
                                                ],
                                                [
                                                    -1.953,
                                                    0
                                                ],
                                                [
                                                    -1.156,
                                                    0.979
                                                ],
                                                [
                                                    0,
                                                    1.343
                                                ],
                                                [
                                                    0.688,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.218,
                                                    0.302
                                                ],
                                                [
                                                    0.645,
                                                    0.375
                                                ],
                                                [
                                                    0,
                                                    0.948
                                                ],
                                                [
                                                    -0.808,
                                                    0.453
                                                ],
                                                [
                                                    -1.786,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    -0.5
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -163.045,
                                                    -5.25
                                                ],
                                                [
                                                    -161.36,
                                                    -1.055
                                                ],
                                                [
                                                    -156.005,
                                                    0.641
                                                ],
                                                [
                                                    -150.777,
                                                    -0.984
                                                ],
                                                [
                                                    -149.06,
                                                    -4.844
                                                ],
                                                [
                                                    -150.701,
                                                    -8.234
                                                ],
                                                [
                                                    -154.84,
                                                    -9.656
                                                ],
                                                [
                                                    -156.735,
                                                    -10.109
                                                ],
                                                [
                                                    -158.613,
                                                    -10.795
                                                ],
                                                [
                                                    -159.717,
                                                    -12.539
                                                ],
                                                [
                                                    -158.877,
                                                    -14.143
                                                ],
                                                [
                                                    -156.406,
                                                    -14.75
                                                ],
                                                [
                                                    -152.967,
                                                    -13.647
                                                ],
                                                [
                                                    -152.279,
                                                    -11.922
                                                ],
                                                [
                                                    -149.623,
                                                    -11.922
                                                ],
                                                [
                                                    -150.653,
                                                    -14.953
                                                ],
                                                [
                                                    -156.179,
                                                    -17.172
                                                ],
                                                [
                                                    -160.842,
                                                    -15.703
                                                ],
                                                [
                                                    -162.576,
                                                    -11.859
                                                ],
                                                [
                                                    -160.734,
                                                    -8.703
                                                ],
                                                [
                                                    -157.526,
                                                    -7.516
                                                ],
                                                [
                                                    -155.256,
                                                    -6.953
                                                ],
                                                [
                                                    -152.81,
                                                    -6.156
                                                ],
                                                [
                                                    -151.842,
                                                    -4.516
                                                ],
                                                [
                                                    -153.054,
                                                    -2.414
                                                ],
                                                [
                                                    -155.86,
                                                    -1.734
                                                ],
                                                [
                                                    -159.624,
                                                    -3.094
                                                ],
                                                [
                                                    -160.342,
                                                    -5.25
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "m",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.87,
                                                    0.823
                                                ],
                                                [
                                                    -1.063,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.781
                                                ],
                                                [
                                                    0,
                                                    -1.135
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.797,
                                                    0.739
                                                ],
                                                [
                                                    -1.104,
                                                    0
                                                ],
                                                [
                                                    -0.557,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    -1.115
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    0.875
                                                ],
                                                [
                                                    2.25,
                                                    0
                                                ],
                                                [
                                                    0.844,
                                                    -0.432
                                                ],
                                                [
                                                    0.625,
                                                    -0.896
                                                ],
                                                [
                                                    0.458,
                                                    0.375
                                                ],
                                                [
                                                    1.333,
                                                    0
                                                ],
                                                [
                                                    0.927,
                                                    -0.636
                                                ],
                                                [
                                                    0.667,
                                                    -0.823
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.156
                                                ],
                                                [
                                                    0.87,
                                                    -0.823
                                                ],
                                                [
                                                    1.166,
                                                    0
                                                ],
                                                [
                                                    0.271,
                                                    0.521
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.729
                                                ],
                                                [
                                                    0.797,
                                                    -0.74
                                                ],
                                                [
                                                    0.802,
                                                    0
                                                ],
                                                [
                                                    0.557,
                                                    0.417
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.479
                                                ],
                                                [
                                                    -0.813,
                                                    -1.625
                                                ],
                                                [
                                                    -1.052,
                                                    0
                                                ],
                                                [
                                                    -0.844,
                                                    0.432
                                                ],
                                                [
                                                    -0.375,
                                                    -0.729
                                                ],
                                                [
                                                    -0.813,
                                                    -0.656
                                                ],
                                                [
                                                    -1.177,
                                                    0
                                                ],
                                                [
                                                    -0.542,
                                                    0.375
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -133.475,
                                                    0
                                                ],
                                                [
                                                    -130.662,
                                                    0
                                                ],
                                                [
                                                    -130.662,
                                                    -8.875
                                                ],
                                                [
                                                    -129.358,
                                                    -13.344
                                                ],
                                                [
                                                    -126.459,
                                                    -14.578
                                                ],
                                                [
                                                    -124.069,
                                                    -13.406
                                                ],
                                                [
                                                    -123.662,
                                                    -10.922
                                                ],
                                                [
                                                    -123.662,
                                                    0
                                                ],
                                                [
                                                    -120.803,
                                                    0
                                                ],
                                                [
                                                    -120.803,
                                                    -9.734
                                                ],
                                                [
                                                    -119.608,
                                                    -13.437
                                                ],
                                                [
                                                    -116.756,
                                                    -14.547
                                                ],
                                                [
                                                    -114.717,
                                                    -13.922
                                                ],
                                                [
                                                    -113.881,
                                                    -11.625
                                                ],
                                                [
                                                    -113.881,
                                                    0
                                                ],
                                                [
                                                    -110.959,
                                                    0
                                                ],
                                                [
                                                    -110.959,
                                                    -11.141
                                                ],
                                                [
                                                    -111.615,
                                                    -14.672
                                                ],
                                                [
                                                    -116.209,
                                                    -17.109
                                                ],
                                                [
                                                    -119.053,
                                                    -16.461
                                                ],
                                                [
                                                    -121.256,
                                                    -14.469
                                                ],
                                                [
                                                    -122.506,
                                                    -16.125
                                                ],
                                                [
                                                    -125.725,
                                                    -17.109
                                                ],
                                                [
                                                    -128.881,
                                                    -16.156
                                                ],
                                                [
                                                    -130.694,
                                                    -14.359
                                                ],
                                                [
                                                    -130.694,
                                                    -16.734
                                                ],
                                                [
                                                    -133.475,
                                                    -16.734
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "y",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.322,
                                                    -0.77
                                                ],
                                                [
                                                    0.052,
                                                    -0.083
                                                ],
                                                [
                                                    0.245,
                                                    -0.172
                                                ],
                                                [
                                                    0.52,
                                                    0
                                                ],
                                                [
                                                    0.218,
                                                    0.031
                                                ],
                                                [
                                                    0.489,
                                                    0.135
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.214,
                                                    -0.032
                                                ],
                                                [
                                                    -0.396,
                                                    0
                                                ],
                                                [
                                                    -0.666,
                                                    0.937
                                                ],
                                                [
                                                    -1.624,
                                                    4.268
                                                ],
                                                [
                                                    -1.021,
                                                    2.876
                                                ],
                                                [
                                                    -0.396,
                                                    1.073
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.145,
                                                    0.374
                                                ],
                                                [
                                                    -0.322,
                                                    0.769
                                                ],
                                                [
                                                    -0.167,
                                                    0.25
                                                ],
                                                [
                                                    -0.244,
                                                    0.171
                                                ],
                                                [
                                                    -0.166,
                                                    0
                                                ],
                                                [
                                                    -0.218,
                                                    -0.031
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.312,
                                                    0.083
                                                ],
                                                [
                                                    0.213,
                                                    0.031
                                                ],
                                                [
                                                    1.624,
                                                    0
                                                ],
                                                [
                                                    0.666,
                                                    -0.937
                                                ],
                                                [
                                                    0.687,
                                                    -1.813
                                                ],
                                                [
                                                    1.365,
                                                    -3.825
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -99.049,
                                                    -3.103
                                                ],
                                                [
                                                    -103.534,
                                                    -16.734
                                                ],
                                                [
                                                    -106.721,
                                                    -16.734
                                                ],
                                                [
                                                    -100.534,
                                                    0.492
                                                ],
                                                [
                                                    -101.236,
                                                    2.208
                                                ],
                                                [
                                                    -101.797,
                                                    3.486
                                                ],
                                                [
                                                    -102.414,
                                                    4.118
                                                ],
                                                [
                                                    -103.56,
                                                    4.375
                                                ],
                                                [
                                                    -104.137,
                                                    4.328
                                                ],
                                                [
                                                    -105.198,
                                                    4.078
                                                ],
                                                [
                                                    -105.198,
                                                    6.641
                                                ],
                                                [
                                                    -104.409,
                                                    6.813
                                                ],
                                                [
                                                    -103.496,
                                                    6.859
                                                ],
                                                [
                                                    -100.062,
                                                    5.454
                                                ],
                                                [
                                                    -96.627,
                                                    -2.353
                                                ],
                                                [
                                                    -94.065,
                                                    -9.387
                                                ],
                                                [
                                                    -91.424,
                                                    -16.734
                                                ],
                                                [
                                                    -94.534,
                                                    -16.734
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "c",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.885,
                                                    0
                                                ],
                                                [
                                                    1.427,
                                                    -1.635
                                                ],
                                                [
                                                    0,
                                                    -2.938
                                                ],
                                                [
                                                    -1.303,
                                                    -1.599
                                                ],
                                                [
                                                    -2.188,
                                                    0
                                                ],
                                                [
                                                    -1.25,
                                                    1.026
                                                ],
                                                [
                                                    -0.313,
                                                    2.219
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.682,
                                                    -0.71
                                                ],
                                                [
                                                    1.166,
                                                    0
                                                ],
                                                [
                                                    0.708,
                                                    1.144
                                                ],
                                                [
                                                    0,
                                                    1.675
                                                ],
                                                [
                                                    -0.5,
                                                    1.134
                                                ],
                                                [
                                                    -1.792,
                                                    0
                                                ],
                                                [
                                                    -0.594,
                                                    -0.682
                                                ],
                                                [
                                                    -0.167,
                                                    -1.032
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.182,
                                                    0.917
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -2.208,
                                                    0
                                                ],
                                                [
                                                    -1.427,
                                                    1.636
                                                ],
                                                [
                                                    0,
                                                    2.396
                                                ],
                                                [
                                                    1.302,
                                                    1.599
                                                ],
                                                [
                                                    1.948,
                                                    0
                                                ],
                                                [
                                                    1.25,
                                                    -1.026
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.26,
                                                    1.235
                                                ],
                                                [
                                                    -0.682,
                                                    0.711
                                                ],
                                                [
                                                    -1.521,
                                                    0
                                                ],
                                                [
                                                    -0.709,
                                                    -1.145
                                                ],
                                                [
                                                    0,
                                                    -1.665
                                                ],
                                                [
                                                    0.771,
                                                    -1.748
                                                ],
                                                [
                                                    1.313,
                                                    0
                                                ],
                                                [
                                                    0.593,
                                                    0.683
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.24,
                                                    -2.24
                                                ],
                                                [
                                                    -1.183,
                                                    -0.916
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -70.003,
                                                    -17.219
                                                ],
                                                [
                                                    -75.456,
                                                    -14.766
                                                ],
                                                [
                                                    -77.597,
                                                    -7.906
                                                ],
                                                [
                                                    -75.643,
                                                    -1.914
                                                ],
                                                [
                                                    -70.409,
                                                    0.484
                                                ],
                                                [
                                                    -65.612,
                                                    -1.055
                                                ],
                                                [
                                                    -63.268,
                                                    -5.922
                                                ],
                                                [
                                                    -66.003,
                                                    -5.922
                                                ],
                                                [
                                                    -67.417,
                                                    -3.004
                                                ],
                                                [
                                                    -70.19,
                                                    -1.937
                                                ],
                                                [
                                                    -73.534,
                                                    -3.654
                                                ],
                                                [
                                                    -74.597,
                                                    -7.883
                                                ],
                                                [
                                                    -73.847,
                                                    -12.081
                                                ],
                                                [
                                                    -70.003,
                                                    -14.703
                                                ],
                                                [
                                                    -67.143,
                                                    -13.68
                                                ],
                                                [
                                                    -66.003,
                                                    -11.109
                                                ],
                                                [
                                                    -63.268,
                                                    -11.109
                                                ],
                                                [
                                                    -65.401,
                                                    -15.844
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "u",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.459,
                                                    -0.855
                                                ],
                                                [
                                                    -2.341,
                                                    0
                                                ],
                                                [
                                                    -1.053,
                                                    0.875
                                                ],
                                                [
                                                    -0.358,
                                                    0.636
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.375,
                                                    -0.938
                                                ],
                                                [
                                                    1.907,
                                                    0
                                                ],
                                                [
                                                    0.487,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0.854
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.427
                                                ],
                                                [
                                                    0.849,
                                                    1.593
                                                ],
                                                [
                                                    1.502,
                                                    0
                                                ],
                                                [
                                                    0.531,
                                                    -0.438
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.636
                                                ],
                                                [
                                                    -0.69,
                                                    1.75
                                                ],
                                                [
                                                    -1.329,
                                                    0
                                                ],
                                                [
                                                    -0.264,
                                                    -0.542
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -58.694,
                                                    -16.734
                                                ],
                                                [
                                                    -58.694,
                                                    -5.359
                                                ],
                                                [
                                                    -58.005,
                                                    -1.937
                                                ],
                                                [
                                                    -53.221,
                                                    0.453
                                                ],
                                                [
                                                    -49.388,
                                                    -0.859
                                                ],
                                                [
                                                    -48.054,
                                                    -2.469
                                                ],
                                                [
                                                    -48.085,
                                                    0
                                                ],
                                                [
                                                    -45.429,
                                                    0
                                                ],
                                                [
                                                    -45.429,
                                                    -16.734
                                                ],
                                                [
                                                    -48.241,
                                                    -16.734
                                                ],
                                                [
                                                    -48.241,
                                                    -8.516
                                                ],
                                                [
                                                    -48.804,
                                                    -4.656
                                                ],
                                                [
                                                    -52.7,
                                                    -2.031
                                                ],
                                                [
                                                    -55.424,
                                                    -3.531
                                                ],
                                                [
                                                    -55.819,
                                                    -5.625
                                                ],
                                                [
                                                    -55.819,
                                                    -16.734
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "r",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.76,
                                                    0.911
                                                ],
                                                [
                                                    -1.417,
                                                    0
                                                ],
                                                [
                                                    -0.141,
                                                    -0.01
                                                ],
                                                [
                                                    -0.167,
                                                    -0.032
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.125,
                                                    0.011
                                                ],
                                                [
                                                    0.052,
                                                    0
                                                ],
                                                [
                                                    0.854,
                                                    -0.808
                                                ],
                                                [
                                                    0.219,
                                                    -0.562
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.187
                                                ],
                                                [
                                                    0.76,
                                                    -0.912
                                                ],
                                                [
                                                    0.166,
                                                    0
                                                ],
                                                [
                                                    0.14,
                                                    0.01
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    -0.303,
                                                    -0.032
                                                ],
                                                [
                                                    -0.125,
                                                    -0.01
                                                ],
                                                [
                                                    -1.114,
                                                    0
                                                ],
                                                [
                                                    -0.854,
                                                    0.807
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -38.933,
                                                    0
                                                ],
                                                [
                                                    -36.12,
                                                    0
                                                ],
                                                [
                                                    -36.12,
                                                    -9.625
                                                ],
                                                [
                                                    -34.98,
                                                    -12.773
                                                ],
                                                [
                                                    -31.714,
                                                    -14.141
                                                ],
                                                [
                                                    -31.253,
                                                    -14.125
                                                ],
                                                [
                                                    -30.792,
                                                    -14.062
                                                ],
                                                [
                                                    -30.792,
                                                    -17.031
                                                ],
                                                [
                                                    -31.433,
                                                    -17.094
                                                ],
                                                [
                                                    -31.699,
                                                    -17.109
                                                ],
                                                [
                                                    -34.652,
                                                    -15.898
                                                ],
                                                [
                                                    -36.261,
                                                    -13.844
                                                ],
                                                [
                                                    -36.261,
                                                    -16.734
                                                ],
                                                [
                                                    -38.933,
                                                    -16.734
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "r",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.76,
                                                    0.911
                                                ],
                                                [
                                                    -1.417,
                                                    0
                                                ],
                                                [
                                                    -0.141,
                                                    -0.01
                                                ],
                                                [
                                                    -0.167,
                                                    -0.032
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.125,
                                                    0.011
                                                ],
                                                [
                                                    0.052,
                                                    0
                                                ],
                                                [
                                                    0.854,
                                                    -0.808
                                                ],
                                                [
                                                    0.219,
                                                    -0.562
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.187
                                                ],
                                                [
                                                    0.761,
                                                    -0.912
                                                ],
                                                [
                                                    0.167,
                                                    0
                                                ],
                                                [
                                                    0.141,
                                                    0.01
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    -0.302,
                                                    -0.032
                                                ],
                                                [
                                                    -0.125,
                                                    -0.01
                                                ],
                                                [
                                                    -1.115,
                                                    0
                                                ],
                                                [
                                                    -0.855,
                                                    0.807
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -26.453,
                                                    0
                                                ],
                                                [
                                                    -23.64,
                                                    0
                                                ],
                                                [
                                                    -23.64,
                                                    -9.625
                                                ],
                                                [
                                                    -22.5,
                                                    -12.773
                                                ],
                                                [
                                                    -19.234,
                                                    -14.141
                                                ],
                                                [
                                                    -18.773,
                                                    -14.125
                                                ],
                                                [
                                                    -18.312,
                                                    -14.062
                                                ],
                                                [
                                                    -18.312,
                                                    -17.031
                                                ],
                                                [
                                                    -18.953,
                                                    -17.094
                                                ],
                                                [
                                                    -19.218,
                                                    -17.109
                                                ],
                                                [
                                                    -22.171,
                                                    -15.898
                                                ],
                                                [
                                                    -23.781,
                                                    -13.844
                                                ],
                                                [
                                                    -23.781,
                                                    -16.734
                                                ],
                                                [
                                                    -26.453,
                                                    -16.734
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "e",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.18,
                                                    0
                                                ],
                                                [
                                                    1.45,
                                                    -1.677
                                                ],
                                                [
                                                    0,
                                                    -2.687
                                                ],
                                                [
                                                    -1.439,
                                                    -1.515
                                                ],
                                                [
                                                    -2.07,
                                                    0
                                                ],
                                                [
                                                    -0.672,
                                                    0.166
                                                ],
                                                [
                                                    -0.848,
                                                    0.834
                                                ],
                                                [
                                                    -0.412,
                                                    0.755
                                                ],
                                                [
                                                    -0.073,
                                                    0.615
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.486,
                                                    -0.565
                                                ],
                                                [
                                                    1.457,
                                                    0
                                                ],
                                                [
                                                    0.744,
                                                    1.028
                                                ],
                                                [
                                                    0.052,
                                                    1.703
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.166,
                                                    0.771
                                                ],
                                                [
                                                    0.559,
                                                    0.843
                                                ],
                                                [
                                                    1.108,
                                                    0.557
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -2.34,
                                                    0
                                                ],
                                                [
                                                    -1.449,
                                                    1.677
                                                ],
                                                [
                                                    0,
                                                    2.729
                                                ],
                                                [
                                                    1.438,
                                                    1.516
                                                ],
                                                [
                                                    0.848,
                                                    0
                                                ],
                                                [
                                                    1.251,
                                                    -0.292
                                                ],
                                                [
                                                    0.506,
                                                    -0.479
                                                ],
                                                [
                                                    0.411,
                                                    -0.755
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.203,
                                                    0.743
                                                ],
                                                [
                                                    -0.868,
                                                    0.973
                                                ],
                                                [
                                                    -1.561,
                                                    0
                                                ],
                                                [
                                                    -0.744,
                                                    -1.029
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.687
                                                ],
                                                [
                                                    -0.186,
                                                    -1.125
                                                ],
                                                [
                                                    -0.58,
                                                    -0.886
                                                ],
                                                [
                                                    -1.108,
                                                    -0.558
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -7.146,
                                                    -17.109
                                                ],
                                                [
                                                    -12.83,
                                                    -14.594
                                                ],
                                                [
                                                    -15.004,
                                                    -8.047
                                                ],
                                                [
                                                    -12.845,
                                                    -1.68
                                                ],
                                                [
                                                    -7.582,
                                                    0.594
                                                ],
                                                [
                                                    -5.302,
                                                    0.344
                                                ],
                                                [
                                                    -2.154,
                                                    -1.344
                                                ],
                                                [
                                                    -0.777,
                                                    -3.195
                                                ],
                                                [
                                                    -0.051,
                                                    -5.25
                                                ],
                                                [
                                                    -2.816,
                                                    -5.25
                                                ],
                                                [
                                                    -3.849,
                                                    -3.288
                                                ],
                                                [
                                                    -7.337,
                                                    -1.828
                                                ],
                                                [
                                                    -10.794,
                                                    -3.371
                                                ],
                                                [
                                                    -11.988,
                                                    -7.469
                                                ],
                                                [
                                                    0.184,
                                                    -7.469
                                                ],
                                                [
                                                    -0.065,
                                                    -11.156
                                                ],
                                                [
                                                    -1.183,
                                                    -14.109
                                                ],
                                                [
                                                    -3.714,
                                                    -16.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.867,
                                                    0.933
                                                ],
                                                [
                                                    -1.281,
                                                    0
                                                ],
                                                [
                                                    -0.764,
                                                    -1.354
                                                ],
                                                [
                                                    -0.114,
                                                    -1.219
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.052,
                                                    -1.438
                                                ],
                                                [
                                                    0.868,
                                                    -0.932
                                                ],
                                                [
                                                    1.787,
                                                    0
                                                ],
                                                [
                                                    0.413,
                                                    0.729
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -11.926,
                                                    -9.703
                                                ],
                                                [
                                                    -10.547,
                                                    -13.258
                                                ],
                                                [
                                                    -7.324,
                                                    -14.656
                                                ],
                                                [
                                                    -3.497,
                                                    -12.625
                                                ],
                                                [
                                                    -2.707,
                                                    -9.703
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.141,
                                                    0.589
                                                ],
                                                [
                                                    -0.469,
                                                    0.552
                                                ],
                                                [
                                                    -0.771,
                                                    0.229
                                                ],
                                                [
                                                    -0.667,
                                                    0
                                                ],
                                                [
                                                    -0.5,
                                                    -1.041
                                                ],
                                                [
                                                    0,
                                                    -1.021
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.459,
                                                    0.906
                                                ],
                                                [
                                                    2.375,
                                                    0
                                                ],
                                                [
                                                    0.885,
                                                    -0.427
                                                ],
                                                [
                                                    0.792,
                                                    -0.979
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.093
                                                ],
                                                [
                                                    0.14,
                                                    -0.588
                                                ],
                                                [
                                                    0.583,
                                                    -0.687
                                                ],
                                                [
                                                    0.427,
                                                    -0.135
                                                ],
                                                [
                                                    1.312,
                                                    0
                                                ],
                                                [
                                                    0.302,
                                                    0.625
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.688
                                                ],
                                                [
                                                    -0.833,
                                                    -1.656
                                                ],
                                                [
                                                    -1.084,
                                                    0
                                                ],
                                                [
                                                    -0.886,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.57,
                                                    0
                                                ],
                                                [
                                                    8.383,
                                                    0
                                                ],
                                                [
                                                    8.383,
                                                    -8.766
                                                ],
                                                [
                                                    8.594,
                                                    -11.289
                                                ],
                                                [
                                                    9.508,
                                                    -13
                                                ],
                                                [
                                                    11.539,
                                                    -14.375
                                                ],
                                                [
                                                    13.18,
                                                    -14.578
                                                ],
                                                [
                                                    15.898,
                                                    -13.016
                                                ],
                                                [
                                                    16.352,
                                                    -10.547
                                                ],
                                                [
                                                    16.352,
                                                    0
                                                ],
                                                [
                                                    19.211,
                                                    0
                                                ],
                                                [
                                                    19.211,
                                                    -10.734
                                                ],
                                                [
                                                    18.523,
                                                    -14.625
                                                ],
                                                [
                                                    13.711,
                                                    -17.109
                                                ],
                                                [
                                                    10.758,
                                                    -16.469
                                                ],
                                                [
                                                    8.242,
                                                    -14.359
                                                ],
                                                [
                                                    8.242,
                                                    -16.734
                                                ],
                                                [
                                                    5.57,
                                                    -16.734
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.469,
                                                    -0.672
                                                ],
                                                [
                                                    -1.313,
                                                    0
                                                ],
                                                [
                                                    -0.349,
                                                    0.042
                                                ],
                                                [
                                                    -0.323,
                                                    0.094
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.157,
                                                    -0.007
                                                ],
                                                [
                                                    0.135,
                                                    0
                                                ],
                                                [
                                                    0.219,
                                                    0.115
                                                ],
                                                [
                                                    0,
                                                    0.584
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    1.073
                                                ],
                                                [
                                                    0.469,
                                                    0.672
                                                ],
                                                [
                                                    0.406,
                                                    0
                                                ],
                                                [
                                                    0.349,
                                                    -0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.208,
                                                    0.027
                                                ],
                                                [
                                                    -0.156,
                                                    0.007
                                                ],
                                                [
                                                    -0.511,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    -0.198
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.754,
                                                    -16.734
                                                ],
                                                [
                                                    23.488,
                                                    -16.734
                                                ],
                                                [
                                                    23.488,
                                                    -14.437
                                                ],
                                                [
                                                    25.754,
                                                    -14.437
                                                ],
                                                [
                                                    25.754,
                                                    -3.359
                                                ],
                                                [
                                                    26.457,
                                                    -0.742
                                                ],
                                                [
                                                    29.129,
                                                    0.266
                                                ],
                                                [
                                                    30.261,
                                                    0.203
                                                ],
                                                [
                                                    31.269,
                                                    0
                                                ],
                                                [
                                                    31.269,
                                                    -2.234
                                                ],
                                                [
                                                    30.722,
                                                    -2.182
                                                ],
                                                [
                                                    30.285,
                                                    -2.172
                                                ],
                                                [
                                                    29.191,
                                                    -2.344
                                                ],
                                                [
                                                    28.597,
                                                    -3.516
                                                ],
                                                [
                                                    28.597,
                                                    -14.437
                                                ],
                                                [
                                                    31.269,
                                                    -14.437
                                                ],
                                                [
                                                    31.269,
                                                    -16.734
                                                ],
                                                [
                                                    28.597,
                                                    -16.734
                                                ],
                                                [
                                                    28.597,
                                                    -21.406
                                                ],
                                                [
                                                    25.754,
                                                    -21.406
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "s",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.049,
                                                    -1.13
                                                ],
                                                [
                                                    -2.521,
                                                    0
                                                ],
                                                [
                                                    -1.144,
                                                    1.083
                                                ],
                                                [
                                                    0,
                                                    1.49
                                                ],
                                                [
                                                    1.094,
                                                    0.718
                                                ],
                                                [
                                                    2.059,
                                                    0.489
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.424,
                                                    0.259
                                                ],
                                                [
                                                    0,
                                                    0.726
                                                ],
                                                [
                                                    -0.56,
                                                    0.405
                                                ],
                                                [
                                                    -1.088,
                                                    0
                                                ],
                                                [
                                                    -0.661,
                                                    -0.735
                                                ],
                                                [
                                                    -0.054,
                                                    -0.632
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.708,
                                                    0.937
                                                ],
                                                [
                                                    2.555,
                                                    0
                                                ],
                                                [
                                                    1.156,
                                                    -0.979
                                                ],
                                                [
                                                    0,
                                                    -1.584
                                                ],
                                                [
                                                    -1.228,
                                                    -0.76
                                                ],
                                                [
                                                    -1.45,
                                                    -0.354
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.414,
                                                    -0.229
                                                ],
                                                [
                                                    0,
                                                    -0.718
                                                ],
                                                [
                                                    0.808,
                                                    -0.453
                                                ],
                                                [
                                                    1.063,
                                                    0
                                                ],
                                                [
                                                    0.723,
                                                    0.907
                                                ],
                                                [
                                                    0.085,
                                                    0.938
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.074,
                                                    1.667
                                                ],
                                                [
                                                    1.049,
                                                    1.13
                                                ],
                                                [
                                                    2.341,
                                                    0
                                                ],
                                                [
                                                    1.144,
                                                    -1.084
                                                ],
                                                [
                                                    0,
                                                    -1.541
                                                ],
                                                [
                                                    -0.701,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.828,
                                                    -0.198
                                                ],
                                                [
                                                    -0.736,
                                                    -0.436
                                                ],
                                                [
                                                    0,
                                                    -0.664
                                                ],
                                                [
                                                    0.56,
                                                    -0.405
                                                ],
                                                [
                                                    1.631,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    0.518
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.021,
                                                    -1.083
                                                ],
                                                [
                                                    -1.129,
                                                    -1.479
                                                ],
                                                [
                                                    -1.953,
                                                    0
                                                ],
                                                [
                                                    -1.156,
                                                    0.979
                                                ],
                                                [
                                                    0,
                                                    1.343
                                                ],
                                                [
                                                    0.688,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.218,
                                                    0.302
                                                ],
                                                [
                                                    0.645,
                                                    0.375
                                                ],
                                                [
                                                    0,
                                                    0.948
                                                ],
                                                [
                                                    -0.808,
                                                    0.453
                                                ],
                                                [
                                                    -1.787,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    -0.5
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    45.589,
                                                    -5.25
                                                ],
                                                [
                                                    47.274,
                                                    -1.055
                                                ],
                                                [
                                                    52.629,
                                                    0.641
                                                ],
                                                [
                                                    57.857,
                                                    -0.984
                                                ],
                                                [
                                                    59.574,
                                                    -4.844
                                                ],
                                                [
                                                    57.933,
                                                    -8.234
                                                ],
                                                [
                                                    53.794,
                                                    -9.656
                                                ],
                                                [
                                                    51.899,
                                                    -10.109
                                                ],
                                                [
                                                    50.021,
                                                    -10.795
                                                ],
                                                [
                                                    48.917,
                                                    -12.539
                                                ],
                                                [
                                                    49.757,
                                                    -14.143
                                                ],
                                                [
                                                    52.228,
                                                    -14.75
                                                ],
                                                [
                                                    55.667,
                                                    -13.647
                                                ],
                                                [
                                                    56.355,
                                                    -11.922
                                                ],
                                                [
                                                    59.011,
                                                    -11.922
                                                ],
                                                [
                                                    57.981,
                                                    -14.953
                                                ],
                                                [
                                                    52.455,
                                                    -17.172
                                                ],
                                                [
                                                    47.792,
                                                    -15.703
                                                ],
                                                [
                                                    46.058,
                                                    -11.859
                                                ],
                                                [
                                                    47.9,
                                                    -8.703
                                                ],
                                                [
                                                    51.107,
                                                    -7.516
                                                ],
                                                [
                                                    53.378,
                                                    -6.953
                                                ],
                                                [
                                                    55.824,
                                                    -6.156
                                                ],
                                                [
                                                    56.792,
                                                    -4.516
                                                ],
                                                [
                                                    55.58,
                                                    -2.414
                                                ],
                                                [
                                                    52.774,
                                                    -1.734
                                                ],
                                                [
                                                    49.01,
                                                    -3.094
                                                ],
                                                [
                                                    48.292,
                                                    -5.25
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "u",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.46,
                                                    -0.855
                                                ],
                                                [
                                                    -2.34,
                                                    0
                                                ],
                                                [
                                                    -1.053,
                                                    0.875
                                                ],
                                                [
                                                    -0.359,
                                                    0.636
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.375,
                                                    -0.938
                                                ],
                                                [
                                                    1.907,
                                                    0
                                                ],
                                                [
                                                    0.487,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0.854
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.427
                                                ],
                                                [
                                                    0.848,
                                                    1.593
                                                ],
                                                [
                                                    1.503,
                                                    0
                                                ],
                                                [
                                                    0.532,
                                                    -0.438
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.636
                                                ],
                                                [
                                                    -0.69,
                                                    1.75
                                                ],
                                                [
                                                    -1.33,
                                                    0
                                                ],
                                                [
                                                    -0.264,
                                                    -0.542
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    64.382,
                                                    -16.734
                                                ],
                                                [
                                                    64.382,
                                                    -5.359
                                                ],
                                                [
                                                    65.072,
                                                    -1.937
                                                ],
                                                [
                                                    69.855,
                                                    0.453
                                                ],
                                                [
                                                    73.688,
                                                    -0.859
                                                ],
                                                [
                                                    75.023,
                                                    -2.469
                                                ],
                                                [
                                                    74.991,
                                                    0
                                                ],
                                                [
                                                    77.648,
                                                    0
                                                ],
                                                [
                                                    77.648,
                                                    -16.734
                                                ],
                                                [
                                                    74.835,
                                                    -16.734
                                                ],
                                                [
                                                    74.835,
                                                    -8.516
                                                ],
                                                [
                                                    74.272,
                                                    -4.656
                                                ],
                                                [
                                                    70.377,
                                                    -2.031
                                                ],
                                                [
                                                    67.653,
                                                    -3.531
                                                ],
                                                [
                                                    67.257,
                                                    -5.625
                                                ],
                                                [
                                                    67.257,
                                                    -16.734
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "b",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.523,
                                                    -0.364
                                                ],
                                                [
                                                    -1.276,
                                                    0
                                                ],
                                                [
                                                    -1.286,
                                                    1.75
                                                ],
                                                [
                                                    0,
                                                    2.645
                                                ],
                                                [
                                                    1.302,
                                                    1.432
                                                ],
                                                [
                                                    2.092,
                                                    0
                                                ],
                                                [
                                                    0.857,
                                                    -0.422
                                                ],
                                                [
                                                    0.617,
                                                    -0.802
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.596,
                                                    0.803
                                                ],
                                                [
                                                    0.878,
                                                    0.615
                                                ],
                                                [
                                                    2.28,
                                                    0
                                                ],
                                                [
                                                    1.286,
                                                    -1.75
                                                ],
                                                [
                                                    0,
                                                    -2.792
                                                ],
                                                [
                                                    -1.302,
                                                    -1.433
                                                ],
                                                [
                                                    -1.004,
                                                    0
                                                ],
                                                [
                                                    -0.857,
                                                    0.422
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    83.831,
                                                    0
                                                ],
                                                [
                                                    86.425,
                                                    0
                                                ],
                                                [
                                                    86.425,
                                                    -2.141
                                                ],
                                                [
                                                    88.103,
                                                    -0.391
                                                ],
                                                [
                                                    91.334,
                                                    0.531
                                                ],
                                                [
                                                    96.683,
                                                    -2.094
                                                ],
                                                [
                                                    98.612,
                                                    -8.687
                                                ],
                                                [
                                                    96.659,
                                                    -15.023
                                                ],
                                                [
                                                    91.569,
                                                    -17.172
                                                ],
                                                [
                                                    88.777,
                                                    -16.539
                                                ],
                                                [
                                                    86.565,
                                                    -14.703
                                                ],
                                                [
                                                    86.565,
                                                    -23.031
                                                ],
                                                [
                                                    83.831,
                                                    -23.031
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.526,
                                                    0
                                                ],
                                                [
                                                    0.742,
                                                    1.844
                                                ],
                                                [
                                                    0,
                                                    1.573
                                                ],
                                                [
                                                    -0.967,
                                                    0.948
                                                ],
                                                [
                                                    -1.286,
                                                    0
                                                ],
                                                [
                                                    -0.758,
                                                    -1.156
                                                ],
                                                [
                                                    0,
                                                    -1.76
                                                ],
                                                [
                                                    0.758,
                                                    -1.208
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -2.028,
                                                    0
                                                ],
                                                [
                                                    -0.397,
                                                    -0.979
                                                ],
                                                [
                                                    0,
                                                    -2.177
                                                ],
                                                [
                                                    0.967,
                                                    -0.948
                                                ],
                                                [
                                                    1.473,
                                                    0
                                                ],
                                                [
                                                    0.758,
                                                    1.156
                                                ],
                                                [
                                                    0,
                                                    1.979
                                                ],
                                                [
                                                    -0.758,
                                                    1.209
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    91.159,
                                                    -1.953
                                                ],
                                                [
                                                    87.005,
                                                    -4.719
                                                ],
                                                [
                                                    86.409,
                                                    -8.547
                                                ],
                                                [
                                                    87.859,
                                                    -13.234
                                                ],
                                                [
                                                    91.238,
                                                    -14.656
                                                ],
                                                [
                                                    94.585,
                                                    -12.922
                                                ],
                                                [
                                                    95.722,
                                                    -8.547
                                                ],
                                                [
                                                    94.585,
                                                    -3.766
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "s",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.05,
                                                    -1.13
                                                ],
                                                [
                                                    -2.521,
                                                    0
                                                ],
                                                [
                                                    -1.145,
                                                    1.083
                                                ],
                                                [
                                                    0,
                                                    1.49
                                                ],
                                                [
                                                    1.093,
                                                    0.718
                                                ],
                                                [
                                                    2.058,
                                                    0.489
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.424,
                                                    0.259
                                                ],
                                                [
                                                    0,
                                                    0.726
                                                ],
                                                [
                                                    -0.56,
                                                    0.405
                                                ],
                                                [
                                                    -1.088,
                                                    0
                                                ],
                                                [
                                                    -0.661,
                                                    -0.735
                                                ],
                                                [
                                                    -0.054,
                                                    -0.632
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.707,
                                                    0.937
                                                ],
                                                [
                                                    2.555,
                                                    0
                                                ],
                                                [
                                                    1.155,
                                                    -0.979
                                                ],
                                                [
                                                    0,
                                                    -1.584
                                                ],
                                                [
                                                    -1.228,
                                                    -0.76
                                                ],
                                                [
                                                    -1.45,
                                                    -0.354
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.413,
                                                    -0.229
                                                ],
                                                [
                                                    0,
                                                    -0.718
                                                ],
                                                [
                                                    0.808,
                                                    -0.453
                                                ],
                                                [
                                                    1.063,
                                                    0
                                                ],
                                                [
                                                    0.723,
                                                    0.907
                                                ],
                                                [
                                                    0.085,
                                                    0.938
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.074,
                                                    1.667
                                                ],
                                                [
                                                    1.049,
                                                    1.13
                                                ],
                                                [
                                                    2.341,
                                                    0
                                                ],
                                                [
                                                    1.144,
                                                    -1.084
                                                ],
                                                [
                                                    0,
                                                    -1.541
                                                ],
                                                [
                                                    -0.701,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.828,
                                                    -0.198
                                                ],
                                                [
                                                    -0.736,
                                                    -0.436
                                                ],
                                                [
                                                    0,
                                                    -0.664
                                                ],
                                                [
                                                    0.559,
                                                    -0.405
                                                ],
                                                [
                                                    1.631,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    0.518
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.021,
                                                    -1.083
                                                ],
                                                [
                                                    -1.129,
                                                    -1.479
                                                ],
                                                [
                                                    -1.953,
                                                    0
                                                ],
                                                [
                                                    -1.156,
                                                    0.979
                                                ],
                                                [
                                                    0,
                                                    1.343
                                                ],
                                                [
                                                    0.688,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.217,
                                                    0.302
                                                ],
                                                [
                                                    0.646,
                                                    0.375
                                                ],
                                                [
                                                    0,
                                                    0.948
                                                ],
                                                [
                                                    -0.808,
                                                    0.453
                                                ],
                                                [
                                                    -1.786,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    -0.5
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    102.655,
                                                    -5.25
                                                ],
                                                [
                                                    104.34,
                                                    -1.055
                                                ],
                                                [
                                                    109.695,
                                                    0.641
                                                ],
                                                [
                                                    114.923,
                                                    -0.984
                                                ],
                                                [
                                                    116.639,
                                                    -4.844
                                                ],
                                                [
                                                    114.999,
                                                    -8.234
                                                ],
                                                [
                                                    110.86,
                                                    -9.656
                                                ],
                                                [
                                                    108.965,
                                                    -10.109
                                                ],
                                                [
                                                    107.087,
                                                    -10.795
                                                ],
                                                [
                                                    105.983,
                                                    -12.539
                                                ],
                                                [
                                                    106.823,
                                                    -14.143
                                                ],
                                                [
                                                    109.294,
                                                    -14.75
                                                ],
                                                [
                                                    112.733,
                                                    -13.647
                                                ],
                                                [
                                                    113.421,
                                                    -11.922
                                                ],
                                                [
                                                    116.077,
                                                    -11.922
                                                ],
                                                [
                                                    115.047,
                                                    -14.953
                                                ],
                                                [
                                                    109.521,
                                                    -17.172
                                                ],
                                                [
                                                    104.858,
                                                    -15.703
                                                ],
                                                [
                                                    103.124,
                                                    -11.859
                                                ],
                                                [
                                                    104.966,
                                                    -8.703
                                                ],
                                                [
                                                    108.173,
                                                    -7.516
                                                ],
                                                [
                                                    110.444,
                                                    -6.953
                                                ],
                                                [
                                                    112.889,
                                                    -6.156
                                                ],
                                                [
                                                    113.858,
                                                    -4.516
                                                ],
                                                [
                                                    112.646,
                                                    -2.414
                                                ],
                                                [
                                                    109.839,
                                                    -1.734
                                                ],
                                                [
                                                    106.076,
                                                    -3.094
                                                ],
                                                [
                                                    105.358,
                                                    -5.25
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "c",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.886,
                                                    0
                                                ],
                                                [
                                                    1.427,
                                                    -1.635
                                                ],
                                                [
                                                    0,
                                                    -2.938
                                                ],
                                                [
                                                    -1.303,
                                                    -1.599
                                                ],
                                                [
                                                    -2.187,
                                                    0
                                                ],
                                                [
                                                    -1.25,
                                                    1.026
                                                ],
                                                [
                                                    -0.313,
                                                    2.219
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.682,
                                                    -0.71
                                                ],
                                                [
                                                    1.166,
                                                    0
                                                ],
                                                [
                                                    0.708,
                                                    1.144
                                                ],
                                                [
                                                    0,
                                                    1.675
                                                ],
                                                [
                                                    -0.5,
                                                    1.134
                                                ],
                                                [
                                                    -1.791,
                                                    0
                                                ],
                                                [
                                                    -0.594,
                                                    -0.682
                                                ],
                                                [
                                                    -0.166,
                                                    -1.032
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.182,
                                                    0.917
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -2.208,
                                                    0
                                                ],
                                                [
                                                    -1.427,
                                                    1.636
                                                ],
                                                [
                                                    0,
                                                    2.396
                                                ],
                                                [
                                                    1.302,
                                                    1.599
                                                ],
                                                [
                                                    1.948,
                                                    0
                                                ],
                                                [
                                                    1.25,
                                                    -1.026
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.26,
                                                    1.235
                                                ],
                                                [
                                                    -0.682,
                                                    0.711
                                                ],
                                                [
                                                    -1.521,
                                                    0
                                                ],
                                                [
                                                    -0.708,
                                                    -1.145
                                                ],
                                                [
                                                    0,
                                                    -1.665
                                                ],
                                                [
                                                    0.77,
                                                    -1.748
                                                ],
                                                [
                                                    1.313,
                                                    0
                                                ],
                                                [
                                                    0.593,
                                                    0.683
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.24,
                                                    -2.24
                                                ],
                                                [
                                                    -1.183,
                                                    -0.916
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    127.963,
                                                    -17.219
                                                ],
                                                [
                                                    122.51,
                                                    -14.766
                                                ],
                                                [
                                                    120.37,
                                                    -7.906
                                                ],
                                                [
                                                    122.323,
                                                    -1.914
                                                ],
                                                [
                                                    127.557,
                                                    0.484
                                                ],
                                                [
                                                    132.354,
                                                    -1.055
                                                ],
                                                [
                                                    134.698,
                                                    -5.922
                                                ],
                                                [
                                                    131.963,
                                                    -5.922
                                                ],
                                                [
                                                    130.549,
                                                    -3.004
                                                ],
                                                [
                                                    127.776,
                                                    -1.937
                                                ],
                                                [
                                                    124.432,
                                                    -3.654
                                                ],
                                                [
                                                    123.37,
                                                    -7.883
                                                ],
                                                [
                                                    124.12,
                                                    -12.081
                                                ],
                                                [
                                                    127.963,
                                                    -14.703
                                                ],
                                                [
                                                    130.823,
                                                    -13.68
                                                ],
                                                [
                                                    131.963,
                                                    -11.109
                                                ],
                                                [
                                                    134.698,
                                                    -11.109
                                                ],
                                                [
                                                    132.565,
                                                    -15.844
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "r",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.76,
                                                    0.911
                                                ],
                                                [
                                                    -1.417,
                                                    0
                                                ],
                                                [
                                                    -0.141,
                                                    -0.01
                                                ],
                                                [
                                                    -0.167,
                                                    -0.032
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.125,
                                                    0.011
                                                ],
                                                [
                                                    0.052,
                                                    0
                                                ],
                                                [
                                                    0.854,
                                                    -0.808
                                                ],
                                                [
                                                    0.219,
                                                    -0.562
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.187
                                                ],
                                                [
                                                    0.761,
                                                    -0.912
                                                ],
                                                [
                                                    0.167,
                                                    0
                                                ],
                                                [
                                                    0.141,
                                                    0.01
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    -0.302,
                                                    -0.032
                                                ],
                                                [
                                                    -0.125,
                                                    -0.01
                                                ],
                                                [
                                                    -1.115,
                                                    0
                                                ],
                                                [
                                                    -0.855,
                                                    0.807
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    139.412,
                                                    0
                                                ],
                                                [
                                                    142.225,
                                                    0
                                                ],
                                                [
                                                    142.225,
                                                    -9.625
                                                ],
                                                [
                                                    143.365,
                                                    -12.773
                                                ],
                                                [
                                                    146.631,
                                                    -14.141
                                                ],
                                                [
                                                    147.092,
                                                    -14.125
                                                ],
                                                [
                                                    147.553,
                                                    -14.062
                                                ],
                                                [
                                                    147.553,
                                                    -17.031
                                                ],
                                                [
                                                    146.912,
                                                    -17.094
                                                ],
                                                [
                                                    146.647,
                                                    -17.109
                                                ],
                                                [
                                                    143.694,
                                                    -15.898
                                                ],
                                                [
                                                    142.084,
                                                    -13.844
                                                ],
                                                [
                                                    142.084,
                                                    -16.734
                                                ],
                                                [
                                                    139.412,
                                                    -16.734
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "i",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    151.814,
                                                    0
                                                ],
                                                [
                                                    154.674,
                                                    0
                                                ],
                                                [
                                                    154.674,
                                                    -16.656
                                                ],
                                                [
                                                    151.814,
                                                    -16.656
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    151.814,
                                                    -19.766
                                                ],
                                                [
                                                    154.674,
                                                    -19.766
                                                ],
                                                [
                                                    154.674,
                                                    -22.953
                                                ],
                                                [
                                                    151.814,
                                                    -22.953
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "p",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.317,
                                                    0
                                                ],
                                                [
                                                    0.731,
                                                    1.729
                                                ],
                                                [
                                                    0,
                                                    1.291
                                                ],
                                                [
                                                    -0.387,
                                                    1.042
                                                ],
                                                [
                                                    -1.954,
                                                    0
                                                ],
                                                [
                                                    -0.732,
                                                    -1.844
                                                ],
                                                [
                                                    0,
                                                    -1.333
                                                ],
                                                [
                                                    0.873,
                                                    -1.099
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.944,
                                                    0
                                                ],
                                                [
                                                    -0.387,
                                                    -0.907
                                                ],
                                                [
                                                    0,
                                                    -1.604
                                                ],
                                                [
                                                    0.721,
                                                    -1.948
                                                ],
                                                [
                                                    1.944,
                                                    0
                                                ],
                                                [
                                                    0.387,
                                                    0.958
                                                ],
                                                [
                                                    0,
                                                    2.188
                                                ],
                                                [
                                                    -0.873,
                                                    1.099
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    167.81,
                                                    -1.891
                                                ],
                                                [
                                                    163.797,
                                                    -4.484
                                                ],
                                                [
                                                    163.217,
                                                    -7.781
                                                ],
                                                [
                                                    163.797,
                                                    -11.75
                                                ],
                                                [
                                                    167.81,
                                                    -14.672
                                                ],
                                                [
                                                    171.824,
                                                    -11.906
                                                ],
                                                [
                                                    172.404,
                                                    -8.469
                                                ],
                                                [
                                                    171.095,
                                                    -3.539
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.502,
                                                    -0.312
                                                ],
                                                [
                                                    -1.266,
                                                    0
                                                ],
                                                [
                                                    -1.213,
                                                    0.99
                                                ],
                                                [
                                                    0,
                                                    3.646
                                                ],
                                                [
                                                    1.326,
                                                    1.453
                                                ],
                                                [
                                                    1.901,
                                                    0
                                                ],
                                                [
                                                    0.95,
                                                    -0.625
                                                ],
                                                [
                                                    0.564,
                                                    -0.761
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.617,
                                                    0.76
                                                ],
                                                [
                                                    0.858,
                                                    0.552
                                                ],
                                                [
                                                    1.61,
                                                    0
                                                ],
                                                [
                                                    1.914,
                                                    -1.562
                                                ],
                                                [
                                                    0,
                                                    -2.698
                                                ],
                                                [
                                                    -1.326,
                                                    -1.453
                                                ],
                                                [
                                                    -1.284,
                                                    0
                                                ],
                                                [
                                                    -0.668,
                                                    0.417
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    160.513,
                                                    6.672
                                                ],
                                                [
                                                    163.326,
                                                    6.672
                                                ],
                                                [
                                                    163.326,
                                                    -1.875
                                                ],
                                                [
                                                    165.004,
                                                    -0.266
                                                ],
                                                [
                                                    168.189,
                                                    0.563
                                                ],
                                                [
                                                    172.424,
                                                    -0.922
                                                ],
                                                [
                                                    175.295,
                                                    -8.734
                                                ],
                                                [
                                                    173.305,
                                                    -14.961
                                                ],
                                                [
                                                    168.464,
                                                    -17.141
                                                ],
                                                [
                                                    165.112,
                                                    -16.203
                                                ],
                                                [
                                                    163.263,
                                                    -14.437
                                                ],
                                                [
                                                    163.263,
                                                    -16.656
                                                ],
                                                [
                                                    160.513,
                                                    -16.656
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.468,
                                                    -0.672
                                                ],
                                                [
                                                    -1.312,
                                                    0
                                                ],
                                                [
                                                    -0.349,
                                                    0.042
                                                ],
                                                [
                                                    -0.323,
                                                    0.094
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.156,
                                                    -0.007
                                                ],
                                                [
                                                    0.136,
                                                    0
                                                ],
                                                [
                                                    0.218,
                                                    0.115
                                                ],
                                                [
                                                    0,
                                                    0.584
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    1.073
                                                ],
                                                [
                                                    0.469,
                                                    0.672
                                                ],
                                                [
                                                    0.406,
                                                    0
                                                ],
                                                [
                                                    0.349,
                                                    -0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.209,
                                                    0.027
                                                ],
                                                [
                                                    -0.156,
                                                    0.007
                                                ],
                                                [
                                                    -0.51,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    -0.198
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    180.931,
                                                    -16.734
                                                ],
                                                [
                                                    178.666,
                                                    -16.734
                                                ],
                                                [
                                                    178.666,
                                                    -14.437
                                                ],
                                                [
                                                    180.931,
                                                    -14.437
                                                ],
                                                [
                                                    180.931,
                                                    -3.359
                                                ],
                                                [
                                                    181.634,
                                                    -0.742
                                                ],
                                                [
                                                    184.306,
                                                    0.266
                                                ],
                                                [
                                                    185.439,
                                                    0.203
                                                ],
                                                [
                                                    186.447,
                                                    0
                                                ],
                                                [
                                                    186.447,
                                                    -2.234
                                                ],
                                                [
                                                    185.9,
                                                    -2.182
                                                ],
                                                [
                                                    185.462,
                                                    -2.172
                                                ],
                                                [
                                                    184.369,
                                                    -2.344
                                                ],
                                                [
                                                    183.775,
                                                    -3.516
                                                ],
                                                [
                                                    183.775,
                                                    -14.437
                                                ],
                                                [
                                                    186.447,
                                                    -14.437
                                                ],
                                                [
                                                    186.447,
                                                    -16.734
                                                ],
                                                [
                                                    183.775,
                                                    -16.734
                                                ],
                                                [
                                                    183.775,
                                                    -21.406
                                                ],
                                                [
                                                    180.931,
                                                    -21.406
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "i",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    191.083,
                                                    0
                                                ],
                                                [
                                                    193.943,
                                                    0
                                                ],
                                                [
                                                    193.943,
                                                    -16.656
                                                ],
                                                [
                                                    191.083,
                                                    -16.656
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    191.083,
                                                    -19.766
                                                ],
                                                [
                                                    193.943,
                                                    -19.766
                                                ],
                                                [
                                                    193.943,
                                                    -22.953
                                                ],
                                                [
                                                    191.083,
                                                    -22.953
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "o",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.843,
                                                    0
                                                ],
                                                [
                                                    0.773,
                                                    1.186
                                                ],
                                                [
                                                    0,
                                                    1.779
                                                ],
                                                [
                                                    -0.772,
                                                    1.311
                                                ],
                                                [
                                                    -1.699,
                                                    0
                                                ],
                                                [
                                                    -0.782,
                                                    -1.54
                                                ],
                                                [
                                                    0,
                                                    -1.56
                                                ],
                                                [
                                                    0.685,
                                                    -1.409
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.68,
                                                    0
                                                ],
                                                [
                                                    -0.772,
                                                    -1.186
                                                ],
                                                [
                                                    0,
                                                    -1.852
                                                ],
                                                [
                                                    0.773,
                                                    -1.311
                                                ],
                                                [
                                                    1.916,
                                                    0
                                                ],
                                                [
                                                    0.495,
                                                    0.978
                                                ],
                                                [
                                                    0,
                                                    1.727
                                                ],
                                                [
                                                    -0.685,
                                                    1.41
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    206.603,
                                                    -1.828
                                                ],
                                                [
                                                    202.925,
                                                    -3.607
                                                ],
                                                [
                                                    201.767,
                                                    -8.055
                                                ],
                                                [
                                                    202.925,
                                                    -12.799
                                                ],
                                                [
                                                    206.633,
                                                    -14.766
                                                ],
                                                [
                                                    210.681,
                                                    -12.456
                                                ],
                                                [
                                                    211.423,
                                                    -8.648
                                                ],
                                                [
                                                    210.395,
                                                    -3.943
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    2.141,
                                                    0
                                                ],
                                                [
                                                    1.417,
                                                    -1.665
                                                ],
                                                [
                                                    0,
                                                    -2.81
                                                ],
                                                [
                                                    -1.345,
                                                    -1.556
                                                ],
                                                [
                                                    -2.286,
                                                    0
                                                ],
                                                [
                                                    -1.303,
                                                    1.758
                                                ],
                                                [
                                                    0,
                                                    2.695
                                                ],
                                                [
                                                    1.479,
                                                    1.436
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -2.389,
                                                    0
                                                ],
                                                [
                                                    -1.417,
                                                    1.665
                                                ],
                                                [
                                                    0,
                                                    2.623
                                                ],
                                                [
                                                    1.345,
                                                    1.556
                                                ],
                                                [
                                                    2.741,
                                                    0
                                                ],
                                                [
                                                    1.304,
                                                    -1.759
                                                ],
                                                [
                                                    0,
                                                    -2.789
                                                ],
                                                [
                                                    -1.48,
                                                    -1.436
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    206.711,
                                                    -17.219
                                                ],
                                                [
                                                    201.002,
                                                    -14.721
                                                ],
                                                [
                                                    198.876,
                                                    -8.008
                                                ],
                                                [
                                                    200.893,
                                                    -1.74
                                                ],
                                                [
                                                    206.339,
                                                    0.594
                                                ],
                                                [
                                                    212.405,
                                                    -2.044
                                                ],
                                                [
                                                    214.36,
                                                    -8.726
                                                ],
                                                [
                                                    212.142,
                                                    -15.064
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.141,
                                                    0.589
                                                ],
                                                [
                                                    -0.469,
                                                    0.552
                                                ],
                                                [
                                                    -0.771,
                                                    0.229
                                                ],
                                                [
                                                    -0.667,
                                                    0
                                                ],
                                                [
                                                    -0.5,
                                                    -1.041
                                                ],
                                                [
                                                    0,
                                                    -1.021
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.458,
                                                    0.906
                                                ],
                                                [
                                                    2.375,
                                                    0
                                                ],
                                                [
                                                    0.885,
                                                    -0.427
                                                ],
                                                [
                                                    0.792,
                                                    -0.979
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.093
                                                ],
                                                [
                                                    0.141,
                                                    -0.588
                                                ],
                                                [
                                                    0.583,
                                                    -0.687
                                                ],
                                                [
                                                    0.427,
                                                    -0.135
                                                ],
                                                [
                                                    1.312,
                                                    0
                                                ],
                                                [
                                                    0.302,
                                                    0.625
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.688
                                                ],
                                                [
                                                    -0.834,
                                                    -1.656
                                                ],
                                                [
                                                    -1.083,
                                                    0
                                                ],
                                                [
                                                    -0.885,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    219.638,
                                                    0
                                                ],
                                                [
                                                    222.45,
                                                    0
                                                ],
                                                [
                                                    222.45,
                                                    -8.766
                                                ],
                                                [
                                                    222.661,
                                                    -11.289
                                                ],
                                                [
                                                    223.575,
                                                    -13
                                                ],
                                                [
                                                    225.606,
                                                    -14.375
                                                ],
                                                [
                                                    227.247,
                                                    -14.578
                                                ],
                                                [
                                                    229.966,
                                                    -13.016
                                                ],
                                                [
                                                    230.419,
                                                    -10.547
                                                ],
                                                [
                                                    230.419,
                                                    0
                                                ],
                                                [
                                                    233.278,
                                                    0
                                                ],
                                                [
                                                    233.278,
                                                    -10.734
                                                ],
                                                [
                                                    232.591,
                                                    -14.625
                                                ],
                                                [
                                                    227.778,
                                                    -17.109
                                                ],
                                                [
                                                    224.825,
                                                    -16.469
                                                ],
                                                [
                                                    222.309,
                                                    -14.359
                                                ],
                                                [
                                                    222.309,
                                                    -16.734
                                                ],
                                                [
                                                    219.638,
                                                    -16.734
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "?",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    244.962,
                                                    0
                                                ],
                                                [
                                                    248.071,
                                                    0
                                                ],
                                                [
                                                    248.071,
                                                    -3.25
                                                ],
                                                [
                                                    244.962,
                                                    -3.25
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -2.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.383,
                                                    0.719
                                                ],
                                                [
                                                    -1.776,
                                                    0
                                                ],
                                                [
                                                    -0.622,
                                                    -0.75
                                                ],
                                                [
                                                    0,
                                                    -1.021
                                                ],
                                                [
                                                    0.433,
                                                    -0.677
                                                ],
                                                [
                                                    0.383,
                                                    -0.355
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.354,
                                                    -0.912
                                                ],
                                                [
                                                    0,
                                                    -1.489
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.309,
                                                    0.672
                                                ],
                                                [
                                                    -1.021,
                                                    0.969
                                                ],
                                                [
                                                    -0.454,
                                                    0.687
                                                ],
                                                [
                                                    0,
                                                    1.104
                                                ],
                                                [
                                                    1.249,
                                                    1.172
                                                ],
                                                [
                                                    2.078,
                                                    0
                                                ],
                                                [
                                                    1.287,
                                                    -1.37
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    -1.354
                                                ],
                                                [
                                                    0.68,
                                                    -1.292
                                                ],
                                                [
                                                    1.436,
                                                    0
                                                ],
                                                [
                                                    0.622,
                                                    0.75
                                                ],
                                                [
                                                    0,
                                                    0.729
                                                ],
                                                [
                                                    -0.238,
                                                    0.386
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    -1.222,
                                                    1.177
                                                ],
                                                [
                                                    -0.354,
                                                    0.911
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.312
                                                ],
                                                [
                                                    0.308,
                                                    -0.672
                                                ],
                                                [
                                                    1.404,
                                                    -1.334
                                                ],
                                                [
                                                    0.453,
                                                    -0.688
                                                ],
                                                [
                                                    0,
                                                    -1.823
                                                ],
                                                [
                                                    -1.25,
                                                    -1.172
                                                ],
                                                [
                                                    -2.246,
                                                    0
                                                ],
                                                [
                                                    -1.286,
                                                    1.37
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    239.633,
                                                    -15.766
                                                ],
                                                [
                                                    242.415,
                                                    -15.766
                                                ],
                                                [
                                                    243.069,
                                                    -18.875
                                                ],
                                                [
                                                    246.754,
                                                    -20.812
                                                ],
                                                [
                                                    249.841,
                                                    -19.687
                                                ],
                                                [
                                                    250.774,
                                                    -17.031
                                                ],
                                                [
                                                    250.125,
                                                    -14.922
                                                ],
                                                [
                                                    249.194,
                                                    -13.812
                                                ],
                                                [
                                                    247.919,
                                                    -12.578
                                                ],
                                                [
                                                    245.555,
                                                    -9.445
                                                ],
                                                [
                                                    245.024,
                                                    -5.844
                                                ],
                                                [
                                                    247.805,
                                                    -5.844
                                                ],
                                                [
                                                    248.268,
                                                    -8.82
                                                ],
                                                [
                                                    250.262,
                                                    -11.281
                                                ],
                                                [
                                                    253.048,
                                                    -14.312
                                                ],
                                                [
                                                    253.727,
                                                    -17
                                                ],
                                                [
                                                    251.853,
                                                    -21.492
                                                ],
                                                [
                                                    246.862,
                                                    -23.25
                                                ],
                                                [
                                                    241.563,
                                                    -21.195
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "U Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 1802,
                    "ip": 0,
                    "ln": "34283",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0.226,
                                -14.663
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                1037.142,
                                322.916
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "U",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.81,
                                                    -1.615
                                                ],
                                                [
                                                    -4.131,
                                                    0
                                                ],
                                                [
                                                    -1.489,
                                                    2.945
                                                ],
                                                [
                                                    0,
                                                    2.999
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.547,
                                                    -1.04
                                                ],
                                                [
                                                    2.822,
                                                    0
                                                ],
                                                [
                                                    0.993,
                                                    1.77
                                                ],
                                                [
                                                    0,
                                                    1.77
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.999
                                                ],
                                                [
                                                    1.477,
                                                    2.945
                                                ],
                                                [
                                                    4.132,
                                                    0
                                                ],
                                                [
                                                    0.81,
                                                    -1.615
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.759
                                                ],
                                                [
                                                    -1.015,
                                                    1.915
                                                ],
                                                [
                                                    -2.354,
                                                    0
                                                ],
                                                [
                                                    -0.669,
                                                    -1.173
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -9.455,
                                                    -24.388
                                                ],
                                                [
                                                    -9.455,
                                                    -10.691
                                                ],
                                                [
                                                    -8.239,
                                                    -3.769
                                                ],
                                                [
                                                    0.174,
                                                    0.647
                                                ],
                                                [
                                                    8.604,
                                                    -3.769
                                                ],
                                                [
                                                    9.82,
                                                    -10.691
                                                ],
                                                [
                                                    9.82,
                                                    -24.388
                                                ],
                                                [
                                                    6.483,
                                                    -24.388
                                                ],
                                                [
                                                    6.483,
                                                    -9.313
                                                ],
                                                [
                                                    5.663,
                                                    -5.113
                                                ],
                                                [
                                                    -0.093,
                                                    -2.241
                                                ],
                                                [
                                                    -5.114,
                                                    -4.897
                                                ],
                                                [
                                                    -6.118,
                                                    -9.313
                                                ],
                                                [
                                                    -6.118,
                                                    -24.388
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 14",
                    "sr": 1,
                    "st": 0,
                    "op": 9999,
                    "ip": 0,
                    "ln": "34282",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                601,
                                612.871
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Ellipse 1",
                            "it": [
                                {
                                    "ty": "el",
                                    "nm": "Ellipse Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            88.31,
                                            88.31
                                        ]
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.098,
                                            0.6039,
                                            0.3373
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.7373,
                                            0.9255,
                                            0.8275
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            73.409,
                                            73.409
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            435.739,
                                            -286.767
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 4
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 13",
                    "sr": 1,
                    "st": 0,
                    "op": 3567,
                    "ip": 0,
                    "ln": "34281",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                306.5,
                                60
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                71.719,
                                60
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                712.777,
                                315.204
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "rc",
                            "nm": "undefined",
                            "d": 1,
                            "p": {
                                "a": 0,
                                "k": [
                                    306.5,
                                    60
                                ]
                            },
                            "r": {
                                "a": 0,
                                "k": 60
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    777,
                                    140
                                ]
                            }
                        },
                        {
                            "ty": "fl",
                            "nm": "undefined",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.098,
                                    0.6039,
                                    0.3373
                                ]
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100
                            }
                        }
                    ],
                    "ind": 5
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 8",
                    "sr": 1,
                    "st": 0,
                    "op": 3569,
                    "ip": 0,
                    "ln": "34280",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -8.716,
                                -288.791
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                180,
                                180
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                696.441,
                                216.545
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 2",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 20
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            1.348,
                                            0.638
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.0483,
                                            0.9945,
                                            0.3723
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            -218.037,
                                            -365.681
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 6
                }
            ]
        },
        {
            "nm": "Pre-comp 3",
            "id": "3",
            "fr": 60,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Comp_19",
                    "sr": 1,
                    "st": -278,
                    "op": 563,
                    "ip": 0,
                    "ln": "34266",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                120,
                                65
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        -26.45,
                                        -26.45
                                    ],
                                    "t": -36.004
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        -26.45,
                                        -26.45
                                    ],
                                    "t": -30.004
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        83.55,
                                        83.55
                                    ],
                                    "t": -19.565
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        73.55,
                                        73.55
                                    ],
                                    "t": -12.004
                                },
                                {
                                    "s": [
                                        100,
                                        100
                                    ],
                                    "t": 561.985
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                398.234,
                                590.891
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "h": 1,
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0
                                    ],
                                    "t": -19.004
                                },
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        0
                                    ],
                                    "t": -13.004
                                },
                                {
                                    "h": 1,
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        100
                                    ],
                                    "t": -1.004
                                },
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        100
                                    ],
                                    "t": 296.99
                                },
                                {
                                    "h": 1,
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0
                                    ],
                                    "t": 308.989
                                },
                                {
                                    "s": [
                                        0
                                    ],
                                    "t": 561.985
                                }
                            ]
                        }
                    },
                    "w": 240,
                    "h": 130,
                    "refId": "4",
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 3",
                    "sr": 1,
                    "st": -258,
                    "op": 342,
                    "ip": 0,
                    "ln": "34211",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -322.984,
                                -127.492
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                397.016,
                                592.508
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 80
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            237.005,
                                            78.6
                                        ]
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8706,
                                            0.8275,
                                            1
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8706,
                                            0.8275,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            84.458,
                                            109
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            -319.181,
                                            -134.43
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 0,
                    "nm": "AI Chat icon.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 6326,
                    "ip": 0,
                    "ln": "34330",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                17,
                                17
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                200,
                                200
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                257.346,
                                597.692
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 34,
                    "h": 34,
                    "refId": "8",
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 2",
                    "sr": 1,
                    "st": -411,
                    "op": 5942,
                    "ip": 0,
                    "ln": "34289",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                129.761,
                                130.329
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                -160.615,
                                946.077
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "ef": [
                        {
                            "ty": 34,
                            "nm": "Puppet",
                            "en": 1,
                            "ef": [
                                {
                                    "ty": 7,
                                    "nm": "Puppet Engine",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Mesh Rotation Refinement",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "On Transparent",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            ]
                        }
                    ],
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            44.559,
                                            34.521
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8706,
                                            0.8275,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            67.243
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            378.045,
                                            -254.509
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 4
                }
            ]
        },
        {
            "nm": "Comp_19",
            "id": "4",
            "fr": 60,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Comp_34",
                    "sr": 1,
                    "st": 0,
                    "op": 4022,
                    "ip": 0,
                    "ln": "34265",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                20,
                                20
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                75,
                                75
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 62
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 83.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 105.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 125.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 147.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 169.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 186.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 208.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 230.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 250.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 272.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 294.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 315.994
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 337.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 359.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 379.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 401.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 423.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 440.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 462.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 484.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 504.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 526.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 548.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 569.99
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 591.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 613.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 633.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 655.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 677.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 694.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 716.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 738.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 758.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 780.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 802.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 823.986
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 845.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 867.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 887.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 909.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 931.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 948.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 970.984
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 992.984
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1012.984
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1034.984
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1056.984
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1075.982
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1097.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1119.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1139.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1161.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1183.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1200.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1222.98
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1244.98
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1264.98
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1286.98
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1308.98
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1329.978
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1351.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1373.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1393.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1415.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1437.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1454.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1476.976
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1498.976
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1518.976
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1540.976
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1562.974
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1583.974
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1605.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1627.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1647.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1669.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1691.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1708.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1730.972
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1752.972
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1772.972
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1794.972
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1816.97
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1837.97
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1859.969
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1881.969
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1901.969
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1923.969
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 1945.969
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 1962.969
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 1984.968
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 2006.968
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        66.114
                                    ],
                                    "t": 2026.968
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        180,
                                        44.954
                                    ],
                                    "t": 2048.968
                                },
                                {
                                    "s": [
                                        180,
                                        65
                                    ],
                                    "t": 2070.966
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 40,
                    "h": 40,
                    "refId": "5",
                    "ind": 1
                },
                {
                    "ty": 0,
                    "nm": "Comp_27",
                    "sr": 1,
                    "st": 0,
                    "op": 4022,
                    "ip": 0,
                    "ln": "34251",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                20,
                                20
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                75,
                                75
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 31
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 53
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 72.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 91.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 113.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 133.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 153.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 175.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 195.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 214.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 236.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 256.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 273.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 295.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 315.994
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 334.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 356.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 376.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 396.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 418.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 438.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 457.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 479.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 499.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 517.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 539.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 559.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 578.99
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 600.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 620.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 640.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 662.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 682.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 701.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 723.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 743.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 760.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 782.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 802.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 821.986
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 843.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 863.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 883.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 905.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 925.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 944.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 966.984
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 986.984
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1008.984
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1030.984
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1050.984
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1069.982
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1091.982
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1111.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1131.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1153.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1173.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1192.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1214.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1234.98
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1251.98
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1273.98
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1293.98
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1312.978
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1334.978
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1354.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1374.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1396.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1416.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1435.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1457.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1477.976
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1495.976
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1517.976
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1537.976
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1556.976
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1578.974
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1598.974
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1618.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1640.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1660.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1679.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1701.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1721.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1738.972
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1760.972
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1780.972
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1799.972
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1821.97
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1841.97
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1861.969
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1883.969
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1903.969
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1922.969
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        120,
                                        44.954
                                    ],
                                    "t": 1944.969
                                },
                                {
                                    "s": [
                                        120,
                                        65
                                    ],
                                    "t": 1964.969
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 40,
                    "h": 40,
                    "refId": "6",
                    "ind": 2
                },
                {
                    "ty": 0,
                    "nm": "Comp_20",
                    "sr": 1,
                    "st": 0,
                    "op": 4022,
                    "ip": 0,
                    "ln": "34237",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                20,
                                20
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                75,
                                75
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 0
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 20
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 41
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 63
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 82.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 103.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 122.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 142.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 163.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 185.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 205.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 226.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 244.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 264.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 285.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 307.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 327.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 348.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 367.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 387.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 408.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 430.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 450.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 471.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 488.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 508.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 529.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 551.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 571.99
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 592.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 611.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 631.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 652.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 674.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 694.989
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 715.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 733.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 753.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 774.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 796.988
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 816.986
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 837.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 856.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 876.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 897.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 919.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 939.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 960.985
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 980.984
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1000.984
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1021.984
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1043.984
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1063.982
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1084.982
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1103.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1123.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1144.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1166.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1186.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1207.981
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1225.98
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1245.98
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1266.98
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1288.98
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1308.98
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1329.978
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1348.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1368.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1389.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1411.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1431.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1452.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1469.977
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1489.976
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1510.976
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1532.976
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1552.976
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1573.974
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1592.974
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1612.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1633.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1655.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1675.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1696.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1714.973
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1734.972
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1755.972
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1777.972
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1797.972
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1818.97
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1837.97
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1857.97
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1878.969
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        65
                                    ],
                                    "t": 1900.969
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        60,
                                        51.636
                                    ],
                                    "t": 1920.969
                                },
                                {
                                    "s": [
                                        60,
                                        67.227
                                    ],
                                    "t": 1941.969
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 40,
                    "h": 40,
                    "refId": "7",
                    "ind": 3
                }
            ]
        },
        {
            "nm": "Comp_34",
            "id": "5",
            "fr": 60,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 841,
                    "ip": 0,
                    "ln": "34264",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "el",
                            "nm": "undefined",
                            "d": 1,
                            "p": {
                                "a": 0,
                                "k": [
                                    20,
                                    20
                                ]
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    40,
                                    40
                                ]
                            }
                        },
                        {
                            "ty": "fl",
                            "nm": "undefined",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.4196,
                                    0.2902,
                                    0.8
                                ]
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100
                            }
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "Comp_27",
            "id": "6",
            "fr": 60,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 841,
                    "ip": 0,
                    "ln": "34250",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "el",
                            "nm": "undefined",
                            "d": 1,
                            "p": {
                                "a": 0,
                                "k": [
                                    20,
                                    20
                                ]
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    40,
                                    40
                                ]
                            }
                        },
                        {
                            "ty": "fl",
                            "nm": "undefined",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.4196,
                                    0.2902,
                                    0.8
                                ]
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100
                            }
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "Comp_20",
            "id": "7",
            "fr": 60,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 841,
                    "ip": 0,
                    "ln": "34236",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "el",
                            "nm": "undefined",
                            "d": 1,
                            "p": {
                                "a": 0,
                                "k": [
                                    20,
                                    20
                                ]
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    40,
                                    40
                                ]
                            }
                        },
                        {
                            "ty": "fl",
                            "nm": "undefined",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.4196,
                                    0.2902,
                                    0.8
                                ]
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100
                            }
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "AI Chat icon.svg",
            "id": "8",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "AI Chat icon.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 6326,
                    "ip": 0,
                    "ln": "34329",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                17,
                                17
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                17,
                                17
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.111,
                                                    0.321
                                                ],
                                                [
                                                    0.288,
                                                    0.182
                                                ],
                                                [
                                                    0.338,
                                                    -0.038
                                                ],
                                                [
                                                    0.241,
                                                    -0.24
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.058,
                                                    -0.291
                                                ],
                                                [
                                                    -0.113,
                                                    -0.274
                                                ],
                                                [
                                                    -0.247,
                                                    -0.165
                                                ],
                                                [
                                                    -0.297,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.071,
                                                    -0.037
                                                ],
                                                [
                                                    -0.046,
                                                    -0.065
                                                ],
                                                [
                                                    -0.011,
                                                    -0.079
                                                ],
                                                [
                                                    0.027,
                                                    -0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.112,
                                                    -0.322
                                                ],
                                                [
                                                    -0.288,
                                                    -0.181
                                                ],
                                                [
                                                    -0.338,
                                                    0.038
                                                ],
                                                [
                                                    -0.24,
                                                    0.24
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.058,
                                                    0.291
                                                ],
                                                [
                                                    0.114,
                                                    0.274
                                                ],
                                                [
                                                    0.247,
                                                    0.165
                                                ],
                                                [
                                                    0.297,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.071,
                                                    0.037
                                                ],
                                                [
                                                    0.046,
                                                    0.065
                                                ],
                                                [
                                                    0.011,
                                                    0.079
                                                ],
                                                [
                                                    -0.027,
                                                    0.075
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.113,
                                                    -0.321
                                                ],
                                                [
                                                    -0.112,
                                                    -0.322
                                                ],
                                                [
                                                    -0.288,
                                                    -0.181
                                                ],
                                                [
                                                    -0.338,
                                                    0.038
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.21
                                                ],
                                                [
                                                    -0.058,
                                                    0.291
                                                ],
                                                [
                                                    0.114,
                                                    0.274
                                                ],
                                                [
                                                    0.246,
                                                    0.165
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.08,
                                                    0
                                                ],
                                                [
                                                    0.07,
                                                    0.037
                                                ],
                                                [
                                                    0.046,
                                                    0.066
                                                ],
                                                [
                                                    0.011,
                                                    0.079
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.113,
                                                    0.321
                                                ],
                                                [
                                                    0.111,
                                                    0.321
                                                ],
                                                [
                                                    0.287,
                                                    0.182
                                                ],
                                                [
                                                    0.338,
                                                    -0.038
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.21
                                                ],
                                                [
                                                    0.058,
                                                    -0.291
                                                ],
                                                [
                                                    -0.113,
                                                    -0.274
                                                ],
                                                [
                                                    -0.246,
                                                    -0.165
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.08,
                                                    0
                                                ],
                                                [
                                                    -0.071,
                                                    -0.037
                                                ],
                                                [
                                                    -0.046,
                                                    -0.066
                                                ],
                                                [
                                                    -0.011,
                                                    -0.08
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.914,
                                                    -8
                                                ],
                                                [
                                                    3.917,
                                                    -8.991
                                                ],
                                                [
                                                    3.3,
                                                    -9.768
                                                ],
                                                [
                                                    2.334,
                                                    -9.99
                                                ],
                                                [
                                                    1.44,
                                                    -9.561
                                                ],
                                                [
                                                    -7.56,
                                                    -0.561
                                                ],
                                                [
                                                    -7.971,
                                                    0.207
                                                ],
                                                [
                                                    -7.886,
                                                    1.074
                                                ],
                                                [
                                                    -7.333,
                                                    1.747
                                                ],
                                                [
                                                    -6.5,
                                                    2
                                                ],
                                                [
                                                    -2.498,
                                                    2
                                                ],
                                                [
                                                    -2.268,
                                                    2.056
                                                ],
                                                [
                                                    -2.09,
                                                    2.211
                                                ],
                                                [
                                                    -2.003,
                                                    2.431
                                                ],
                                                [
                                                    -2.027,
                                                    2.666
                                                ],
                                                [
                                                    -3.914,
                                                    8
                                                ],
                                                [
                                                    -3.916,
                                                    8.992
                                                ],
                                                [
                                                    -3.299,
                                                    9.768
                                                ],
                                                [
                                                    -2.333,
                                                    9.99
                                                ],
                                                [
                                                    -1.439,
                                                    9.56
                                                ],
                                                [
                                                    7.561,
                                                    0.56
                                                ],
                                                [
                                                    7.971,
                                                    -0.208
                                                ],
                                                [
                                                    7.885,
                                                    -1.074
                                                ],
                                                [
                                                    7.333,
                                                    -1.747
                                                ],
                                                [
                                                    6.5,
                                                    -2
                                                ],
                                                [
                                                    2.503,
                                                    -2
                                                ],
                                                [
                                                    2.273,
                                                    -2.056
                                                ],
                                                [
                                                    2.094,
                                                    -2.211
                                                ],
                                                [
                                                    2.007,
                                                    -2.431
                                                ],
                                                [
                                                    2.031,
                                                    -2.667
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "gf",
                                    "nm": "Gradient Fill 1",
                                    "e": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            12
                                        ]
                                    },
                                    "g": {
                                        "p": 3,
                                        "k": {
                                            "a": 0,
                                            "k": [
                                                0,
                                                0.51372552,
                                                0.36078432,
                                                0.96078438,
                                                0.5,
                                                0.2941176635,
                                                0.6588235649999999,
                                                0.729411815,
                                                1,
                                                0.074509807,
                                                0.95686281,
                                                0.49803925
                                            ]
                                        }
                                    },
                                    "t": 1,
                                    "a": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "h": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            -12
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            17,
                                            17
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -9.083
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    9.083
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    9.083
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -9.083
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -16.446
                                                ],
                                                [
                                                    0,
                                                    -16.446
                                                ],
                                                [
                                                    16.446,
                                                    0
                                                ],
                                                [
                                                    16.446,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    16.446
                                                ],
                                                [
                                                    0,
                                                    16.446
                                                ],
                                                [
                                                    -16.446,
                                                    0
                                                ],
                                                [
                                                    -16.446,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.109
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.5137,
                                            0.3608,
                                            0.9608
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.902,
                                            0.8706,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            17,
                                            17
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "Dots line",
            "id": "9",
            "fr": 60,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Shape Layer 9",
                    "sr": 1,
                    "st": -240,
                    "op": 360,
                    "ip": 47,
                    "ln": "34196",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -149.245,
                                273.622
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                105.364,
                                98.869
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                539.75,
                                991.527
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -149.281,
                                                    308.757
                                                ],
                                                [
                                                    -149.281,
                                                    473.024
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 1,
                                                "k": [
                                                    {
                                                        "o": {
                                                            "x": 0.167,
                                                            "y": 0.167
                                                        },
                                                        "i": {
                                                            "x": 0.833,
                                                            "y": 0.833
                                                        },
                                                        "s": [
                                                            100
                                                        ],
                                                        "t": 29.998
                                                    },
                                                    {
                                                        "o": {
                                                            "x": 0.167,
                                                            "y": 0.167
                                                        },
                                                        "i": {
                                                            "x": 0.833,
                                                            "y": 0.833
                                                        },
                                                        "s": [
                                                            0
                                                        ],
                                                        "t": 235.996
                                                    },
                                                    {
                                                        "s": [
                                                            96
                                                        ],
                                                        "t": 249.996
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            99.976,
                                            70
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "tm",
                            "nm": "Trim Paths 2",
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "s": [
                                            0
                                        ],
                                        "t": 28.996
                                    },
                                    {
                                        "s": [
                                            100
                                        ],
                                        "t": 51.996
                                    }
                                ]
                            },
                            "o": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 0,
                                "k": 0
                            },
                            "m": 1
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 8",
                    "sr": 1,
                    "st": -240,
                    "op": 360,
                    "ip": 47,
                    "ln": "34195",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -149.245,
                                273.622
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                105.364,
                                98.869
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                928.75,
                                991.527
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -149.281,
                                                    308.757
                                                ],
                                                [
                                                    -149.281,
                                                    473.024
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 1,
                                                "k": [
                                                    {
                                                        "o": {
                                                            "x": 0.167,
                                                            "y": 0.167
                                                        },
                                                        "i": {
                                                            "x": 0.833,
                                                            "y": 0.833
                                                        },
                                                        "s": [
                                                            100
                                                        ],
                                                        "t": 30.998
                                                    },
                                                    {
                                                        "s": [
                                                            0
                                                        ],
                                                        "t": 235.996
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            99.976,
                                            70
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "tm",
                            "nm": "Trim Paths 2",
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "s": [
                                            0
                                        ],
                                        "t": 28.996
                                    },
                                    {
                                        "s": [
                                            100
                                        ],
                                        "t": 51.996
                                    }
                                ]
                            },
                            "o": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 0,
                                "k": 0
                            },
                            "m": 1
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 5",
                    "sr": 1,
                    "st": -240,
                    "op": 360,
                    "ip": 0,
                    "ln": "34194",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                99.113
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                725.401,
                                660.78
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -7.861,
                                                    214.99
                                                ],
                                                [
                                                    -70.787,
                                                    214.99
                                                ],
                                                [
                                                    -177.769,
                                                    214.562
                                                ],
                                                [
                                                    -177.769,
                                                    267.345
                                                ],
                                                [
                                                    -177.664,
                                                    411.108
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "tm",
                                    "nm": "Trim Paths 1",
                                    "e": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 28.996
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 51.996
                                            }
                                        ]
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "m": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 1,
                                                "k": [
                                                    {
                                                        "o": {
                                                            "x": 0.167,
                                                            "y": 0.167
                                                        },
                                                        "i": {
                                                            "x": 0.833,
                                                            "y": 0.833
                                                        },
                                                        "s": [
                                                            100
                                                        ],
                                                        "t": 35.998
                                                    },
                                                    {
                                                        "s": [
                                                            0
                                                        ],
                                                        "t": 240.996
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            167.694,
                                            129
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 3",
                    "sr": 1,
                    "st": -240,
                    "op": 360,
                    "ip": 0,
                    "ln": "34193",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                93.04,
                                93.04
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                720,
                                710
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -217.275,
                                                    -4.828
                                                ],
                                                [
                                                    -8.502,
                                                    -4.828
                                                ],
                                                [
                                                    -8.502,
                                                    242.025
                                                ],
                                                [
                                                    124.654,
                                                    241.303
                                                ],
                                                [
                                                    282.417,
                                                    241.084
                                                ],
                                                [
                                                    282.417,
                                                    478.576
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "tm",
                                    "nm": "Trim Paths 1",
                                    "e": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 1
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 1.996
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 51.996
                                            }
                                        ]
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "m": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 1,
                                                "k": [
                                                    {
                                                        "o": {
                                                            "x": 0.167,
                                                            "y": 0.167
                                                        },
                                                        "i": {
                                                            "x": 0.833,
                                                            "y": 0.833
                                                        },
                                                        "s": [
                                                            100
                                                        ],
                                                        "t": 40.998
                                                    },
                                                    {
                                                        "s": [
                                                            0
                                                        ],
                                                        "t": 245.996
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            98.216,
                                            100.031
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 4
                }
            ]
        },
        {
            "nm": "Isometric",
            "id": "10",
            "fr": 60,
            "layers": [
                {
                    "ty": 4,
                    "nm": "8 Outlines",
                    "sr": 1,
                    "st": -244,
                    "op": 631,
                    "ip": 43,
                    "ln": "34179",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                18.5,
                                16
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0,
                                        0
                                    ],
                                    "t": 41.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 61.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        98,
                                        98
                                    ],
                                    "t": 66.996
                                },
                                {
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 72.994
                                }
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        540.606,
                                        1043.849
                                    ],
                                    "t": 56.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        540.606,
                                        1037.849
                                    ],
                                    "t": 115.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        540.606,
                                        1043.849
                                    ],
                                    "t": 175.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        540.606,
                                        1037.849
                                    ],
                                    "t": 234.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        540.606,
                                        1043.849
                                    ],
                                    "t": 296.992
                                },
                                {
                                    "s": [
                                        540.606,
                                        1037.849
                                    ],
                                    "t": 355.989
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.533,
                                                    -0.342
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.091,
                                                    -0.123
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.018,
                                                    -0.146
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.349,
                                                    -0.096
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    0.045
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.549,
                                                    0.628
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.046,
                                                    0.105
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.017,
                                                    0.132
                                                ],
                                                [
                                                    -0.003,
                                                    0.03
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.298,
                                                    0.102
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.481,
                                                    -0.15
                                                ],
                                                [
                                                    -0.281,
                                                    -0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.172,
                                                    0.012
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.604,
                                                    -0.047
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.158,
                                                    0.124
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.114,
                                                    0.198
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.109,
                                                    0.185
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.336,
                                                    0.094
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.008,
                                                    -0.148
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.072,
                                                    -0.091
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.059,
                                                    -0.139
                                                ],
                                                [
                                                    0.006,
                                                    -0.022
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.077,
                                                    -0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.397,
                                                    -0.099
                                                ],
                                                [
                                                    0.479,
                                                    0.148
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.177,
                                                    -0.049
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.739,
                                                    -2.828
                                                ],
                                                [
                                                    11.552,
                                                    -2.352
                                                ],
                                                [
                                                    11.771,
                                                    -2.196
                                                ],
                                                [
                                                    12.143,
                                                    -1.825
                                                ],
                                                [
                                                    12.225,
                                                    -1.703
                                                ],
                                                [
                                                    12.349,
                                                    -1.183
                                                ],
                                                [
                                                    12.287,
                                                    -0.982
                                                ],
                                                [
                                                    11.659,
                                                    -0.552
                                                ],
                                                [
                                                    11.658,
                                                    -0.551
                                                ],
                                                [
                                                    10.064,
                                                    -0.112
                                                ],
                                                [
                                                    10.063,
                                                    -0.111
                                                ],
                                                [
                                                    8.212,
                                                    0.402
                                                ],
                                                [
                                                    6.141,
                                                    0.976
                                                ],
                                                [
                                                    -1.58,
                                                    3.116
                                                ],
                                                [
                                                    -4.168,
                                                    3.834
                                                ],
                                                [
                                                    -4.169,
                                                    3.834
                                                ],
                                                [
                                                    -5.346,
                                                    3.905
                                                ],
                                                [
                                                    -5.533,
                                                    3.881
                                                ],
                                                [
                                                    -8.103,
                                                    2.603
                                                ],
                                                [
                                                    -8.401,
                                                    2.234
                                                ],
                                                [
                                                    -8.402,
                                                    2.234
                                                ],
                                                [
                                                    -10.339,
                                                    -0.302
                                                ],
                                                [
                                                    -10.345,
                                                    -0.309
                                                ],
                                                [
                                                    -12.097,
                                                    -2.515
                                                ],
                                                [
                                                    -12.264,
                                                    -2.801
                                                ],
                                                [
                                                    -12.263,
                                                    -2.801
                                                ],
                                                [
                                                    -12.318,
                                                    -3.2
                                                ],
                                                [
                                                    -12.304,
                                                    -3.279
                                                ],
                                                [
                                                    -12.26,
                                                    -3.405
                                                ],
                                                [
                                                    -11.718,
                                                    -3.809
                                                ],
                                                [
                                                    -11.577,
                                                    -3.851
                                                ],
                                                [
                                                    -10.207,
                                                    -3.774
                                                ],
                                                [
                                                    -9.022,
                                                    -3.057
                                                ],
                                                [
                                                    -7.994,
                                                    -1.763
                                                ],
                                                [
                                                    -7.994,
                                                    -1.762
                                                ],
                                                [
                                                    -5.79,
                                                    1.116
                                                ],
                                                [
                                                    -5.584,
                                                    1.384
                                                ],
                                                [
                                                    -5.259,
                                                    1.293
                                                ],
                                                [
                                                    1.965,
                                                    -0.716
                                                ],
                                                [
                                                    1.966,
                                                    -0.717
                                                ],
                                                [
                                                    3.517,
                                                    -1.152
                                                ],
                                                [
                                                    9.222,
                                                    -2.732
                                                ],
                                                [
                                                    9.736,
                                                    -2.828
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.001,
                                                    -0.003
                                                ],
                                                [
                                                    0.001,
                                                    -0.002
                                                ],
                                                [
                                                    -0.014,
                                                    0.035
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.007,
                                                    0.018
                                                ],
                                                [
                                                    -0.009,
                                                    0.017
                                                ],
                                                [
                                                    -0.001,
                                                    0.004
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.343,
                                                    -3.125
                                                ],
                                                [
                                                    -12.358,
                                                    -3.092
                                                ],
                                                [
                                                    -12.341,
                                                    -3.136
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            19.989,
                                            10.197
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.307,
                                                    0.021
                                                ],
                                                [
                                                    0.037,
                                                    5.669
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -4.489,
                                                    -1.872
                                                ],
                                                [
                                                    -3.872,
                                                    -0.009
                                                ],
                                                [
                                                    -2.896,
                                                    1.185
                                                ],
                                                [
                                                    -0.432,
                                                    3.09
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.741,
                                                    5.254
                                                ],
                                                [
                                                    -9.818,
                                                    -0.02
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.021,
                                                    3.431
                                                ],
                                                [
                                                    2.93,
                                                    1.222
                                                ],
                                                [
                                                    3.83,
                                                    0.008
                                                ],
                                                [
                                                    4.144,
                                                    -1.691
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    17.75,
                                                    -9.61
                                                ],
                                                [
                                                    17.75,
                                                    1.195
                                                ],
                                                [
                                                    0.095,
                                                    10.543
                                                ],
                                                [
                                                    -17.75,
                                                    0.241
                                                ],
                                                [
                                                    -17.75,
                                                    -10.564
                                                ],
                                                [
                                                    -10.303,
                                                    -2.216
                                                ],
                                                [
                                                    0.091,
                                                    -0.261
                                                ],
                                                [
                                                    10.356,
                                                    -2.129
                                                ],
                                                [
                                                    17.746,
                                                    -9.61
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.437
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            18.468,
                                            20.673
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -5.649
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -4.489,
                                                    -1.872
                                                ],
                                                [
                                                    -3.872,
                                                    -0.008
                                                ],
                                                [
                                                    -2.896,
                                                    1.185
                                                ],
                                                [
                                                    -0.432,
                                                    3.09
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.348,
                                                    0.021
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -9.797,
                                                    -0.021
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.021,
                                                    3.432
                                                ],
                                                [
                                                    2.93,
                                                    1.222
                                                ],
                                                [
                                                    3.83,
                                                    0.008
                                                ],
                                                [
                                                    4.144,
                                                    -1.691
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.745,
                                                    -5.292
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.035,
                                                    -10.257
                                                ],
                                                [
                                                    -17.748,
                                                    -0.07
                                                ],
                                                [
                                                    -17.748,
                                                    -0.033
                                                ],
                                                [
                                                    -10.301,
                                                    8.315
                                                ],
                                                [
                                                    0.093,
                                                    10.27
                                                ],
                                                [
                                                    10.358,
                                                    8.402
                                                ],
                                                [
                                                    17.748,
                                                    0.922
                                                ],
                                                [
                                                    17.748,
                                                    -0.765
                                                ],
                                                [
                                                    -0.035,
                                                    -10.262
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.437
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            18.466,
                                            10.982
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "7 Outlines",
                    "sr": 1,
                    "st": -227,
                    "op": 648,
                    "ip": 60,
                    "ln": "34178",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                45,
                                33
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0,
                                        0
                                    ],
                                    "t": 58.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 78.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        98,
                                        98
                                    ],
                                    "t": 83.996
                                },
                                {
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 89.994
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                451.092,
                                1181.09
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    72.071,
                                                    65.164
                                                ],
                                                [
                                                    72.071,
                                                    51.514
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.231,
                                                    0.783
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.044,
                                                    -0.603
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.715,
                                                    1.568
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.158,
                                                    0.889
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.992,
                                                    -0.573
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.092,
                                                    -0.183
                                                ],
                                                [
                                                    -1.839,
                                                    1.062
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.231,
                                                    0.783
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.695,
                                                    1.556
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.182,
                                                    -0.682
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.271,
                                                    0.737
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.862,
                                                    0.498
                                                ],
                                                [
                                                    2.346,
                                                    0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.044,
                                                    -0.603
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    44.126,
                                                    3.661
                                                ],
                                                [
                                                    44.126,
                                                    17.313
                                                ],
                                                [
                                                    42.213,
                                                    19.447
                                                ],
                                                [
                                                    31.668,
                                                    25.535
                                                ],
                                                [
                                                    21.871,
                                                    25.514
                                                ],
                                                [
                                                    -42.114,
                                                    -11.428
                                                ],
                                                [
                                                    -44.126,
                                                    -13.865
                                                ],
                                                [
                                                    -44.118,
                                                    -14.719
                                                ],
                                                [
                                                    -44.01,
                                                    -27.091
                                                ],
                                                [
                                                    -42.114,
                                                    -25.079
                                                ],
                                                [
                                                    -35.209,
                                                    -21.092
                                                ],
                                                [
                                                    -26.197,
                                                    -15.89
                                                ],
                                                [
                                                    -20.881,
                                                    -12.82
                                                ],
                                                [
                                                    -13.892,
                                                    -8.784
                                                ],
                                                [
                                                    21.871,
                                                    11.863
                                                ],
                                                [
                                                    24.856,
                                                    12.884
                                                ],
                                                [
                                                    31.668,
                                                    11.884
                                                ],
                                                [
                                                    35.272,
                                                    9.803
                                                ],
                                                [
                                                    42.213,
                                                    5.796
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.661,
                                            38.485
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.131,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.131,
                                                    -0.447
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    44.085,
                                                    14.663
                                                ],
                                                [
                                                    44.085,
                                                    16.016
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.05,
                                                    -0.284
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.056,
                                                    0.284
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -44.167,
                                                    -15.162
                                                ],
                                                [
                                                    -44.159,
                                                    -16.016
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.703,
                                            39.781
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.257,
                                                    -0.727
                                                ],
                                                [
                                                    0.867,
                                                    0.021
                                                ],
                                                [
                                                    0.603,
                                                    0.348
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.032,
                                                    0.455
                                                ],
                                                [
                                                    -0.659,
                                                    0.38
                                                ],
                                                [
                                                    -0.824,
                                                    0
                                                ],
                                                [
                                                    -0.636,
                                                    -0.367
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.66,
                                                    0.381
                                                ],
                                                [
                                                    -0.788,
                                                    -0.018
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.605,
                                                    -0.348
                                                ],
                                                [
                                                    -0.034,
                                                    -0.501
                                                ],
                                                [
                                                    0.627,
                                                    -0.361
                                                ],
                                                [
                                                    0.824,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.268,
                                                    0.732
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    22.212,
                                                    12.898
                                                ],
                                                [
                                                    19.809,
                                                    13.438
                                                ],
                                                [
                                                    17.64,
                                                    12.889
                                                ],
                                                [
                                                    -22.482,
                                                    -10.277
                                                ],
                                                [
                                                    -23.435,
                                                    -11.53
                                                ],
                                                [
                                                    -22.5,
                                                    -12.916
                                                ],
                                                [
                                                    -20.229,
                                                    -13.459
                                                ],
                                                [
                                                    -17.928,
                                                    -12.907
                                                ],
                                                [
                                                    22.194,
                                                    10.257
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            50.868,
                                            29.506
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.858,
                                                    -0.495
                                                ],
                                                [
                                                    1.737,
                                                    1.004
                                                ],
                                                [
                                                    0,
                                                    0.658
                                                ],
                                                [
                                                    -0.858,
                                                    0.495
                                                ],
                                                [
                                                    -1.128,
                                                    0
                                                ],
                                                [
                                                    -0.873,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    -0.659
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.725,
                                                    0.996
                                                ],
                                                [
                                                    -0.873,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    -0.659
                                                ],
                                                [
                                                    0.859,
                                                    -0.496
                                                ],
                                                [
                                                    1.128,
                                                    0
                                                ],
                                                [
                                                    0.873,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0.658
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.147,
                                                    1.69
                                                ],
                                                [
                                                    -3.123,
                                                    1.676
                                                ],
                                                [
                                                    -4.435,
                                                    -0.146
                                                ],
                                                [
                                                    -3.147,
                                                    -1.943
                                                ],
                                                [
                                                    -0.033,
                                                    -2.686
                                                ],
                                                [
                                                    3.125,
                                                    -1.93
                                                ],
                                                [
                                                    4.434,
                                                    -0.107
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            18.996,
                                            11.623
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.064,
                                                    0.614
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.696,
                                                    -1.556
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.275,
                                                    -0.711
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.991,
                                                    -0.573
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.092,
                                                    -0.183
                                                ],
                                                [
                                                    -1.84,
                                                    1.062
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.231,
                                                    0.784
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.715,
                                                    -1.568
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.955,
                                                    0.551
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.272,
                                                    0.738
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.863,
                                                    0.498
                                                ],
                                                [
                                                    2.347,
                                                    0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.044,
                                                    -0.603
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.236,
                                                    -0.793
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    42.119,
                                                    12.689
                                                ],
                                                [
                                                    -21.866,
                                                    -24.252
                                                ],
                                                [
                                                    -31.663,
                                                    -24.273
                                                ],
                                                [
                                                    -42.208,
                                                    -18.186
                                                ],
                                                [
                                                    -44.053,
                                                    -16.249
                                                ],
                                                [
                                                    -44.068,
                                                    -14.542
                                                ],
                                                [
                                                    -42.172,
                                                    -12.529
                                                ],
                                                [
                                                    -35.267,
                                                    -8.541
                                                ],
                                                [
                                                    -26.255,
                                                    -3.34
                                                ],
                                                [
                                                    -20.939,
                                                    -0.269
                                                ],
                                                [
                                                    -13.949,
                                                    3.766
                                                ],
                                                [
                                                    21.813,
                                                    24.413
                                                ],
                                                [
                                                    24.798,
                                                    25.434
                                                ],
                                                [
                                                    31.611,
                                                    24.434
                                                ],
                                                [
                                                    35.214,
                                                    22.353
                                                ],
                                                [
                                                    42.155,
                                                    18.346
                                                ],
                                                [
                                                    44.068,
                                                    16.211
                                                ],
                                                [
                                                    44.068,
                                                    14.858
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.858,
                                                    -0.495
                                                ],
                                                [
                                                    1.737,
                                                    1.003
                                                ],
                                                [
                                                    0,
                                                    0.659
                                                ],
                                                [
                                                    -0.858,
                                                    0.495
                                                ],
                                                [
                                                    -1.129,
                                                    0
                                                ],
                                                [
                                                    -0.873,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    -0.658
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.725,
                                                    0.996
                                                ],
                                                [
                                                    -0.873,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    -0.658
                                                ],
                                                [
                                                    0.86,
                                                    -0.495
                                                ],
                                                [
                                                    1.128,
                                                    0
                                                ],
                                                [
                                                    0.873,
                                                    0.505
                                                ],
                                                [
                                                    0,
                                                    0.659
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -22.119,
                                                    -12.676
                                                ],
                                                [
                                                    -28.39,
                                                    -12.689
                                                ],
                                                [
                                                    -29.701,
                                                    -14.512
                                                ],
                                                [
                                                    -28.414,
                                                    -16.309
                                                ],
                                                [
                                                    -25.299,
                                                    -17.052
                                                ],
                                                [
                                                    -22.142,
                                                    -16.296
                                                ],
                                                [
                                                    -20.832,
                                                    -14.473
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.257,
                                                    -0.727
                                                ],
                                                [
                                                    0.867,
                                                    0.021
                                                ],
                                                [
                                                    0.603,
                                                    0.348
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.032,
                                                    0.455
                                                ],
                                                [
                                                    -0.659,
                                                    0.38
                                                ],
                                                [
                                                    -0.823,
                                                    0
                                                ],
                                                [
                                                    -0.636,
                                                    -0.367
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.66,
                                                    0.381
                                                ],
                                                [
                                                    -0.788,
                                                    -0.018
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.605,
                                                    -0.348
                                                ],
                                                [
                                                    -0.034,
                                                    -0.501
                                                ],
                                                [
                                                    0.627,
                                                    -0.361
                                                ],
                                                [
                                                    0.824,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.268,
                                                    0.732
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    28.361,
                                                    16.47
                                                ],
                                                [
                                                    25.958,
                                                    17.01
                                                ],
                                                [
                                                    23.789,
                                                    16.461
                                                ],
                                                [
                                                    -16.333,
                                                    -6.705
                                                ],
                                                [
                                                    -17.286,
                                                    -7.958
                                                ],
                                                [
                                                    -16.351,
                                                    -9.344
                                                ],
                                                [
                                                    -14.08,
                                                    -9.887
                                                ],
                                                [
                                                    -11.779,
                                                    -9.335
                                                ],
                                                [
                                                    28.343,
                                                    13.829
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.719,
                                            25.934
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.132,
                                                    0.449
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.132,
                                                    -0.447
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    44.105,
                                                    14.876
                                                ],
                                                [
                                                    44.105,
                                                    16.229
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.206,
                                                    -0.562
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.216,
                                                    0.559
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -44.031,
                                                    -14.524
                                                ],
                                                [
                                                    -44.016,
                                                    -16.229
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.682,
                                            25.916
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "6 Outlines",
                    "sr": 1,
                    "st": -218,
                    "op": 657,
                    "ip": 69,
                    "ln": "34177",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                40.5,
                                35
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0,
                                        0
                                    ],
                                    "t": 68.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 88.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        98,
                                        98
                                    ],
                                    "t": 93.996
                                },
                                {
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 99.994
                                }
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        591,
                                        1344
                                    ],
                                    "t": 82.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        591,
                                        1363
                                    ],
                                    "t": 141.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        591,
                                        1344
                                    ],
                                    "t": 201.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        591,
                                        1363
                                    ],
                                    "t": 260.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        591,
                                        1344
                                    ],
                                    "t": 321.992
                                },
                                {
                                    "s": [
                                        591,
                                        1363
                                    ],
                                    "t": 380.989
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.186,
                                                    -0.94
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.221,
                                                    -0.333
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.059,
                                                    -0.412
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.636,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.903,
                                                    0.094
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.202,
                                                    1.223
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.102,
                                                    0.238
                                                ],
                                                [
                                                    -0.047,
                                                    0.344
                                                ],
                                                [
                                                    -0.001,
                                                    0.004
                                                ],
                                                [
                                                    -0.001,
                                                    0.069
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.862,
                                                    0.217
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.011,
                                                    -0.313
                                                ],
                                                [
                                                    -0.62,
                                                    -0.692
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.381,
                                                    0.027
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.48,
                                                    -0.114
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.389,
                                                    0.308
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.483
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.247,
                                                    0.443
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.732,
                                                    0.204
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.942,
                                                    -0.286
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.175,
                                                    -0.221
                                                ],
                                                [
                                                    -0.153,
                                                    -0.363
                                                ],
                                                [
                                                    0.002,
                                                    -0.004
                                                ],
                                                [
                                                    0.013,
                                                    -0.038
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.248,
                                                    -0.51
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.882,
                                                    -0.222
                                                ],
                                                [
                                                    1.008,
                                                    0.313
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.365,
                                                    -0.101
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    19.054,
                                                    -6.03
                                                ],
                                                [
                                                    23.38,
                                                    -4.685
                                                ],
                                                [
                                                    23.381,
                                                    -4.685
                                                ],
                                                [
                                                    24.299,
                                                    -3.724
                                                ],
                                                [
                                                    24.389,
                                                    -3.581
                                                ],
                                                [
                                                    24.692,
                                                    -2.223
                                                ],
                                                [
                                                    24.542,
                                                    -1.728
                                                ],
                                                [
                                                    23.286,
                                                    -0.707
                                                ],
                                                [
                                                    22.989,
                                                    -0.613
                                                ],
                                                [
                                                    19.857,
                                                    0.251
                                                ],
                                                [
                                                    19.857,
                                                    0.252
                                                ],
                                                [
                                                    16.22,
                                                    1.26
                                                ],
                                                [
                                                    12.153,
                                                    2.387
                                                ],
                                                [
                                                    -3.01,
                                                    6.591
                                                ],
                                                [
                                                    -8.093,
                                                    7.999
                                                ],
                                                [
                                                    -8.093,
                                                    8
                                                ],
                                                [
                                                    -10.586,
                                                    8.153
                                                ],
                                                [
                                                    -10.974,
                                                    8.105
                                                ],
                                                [
                                                    -16.096,
                                                    5.669
                                                ],
                                                [
                                                    -16.325,
                                                    5.421
                                                ],
                                                [
                                                    -16.91,
                                                    4.696
                                                ],
                                                [
                                                    -20.724,
                                                    -0.294
                                                ],
                                                [
                                                    -20.729,
                                                    -0.302
                                                ],
                                                [
                                                    -24.169,
                                                    -4.634
                                                ],
                                                [
                                                    -24.564,
                                                    -5.309
                                                ],
                                                [
                                                    -24.704,
                                                    -6.361
                                                ],
                                                [
                                                    -24.698,
                                                    -6.373
                                                ],
                                                [
                                                    -24.673,
                                                    -6.537
                                                ],
                                                [
                                                    -24.556,
                                                    -6.874
                                                ],
                                                [
                                                    -22.889,
                                                    -8.024
                                                ],
                                                [
                                                    -22.889,
                                                    -8.025
                                                ],
                                                [
                                                    -19.937,
                                                    -7.867
                                                ],
                                                [
                                                    -17.392,
                                                    -6.315
                                                ],
                                                [
                                                    -15.352,
                                                    -3.749
                                                ],
                                                [
                                                    -15.352,
                                                    -3.748
                                                ],
                                                [
                                                    -11.023,
                                                    1.903
                                                ],
                                                [
                                                    -10.817,
                                                    2.172
                                                ],
                                                [
                                                    -10.492,
                                                    2.081
                                                ],
                                                [
                                                    3.694,
                                                    -1.864
                                                ],
                                                [
                                                    3.695,
                                                    -1.864
                                                ],
                                                [
                                                    6.74,
                                                    -2.721
                                                ],
                                                [
                                                    6.741,
                                                    -2.719
                                                ],
                                                [
                                                    17.948,
                                                    -5.825
                                                ],
                                                [
                                                    19.051,
                                                    -6.03
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.001,
                                                    -0.003
                                                ],
                                                [
                                                    0,
                                                    -0.002
                                                ],
                                                [
                                                    -0.008,
                                                    0.017
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.006,
                                                    0.015
                                                ],
                                                [
                                                    0.003,
                                                    -0.007
                                                ],
                                                [
                                                    -0.001,
                                                    0.004
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -24.723,
                                                    -6.31
                                                ],
                                                [
                                                    -24.735,
                                                    -6.282
                                                ],
                                                [
                                                    -24.72,
                                                    -6.32
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            43.74,
                                            21.817
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    20.836,
                                                    0.046
                                                ],
                                                [
                                                    0.083,
                                                    12.693
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -10.05,
                                                    -4.192
                                                ],
                                                [
                                                    -8.668,
                                                    -0.018
                                                ],
                                                [
                                                    -6.485,
                                                    2.653
                                                ],
                                                [
                                                    -0.967,
                                                    6.918
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.658,
                                                    11.763
                                                ],
                                                [
                                                    -21.979,
                                                    -0.046
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.046,
                                                    7.682
                                                ],
                                                [
                                                    6.558,
                                                    2.735
                                                ],
                                                [
                                                    8.575,
                                                    0.018
                                                ],
                                                [
                                                    9.276,
                                                    -3.786
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    39.738,
                                                    -21.513
                                                ],
                                                [
                                                    39.738,
                                                    2.676
                                                ],
                                                [
                                                    0.212,
                                                    23.604
                                                ],
                                                [
                                                    -39.738,
                                                    0.539
                                                ],
                                                [
                                                    -39.738,
                                                    -23.65
                                                ],
                                                [
                                                    -23.065,
                                                    -4.96
                                                ],
                                                [
                                                    0.203,
                                                    -0.585
                                                ],
                                                [
                                                    23.185,
                                                    -4.767
                                                ],
                                                [
                                                    39.729,
                                                    -21.513
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.437
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            40.456,
                                            45.389
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -12.647
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -10.049,
                                                    -4.191
                                                ],
                                                [
                                                    -8.668,
                                                    -0.019
                                                ],
                                                [
                                                    -6.485,
                                                    2.653
                                                ],
                                                [
                                                    -0.967,
                                                    6.918
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    20.928,
                                                    0.046
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -21.933,
                                                    -0.046
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.046,
                                                    7.683
                                                ],
                                                [
                                                    6.559,
                                                    2.736
                                                ],
                                                [
                                                    8.576,
                                                    0.018
                                                ],
                                                [
                                                    9.276,
                                                    -3.786
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.667,
                                                    -11.846
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.078,
                                                    -22.964
                                                ],
                                                [
                                                    -39.733,
                                                    -0.157
                                                ],
                                                [
                                                    -39.733,
                                                    -0.074
                                                ],
                                                [
                                                    -23.061,
                                                    18.616
                                                ],
                                                [
                                                    0.207,
                                                    22.992
                                                ],
                                                [
                                                    23.19,
                                                    18.81
                                                ],
                                                [
                                                    39.733,
                                                    2.063
                                                ],
                                                [
                                                    39.733,
                                                    -1.713
                                                ],
                                                [
                                                    -0.078,
                                                    -22.973
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.437
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            40.452,
                                            23.693
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "5 Outlines",
                    "sr": 1,
                    "st": -224,
                    "op": 651,
                    "ip": 63,
                    "ln": "34176",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                45,
                                33
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0,
                                        0
                                    ],
                                    "t": 62.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 82.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        98,
                                        98
                                    ],
                                    "t": 87.996
                                },
                                {
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 93.994
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                909.333,
                                1300.939
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    72.071,
                                                    65.164
                                                ],
                                                [
                                                    72.071,
                                                    51.514
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.231,
                                                    0.783
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.044,
                                                    -0.603
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.715,
                                                    1.568
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.158,
                                                    0.889
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.992,
                                                    -0.573
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.092,
                                                    -0.183
                                                ],
                                                [
                                                    -1.839,
                                                    1.062
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.231,
                                                    0.783
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.695,
                                                    1.556
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.182,
                                                    -0.682
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.271,
                                                    0.737
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.862,
                                                    0.498
                                                ],
                                                [
                                                    2.346,
                                                    0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.044,
                                                    -0.603
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    44.126,
                                                    3.661
                                                ],
                                                [
                                                    44.126,
                                                    17.313
                                                ],
                                                [
                                                    42.213,
                                                    19.447
                                                ],
                                                [
                                                    31.668,
                                                    25.535
                                                ],
                                                [
                                                    21.871,
                                                    25.514
                                                ],
                                                [
                                                    -42.114,
                                                    -11.428
                                                ],
                                                [
                                                    -44.126,
                                                    -13.865
                                                ],
                                                [
                                                    -44.118,
                                                    -14.719
                                                ],
                                                [
                                                    -44.01,
                                                    -27.091
                                                ],
                                                [
                                                    -42.114,
                                                    -25.079
                                                ],
                                                [
                                                    -35.209,
                                                    -21.092
                                                ],
                                                [
                                                    -26.197,
                                                    -15.89
                                                ],
                                                [
                                                    -20.881,
                                                    -12.82
                                                ],
                                                [
                                                    -13.892,
                                                    -8.784
                                                ],
                                                [
                                                    21.871,
                                                    11.863
                                                ],
                                                [
                                                    24.856,
                                                    12.884
                                                ],
                                                [
                                                    31.668,
                                                    11.884
                                                ],
                                                [
                                                    35.272,
                                                    9.803
                                                ],
                                                [
                                                    42.213,
                                                    5.796
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.661,
                                            38.485
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.131,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.131,
                                                    -0.447
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    44.085,
                                                    14.663
                                                ],
                                                [
                                                    44.085,
                                                    16.016
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.05,
                                                    -0.284
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.056,
                                                    0.284
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -44.167,
                                                    -15.162
                                                ],
                                                [
                                                    -44.159,
                                                    -16.016
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.703,
                                            39.781
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.257,
                                                    -0.727
                                                ],
                                                [
                                                    0.867,
                                                    0.021
                                                ],
                                                [
                                                    0.603,
                                                    0.348
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.032,
                                                    0.455
                                                ],
                                                [
                                                    -0.659,
                                                    0.38
                                                ],
                                                [
                                                    -0.824,
                                                    0
                                                ],
                                                [
                                                    -0.636,
                                                    -0.367
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.66,
                                                    0.381
                                                ],
                                                [
                                                    -0.788,
                                                    -0.018
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.605,
                                                    -0.348
                                                ],
                                                [
                                                    -0.034,
                                                    -0.501
                                                ],
                                                [
                                                    0.627,
                                                    -0.361
                                                ],
                                                [
                                                    0.824,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.268,
                                                    0.732
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    22.212,
                                                    12.898
                                                ],
                                                [
                                                    19.809,
                                                    13.438
                                                ],
                                                [
                                                    17.64,
                                                    12.889
                                                ],
                                                [
                                                    -22.482,
                                                    -10.277
                                                ],
                                                [
                                                    -23.435,
                                                    -11.53
                                                ],
                                                [
                                                    -22.5,
                                                    -12.916
                                                ],
                                                [
                                                    -20.229,
                                                    -13.459
                                                ],
                                                [
                                                    -17.928,
                                                    -12.907
                                                ],
                                                [
                                                    22.194,
                                                    10.257
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            50.868,
                                            29.506
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.858,
                                                    -0.495
                                                ],
                                                [
                                                    1.737,
                                                    1.004
                                                ],
                                                [
                                                    0,
                                                    0.658
                                                ],
                                                [
                                                    -0.858,
                                                    0.495
                                                ],
                                                [
                                                    -1.128,
                                                    0
                                                ],
                                                [
                                                    -0.873,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    -0.659
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.725,
                                                    0.996
                                                ],
                                                [
                                                    -0.873,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    -0.659
                                                ],
                                                [
                                                    0.859,
                                                    -0.496
                                                ],
                                                [
                                                    1.128,
                                                    0
                                                ],
                                                [
                                                    0.873,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0.658
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.147,
                                                    1.69
                                                ],
                                                [
                                                    -3.123,
                                                    1.676
                                                ],
                                                [
                                                    -4.435,
                                                    -0.146
                                                ],
                                                [
                                                    -3.147,
                                                    -1.943
                                                ],
                                                [
                                                    -0.033,
                                                    -2.686
                                                ],
                                                [
                                                    3.125,
                                                    -1.93
                                                ],
                                                [
                                                    4.434,
                                                    -0.107
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            18.996,
                                            11.623
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.064,
                                                    0.614
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.696,
                                                    -1.556
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.275,
                                                    -0.711
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.991,
                                                    -0.573
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.092,
                                                    -0.183
                                                ],
                                                [
                                                    -1.839,
                                                    1.062
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.231,
                                                    0.784
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.715,
                                                    -1.568
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.955,
                                                    0.551
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.272,
                                                    0.738
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.863,
                                                    0.498
                                                ],
                                                [
                                                    2.347,
                                                    0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.044,
                                                    -0.603
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    -0.793
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    42.119,
                                                    12.689
                                                ],
                                                [
                                                    -21.866,
                                                    -24.252
                                                ],
                                                [
                                                    -31.663,
                                                    -24.273
                                                ],
                                                [
                                                    -42.208,
                                                    -18.186
                                                ],
                                                [
                                                    -44.053,
                                                    -16.249
                                                ],
                                                [
                                                    -44.068,
                                                    -14.542
                                                ],
                                                [
                                                    -42.172,
                                                    -12.529
                                                ],
                                                [
                                                    -35.267,
                                                    -8.541
                                                ],
                                                [
                                                    -26.255,
                                                    -3.34
                                                ],
                                                [
                                                    -20.938,
                                                    -0.269
                                                ],
                                                [
                                                    -13.949,
                                                    3.766
                                                ],
                                                [
                                                    21.813,
                                                    24.413
                                                ],
                                                [
                                                    24.798,
                                                    25.434
                                                ],
                                                [
                                                    31.611,
                                                    24.434
                                                ],
                                                [
                                                    35.214,
                                                    22.353
                                                ],
                                                [
                                                    42.155,
                                                    18.346
                                                ],
                                                [
                                                    44.068,
                                                    16.211
                                                ],
                                                [
                                                    44.068,
                                                    14.858
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.858,
                                                    -0.495
                                                ],
                                                [
                                                    1.737,
                                                    1.003
                                                ],
                                                [
                                                    0,
                                                    0.659
                                                ],
                                                [
                                                    -0.858,
                                                    0.495
                                                ],
                                                [
                                                    -1.129,
                                                    0
                                                ],
                                                [
                                                    -0.873,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    -0.658
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.725,
                                                    0.996
                                                ],
                                                [
                                                    -0.873,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    -0.658
                                                ],
                                                [
                                                    0.86,
                                                    -0.495
                                                ],
                                                [
                                                    1.128,
                                                    0
                                                ],
                                                [
                                                    0.873,
                                                    0.505
                                                ],
                                                [
                                                    0,
                                                    0.659
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -22.119,
                                                    -12.676
                                                ],
                                                [
                                                    -28.39,
                                                    -12.689
                                                ],
                                                [
                                                    -29.701,
                                                    -14.512
                                                ],
                                                [
                                                    -28.414,
                                                    -16.309
                                                ],
                                                [
                                                    -25.299,
                                                    -17.052
                                                ],
                                                [
                                                    -22.142,
                                                    -16.296
                                                ],
                                                [
                                                    -20.832,
                                                    -14.473
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.257,
                                                    -0.727
                                                ],
                                                [
                                                    0.867,
                                                    0.021
                                                ],
                                                [
                                                    0.603,
                                                    0.348
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.032,
                                                    0.455
                                                ],
                                                [
                                                    -0.659,
                                                    0.38
                                                ],
                                                [
                                                    -0.823,
                                                    0
                                                ],
                                                [
                                                    -0.637,
                                                    -0.367
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.66,
                                                    0.381
                                                ],
                                                [
                                                    -0.787,
                                                    -0.018
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.605,
                                                    -0.348
                                                ],
                                                [
                                                    -0.034,
                                                    -0.501
                                                ],
                                                [
                                                    0.627,
                                                    -0.361
                                                ],
                                                [
                                                    0.824,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.268,
                                                    0.732
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    28.361,
                                                    16.47
                                                ],
                                                [
                                                    25.958,
                                                    17.01
                                                ],
                                                [
                                                    23.789,
                                                    16.461
                                                ],
                                                [
                                                    -16.333,
                                                    -6.705
                                                ],
                                                [
                                                    -17.286,
                                                    -7.958
                                                ],
                                                [
                                                    -16.351,
                                                    -9.344
                                                ],
                                                [
                                                    -14.08,
                                                    -9.887
                                                ],
                                                [
                                                    -11.778,
                                                    -9.335
                                                ],
                                                [
                                                    28.343,
                                                    13.829
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.719,
                                            25.934
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.132,
                                                    0.449
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.132,
                                                    -0.447
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    44.105,
                                                    14.876
                                                ],
                                                [
                                                    44.105,
                                                    16.229
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.206,
                                                    -0.562
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.216,
                                                    0.559
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -44.031,
                                                    -14.524
                                                ],
                                                [
                                                    -44.016,
                                                    -16.229
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.682,
                                            25.916
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 4
                },
                {
                    "ty": 4,
                    "nm": "4 Outlines",
                    "sr": 1,
                    "st": -232,
                    "op": 643,
                    "ip": 55,
                    "ln": "34175",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                43,
                                36.5
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0,
                                        0
                                    ],
                                    "t": 54.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 74.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        98,
                                        98
                                    ],
                                    "t": 79.996
                                },
                                {
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 85.994
                                }
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        801,
                                        1163
                                    ],
                                    "t": 68.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        801,
                                        1192
                                    ],
                                    "t": 127.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        801,
                                        1163
                                    ],
                                    "t": 187.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        801,
                                        1192
                                    ],
                                    "t": 246.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        801,
                                        1163
                                    ],
                                    "t": 307.992
                                },
                                {
                                    "s": [
                                        801,
                                        1192
                                    ],
                                    "t": 366.989
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.141,
                                                    -0.297
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.542,
                                                    -0.43
                                                ],
                                                [
                                                    2.276,
                                                    1.314
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.101,
                                                    1.095
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.517,
                                                    -0.884
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.69,
                                                    0.461
                                                ],
                                                [
                                                    -0.774,
                                                    1.69
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.031,
                                                    0.297
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.031,
                                                    0.297
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.775,
                                                    1.69
                                                ],
                                                [
                                                    -2.69,
                                                    0.461
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.517,
                                                    -0.876
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.101,
                                                    1.087
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.276,
                                                    1.314
                                                ],
                                                [
                                                    2.542,
                                                    -0.43
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.141,
                                                    -0.297
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    42.179,
                                                    -33.134
                                                ],
                                                [
                                                    42.179,
                                                    -10.828
                                                ],
                                                [
                                                    41.921,
                                                    -9.937
                                                ],
                                                [
                                                    23.886,
                                                    29.411
                                                ],
                                                [
                                                    18.395,
                                                    32.673
                                                ],
                                                [
                                                    10.332,
                                                    31.484
                                                ],
                                                [
                                                    -39.794,
                                                    2.546
                                                ],
                                                [
                                                    -42.179,
                                                    -0.512
                                                ],
                                                [
                                                    -42.179,
                                                    -22.818
                                                ],
                                                [
                                                    -39.794,
                                                    -19.76
                                                ],
                                                [
                                                    -19.216,
                                                    -7.88
                                                ],
                                                [
                                                    3.199,
                                                    5.064
                                                ],
                                                [
                                                    5.967,
                                                    6.66
                                                ],
                                                [
                                                    10.324,
                                                    9.178
                                                ],
                                                [
                                                    18.387,
                                                    10.367
                                                ],
                                                [
                                                    23.878,
                                                    7.105
                                                ],
                                                [
                                                    34.397,
                                                    -15.849
                                                ],
                                                [
                                                    41.913,
                                                    -32.243
                                                ],
                                                [
                                                    42.171,
                                                    -33.134
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            42.688,
                                            38.887
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.186,
                                                    -0.94
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.221,
                                                    -0.333
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.059,
                                                    -0.412
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.636,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.903,
                                                    0.094
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.202,
                                                    1.223
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.102,
                                                    0.238
                                                ],
                                                [
                                                    -0.047,
                                                    0.345
                                                ],
                                                [
                                                    -0.001,
                                                    0.004
                                                ],
                                                [
                                                    0,
                                                    0.069
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.862,
                                                    0.217
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.01,
                                                    -0.313
                                                ],
                                                [
                                                    -0.62,
                                                    -0.692
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.381,
                                                    0.027
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.48,
                                                    -0.114
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.389,
                                                    0.308
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.483
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.247,
                                                    0.443
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.732,
                                                    0.204
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.942,
                                                    -0.286
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.175,
                                                    -0.221
                                                ],
                                                [
                                                    -0.153,
                                                    -0.363
                                                ],
                                                [
                                                    0.002,
                                                    -0.003
                                                ],
                                                [
                                                    0.013,
                                                    -0.038
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.248,
                                                    -0.51
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.882,
                                                    -0.222
                                                ],
                                                [
                                                    1.009,
                                                    0.313
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.365,
                                                    -0.102
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    19.054,
                                                    -6.03
                                                ],
                                                [
                                                    23.38,
                                                    -4.685
                                                ],
                                                [
                                                    23.381,
                                                    -4.685
                                                ],
                                                [
                                                    24.299,
                                                    -3.724
                                                ],
                                                [
                                                    24.389,
                                                    -3.581
                                                ],
                                                [
                                                    24.692,
                                                    -2.223
                                                ],
                                                [
                                                    24.542,
                                                    -1.728
                                                ],
                                                [
                                                    23.286,
                                                    -0.707
                                                ],
                                                [
                                                    22.989,
                                                    -0.613
                                                ],
                                                [
                                                    19.857,
                                                    0.251
                                                ],
                                                [
                                                    19.857,
                                                    0.251
                                                ],
                                                [
                                                    16.22,
                                                    1.26
                                                ],
                                                [
                                                    12.153,
                                                    2.387
                                                ],
                                                [
                                                    -3.01,
                                                    6.591
                                                ],
                                                [
                                                    -8.093,
                                                    7.999
                                                ],
                                                [
                                                    -8.093,
                                                    8
                                                ],
                                                [
                                                    -10.586,
                                                    8.153
                                                ],
                                                [
                                                    -10.974,
                                                    8.105
                                                ],
                                                [
                                                    -16.096,
                                                    5.669
                                                ],
                                                [
                                                    -16.325,
                                                    5.421
                                                ],
                                                [
                                                    -16.91,
                                                    4.696
                                                ],
                                                [
                                                    -20.724,
                                                    -0.294
                                                ],
                                                [
                                                    -20.729,
                                                    -0.302
                                                ],
                                                [
                                                    -24.169,
                                                    -4.634
                                                ],
                                                [
                                                    -24.564,
                                                    -5.309
                                                ],
                                                [
                                                    -24.704,
                                                    -6.362
                                                ],
                                                [
                                                    -24.698,
                                                    -6.373
                                                ],
                                                [
                                                    -24.674,
                                                    -6.537
                                                ],
                                                [
                                                    -24.556,
                                                    -6.874
                                                ],
                                                [
                                                    -22.889,
                                                    -8.024
                                                ],
                                                [
                                                    -22.889,
                                                    -8.025
                                                ],
                                                [
                                                    -19.938,
                                                    -7.867
                                                ],
                                                [
                                                    -17.392,
                                                    -6.315
                                                ],
                                                [
                                                    -15.352,
                                                    -3.749
                                                ],
                                                [
                                                    -15.352,
                                                    -3.748
                                                ],
                                                [
                                                    -11.023,
                                                    1.903
                                                ],
                                                [
                                                    -10.817,
                                                    2.172
                                                ],
                                                [
                                                    -10.492,
                                                    2.081
                                                ],
                                                [
                                                    3.694,
                                                    -1.864
                                                ],
                                                [
                                                    3.695,
                                                    -1.864
                                                ],
                                                [
                                                    6.74,
                                                    -2.721
                                                ],
                                                [
                                                    6.741,
                                                    -2.719
                                                ],
                                                [
                                                    17.948,
                                                    -5.825
                                                ],
                                                [
                                                    19.051,
                                                    -6.03
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.001,
                                                    -0.003
                                                ],
                                                [
                                                    0,
                                                    -0.001
                                                ],
                                                [
                                                    -0.008,
                                                    0.017
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.006,
                                                    0.015
                                                ],
                                                [
                                                    0.003,
                                                    -0.006
                                                ],
                                                [
                                                    -0.002,
                                                    0.004
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -24.723,
                                                    -6.31
                                                ],
                                                [
                                                    -24.735,
                                                    -6.283
                                                ],
                                                [
                                                    -24.72,
                                                    -6.32
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            48.932,
                                            19.969
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.047,
                                                    0.031
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -5.776,
                                                    4.157
                                                ],
                                                [
                                                    -5.917,
                                                    4.071
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.187,
                                                    -1.9
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.517,
                                                    -0.883
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.69,
                                                    0.462
                                                ],
                                                [
                                                    -0.775,
                                                    1.689
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.031,
                                                    0.297
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.131,
                                                    -0.782
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.621,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.101,
                                                    1.087
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.276,
                                                    1.314
                                                ],
                                                [
                                                    2.542,
                                                    -0.43
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.141,
                                                    -0.297
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    -2.824
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    31.961,
                                                    -24.03
                                                ],
                                                [
                                                    -36.2,
                                                    -13.62
                                                ],
                                                [
                                                    -42.175,
                                                    -9.374
                                                ],
                                                [
                                                    -42.175,
                                                    -8.842
                                                ],
                                                [
                                                    -39.79,
                                                    -5.784
                                                ],
                                                [
                                                    -19.213,
                                                    6.097
                                                ],
                                                [
                                                    3.203,
                                                    19.041
                                                ],
                                                [
                                                    5.971,
                                                    20.636
                                                ],
                                                [
                                                    10.328,
                                                    23.154
                                                ],
                                                [
                                                    18.391,
                                                    24.343
                                                ],
                                                [
                                                    23.882,
                                                    21.082
                                                ],
                                                [
                                                    34.401,
                                                    -1.873
                                                ],
                                                [
                                                    41.917,
                                                    -18.266
                                                ],
                                                [
                                                    42.175,
                                                    -19.158
                                                ],
                                                [
                                                    42.175,
                                                    -19.783
                                                ],
                                                [
                                                    31.945,
                                                    -24.023
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            42.675,
                                            24.919
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.187,
                                                    -1.9
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.517,
                                                    -0.883
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.69,
                                                    0.462
                                                ],
                                                [
                                                    -0.775,
                                                    1.689
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.031,
                                                    0.297
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.131,
                                                    -0.782
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.621,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.101,
                                                    1.087
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.276,
                                                    1.314
                                                ],
                                                [
                                                    2.542,
                                                    -0.43
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.141,
                                                    -0.297
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    -2.824
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    31.961,
                                                    -24.03
                                                ],
                                                [
                                                    -36.2,
                                                    -13.62
                                                ],
                                                [
                                                    -42.175,
                                                    -9.374
                                                ],
                                                [
                                                    -42.175,
                                                    -8.842
                                                ],
                                                [
                                                    -39.79,
                                                    -5.784
                                                ],
                                                [
                                                    -19.213,
                                                    6.097
                                                ],
                                                [
                                                    3.203,
                                                    19.041
                                                ],
                                                [
                                                    5.971,
                                                    20.636
                                                ],
                                                [
                                                    10.328,
                                                    23.154
                                                ],
                                                [
                                                    18.391,
                                                    24.343
                                                ],
                                                [
                                                    23.882,
                                                    21.082
                                                ],
                                                [
                                                    34.401,
                                                    -1.873
                                                ],
                                                [
                                                    41.917,
                                                    -18.266
                                                ],
                                                [
                                                    42.175,
                                                    -19.158
                                                ],
                                                [
                                                    42.175,
                                                    -19.783
                                                ],
                                                [
                                                    31.945,
                                                    -24.023
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            42.675,
                                            24.919
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 5
                },
                {
                    "ty": 4,
                    "nm": "3 Outlines",
                    "sr": 1,
                    "st": -242,
                    "op": 633,
                    "ip": 45,
                    "ln": "34174",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                28,
                                24
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0,
                                        0
                                    ],
                                    "t": 45.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 65.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        98,
                                        98
                                    ],
                                    "t": 70.996
                                },
                                {
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 76.994
                                }
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        981.667,
                                        1180.818
                                    ],
                                    "t": 58.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        981.667,
                                        1157.818
                                    ],
                                    "t": 117.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        981.667,
                                        1180.818
                                    ],
                                    "t": 177.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        981.667,
                                        1157.818
                                    ],
                                    "t": 236.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        981.667,
                                        1180.818
                                    ],
                                    "t": 298.992
                                },
                                {
                                    "s": [
                                        981.667,
                                        1157.818
                                    ],
                                    "t": 357.989
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.775,
                                                    -0.614
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.133,
                                                    -0.178
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.031,
                                                    -0.237
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.513,
                                                    -0.141
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.598,
                                                    0.062
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.763,
                                                    0.878
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.039,
                                                    0.07
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.027,
                                                    0.205
                                                ],
                                                [
                                                    -0.003,
                                                    0.047
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.554,
                                                    0.14
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.665,
                                                    -0.206
                                                ],
                                                [
                                                    -0.398,
                                                    -0.441
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.245,
                                                    0.017
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.964,
                                                    -0.074
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.219,
                                                    0.173
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.171,
                                                    0.296
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.17,
                                                    0.297
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.473,
                                                    0.131
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.377,
                                                    -0.202
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.054,
                                                    -0.068
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.091,
                                                    -0.216
                                                ],
                                                [
                                                    0.009,
                                                    -0.03
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.142,
                                                    -0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    -0.142
                                                ],
                                                [
                                                    0.659,
                                                    0.205
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.242,
                                                    -0.067
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.965,
                                                    -3.938
                                                ],
                                                [
                                                    15.792,
                                                    -3.059
                                                ],
                                                [
                                                    15.793,
                                                    -3.059
                                                ],
                                                [
                                                    16.32,
                                                    -2.533
                                                ],
                                                [
                                                    16.439,
                                                    -2.354
                                                ],
                                                [
                                                    16.626,
                                                    -1.546
                                                ],
                                                [
                                                    16.533,
                                                    -1.24
                                                ],
                                                [
                                                    15.584,
                                                    -0.572
                                                ],
                                                [
                                                    15.583,
                                                    -0.572
                                                ],
                                                [
                                                    13.456,
                                                    0.015
                                                ],
                                                [
                                                    13.455,
                                                    0.015
                                                ],
                                                [
                                                    10.984,
                                                    0.7
                                                ],
                                                [
                                                    8.221,
                                                    1.466
                                                ],
                                                [
                                                    -2.082,
                                                    4.322
                                                ],
                                                [
                                                    -5.536,
                                                    5.28
                                                ],
                                                [
                                                    -7.168,
                                                    5.379
                                                ],
                                                [
                                                    -7.427,
                                                    5.346
                                                ],
                                                [
                                                    -10.962,
                                                    3.579
                                                ],
                                                [
                                                    -11.351,
                                                    3.099
                                                ],
                                                [
                                                    -13.947,
                                                    -0.298
                                                ],
                                                [
                                                    -13.953,
                                                    -0.305
                                                ],
                                                [
                                                    -16.29,
                                                    -3.249
                                                ],
                                                [
                                                    -16.429,
                                                    -3.455
                                                ],
                                                [
                                                    -16.536,
                                                    -3.671
                                                ],
                                                [
                                                    -16.619,
                                                    -4.294
                                                ],
                                                [
                                                    -16.599,
                                                    -4.411
                                                ],
                                                [
                                                    -16.531,
                                                    -4.606
                                                ],
                                                [
                                                    -15.506,
                                                    -5.298
                                                ],
                                                [
                                                    -15.507,
                                                    -5.299
                                                ],
                                                [
                                                    -13.588,
                                                    -5.194
                                                ],
                                                [
                                                    -11.936,
                                                    -4.192
                                                ],
                                                [
                                                    -10.547,
                                                    -2.444
                                                ],
                                                [
                                                    -7.61,
                                                    1.389
                                                ],
                                                [
                                                    -7.405,
                                                    1.657
                                                ],
                                                [
                                                    -7.08,
                                                    1.567
                                                ],
                                                [
                                                    2.559,
                                                    -1.113
                                                ],
                                                [
                                                    2.56,
                                                    -1.114
                                                ],
                                                [
                                                    4.631,
                                                    -1.695
                                                ],
                                                [
                                                    4.63,
                                                    -1.697
                                                ],
                                                [
                                                    12.243,
                                                    -3.805
                                                ],
                                                [
                                                    12.962,
                                                    -3.938
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.001,
                                                    -0.003
                                                ],
                                                [
                                                    0.001,
                                                    -0.002
                                                ],
                                                [
                                                    -0.008,
                                                    0.018
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.007,
                                                    0.016
                                                ],
                                                [
                                                    0.003,
                                                    -0.007
                                                ],
                                                [
                                                    -0.001,
                                                    0.003
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -16.643,
                                                    -4.229
                                                ],
                                                [
                                                    -16.657,
                                                    -4.198
                                                ],
                                                [
                                                    -16.641,
                                                    -4.238
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            29.943,
                                            15.056
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    14.157,
                                                    0.031
                                                ],
                                                [
                                                    0.056,
                                                    8.625
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -6.828,
                                                    -2.848
                                                ],
                                                [
                                                    -5.89,
                                                    -0.013
                                                ],
                                                [
                                                    -4.406,
                                                    1.803
                                                ],
                                                [
                                                    -0.657,
                                                    4.7
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.127,
                                                    7.992
                                                ],
                                                [
                                                    -14.933,
                                                    -0.031
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.031,
                                                    5.22
                                                ],
                                                [
                                                    4.456,
                                                    1.859
                                                ],
                                                [
                                                    5.827,
                                                    0.012
                                                ],
                                                [
                                                    6.303,
                                                    -2.572
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    27,
                                                    -14.617
                                                ],
                                                [
                                                    27,
                                                    1.818
                                                ],
                                                [
                                                    0.144,
                                                    16.038
                                                ],
                                                [
                                                    -27,
                                                    0.366
                                                ],
                                                [
                                                    -27,
                                                    -16.069
                                                ],
                                                [
                                                    -15.672,
                                                    -3.37
                                                ],
                                                [
                                                    0.138,
                                                    -0.397
                                                ],
                                                [
                                                    15.753,
                                                    -3.239
                                                ],
                                                [
                                                    26.994,
                                                    -14.617
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.437
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            27.718,
                                            31.071
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -8.594
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -6.828,
                                                    -2.848
                                                ],
                                                [
                                                    -5.89,
                                                    -0.013
                                                ],
                                                [
                                                    -4.406,
                                                    1.803
                                                ],
                                                [
                                                    -0.657,
                                                    4.7
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    14.22,
                                                    0.031
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -14.902,
                                                    -0.031
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.031,
                                                    5.22
                                                ],
                                                [
                                                    4.457,
                                                    1.859
                                                ],
                                                [
                                                    5.827,
                                                    0.012
                                                ],
                                                [
                                                    6.303,
                                                    -2.572
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.133,
                                                    -8.049
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.053,
                                                    -15.603
                                                ],
                                                [
                                                    -26.997,
                                                    -0.106
                                                ],
                                                [
                                                    -26.997,
                                                    -0.05
                                                ],
                                                [
                                                    -15.669,
                                                    12.649
                                                ],
                                                [
                                                    0.141,
                                                    15.622
                                                ],
                                                [
                                                    15.756,
                                                    12.78
                                                ],
                                                [
                                                    26.997,
                                                    1.402
                                                ],
                                                [
                                                    26.997,
                                                    -1.164
                                                ],
                                                [
                                                    -0.053,
                                                    -15.609
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.437
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            27.715,
                                            16.329
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 6
                },
                {
                    "ty": 4,
                    "nm": "2 Outlines",
                    "sr": 1,
                    "st": -254,
                    "op": 621,
                    "ip": 33,
                    "ln": "34173",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                18.5,
                                16
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0,
                                        0
                                    ],
                                    "t": 33.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 53.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        98,
                                        98
                                    ],
                                    "t": 58.996
                                },
                                {
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 64.994
                                }
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        928.207,
                                        1038
                                    ],
                                    "t": 46.996
                                },
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        928.074,
                                        1059
                                    ],
                                    "t": 105.993
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0.006
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        927.905,
                                        1050.588
                                    ],
                                    "t": 131.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        928.074,
                                        1038
                                    ],
                                    "t": 165.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        927.942,
                                        1059
                                    ],
                                    "t": 224.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        928.207,
                                        1038
                                    ],
                                    "t": 286.992
                                },
                                {
                                    "s": [
                                        927.942,
                                        1059
                                    ],
                                    "t": 345.989
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.533,
                                                    -0.342
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.091,
                                                    -0.123
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.018,
                                                    -0.146
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.349,
                                                    -0.096
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    0.045
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.549,
                                                    0.628
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.046,
                                                    0.105
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.017,
                                                    0.132
                                                ],
                                                [
                                                    -0.003,
                                                    0.03
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.298,
                                                    0.102
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.481,
                                                    -0.15
                                                ],
                                                [
                                                    -0.281,
                                                    -0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.172,
                                                    0.012
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.604,
                                                    -0.047
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.158,
                                                    0.124
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.114,
                                                    0.198
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.109,
                                                    0.185
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.336,
                                                    0.094
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.008,
                                                    -0.148
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.072,
                                                    -0.091
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.059,
                                                    -0.139
                                                ],
                                                [
                                                    0.006,
                                                    -0.022
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.077,
                                                    -0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.397,
                                                    -0.099
                                                ],
                                                [
                                                    0.479,
                                                    0.148
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.177,
                                                    -0.049
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.739,
                                                    -2.828
                                                ],
                                                [
                                                    11.552,
                                                    -2.352
                                                ],
                                                [
                                                    11.771,
                                                    -2.196
                                                ],
                                                [
                                                    12.143,
                                                    -1.825
                                                ],
                                                [
                                                    12.225,
                                                    -1.703
                                                ],
                                                [
                                                    12.349,
                                                    -1.183
                                                ],
                                                [
                                                    12.287,
                                                    -0.982
                                                ],
                                                [
                                                    11.659,
                                                    -0.552
                                                ],
                                                [
                                                    11.658,
                                                    -0.551
                                                ],
                                                [
                                                    10.064,
                                                    -0.112
                                                ],
                                                [
                                                    10.063,
                                                    -0.111
                                                ],
                                                [
                                                    8.212,
                                                    0.402
                                                ],
                                                [
                                                    6.141,
                                                    0.976
                                                ],
                                                [
                                                    -1.58,
                                                    3.116
                                                ],
                                                [
                                                    -4.168,
                                                    3.834
                                                ],
                                                [
                                                    -4.169,
                                                    3.834
                                                ],
                                                [
                                                    -5.346,
                                                    3.905
                                                ],
                                                [
                                                    -5.533,
                                                    3.881
                                                ],
                                                [
                                                    -8.103,
                                                    2.603
                                                ],
                                                [
                                                    -8.401,
                                                    2.234
                                                ],
                                                [
                                                    -8.402,
                                                    2.234
                                                ],
                                                [
                                                    -10.339,
                                                    -0.302
                                                ],
                                                [
                                                    -10.345,
                                                    -0.309
                                                ],
                                                [
                                                    -12.097,
                                                    -2.515
                                                ],
                                                [
                                                    -12.264,
                                                    -2.801
                                                ],
                                                [
                                                    -12.263,
                                                    -2.801
                                                ],
                                                [
                                                    -12.318,
                                                    -3.2
                                                ],
                                                [
                                                    -12.304,
                                                    -3.279
                                                ],
                                                [
                                                    -12.26,
                                                    -3.405
                                                ],
                                                [
                                                    -11.718,
                                                    -3.809
                                                ],
                                                [
                                                    -11.577,
                                                    -3.851
                                                ],
                                                [
                                                    -10.207,
                                                    -3.774
                                                ],
                                                [
                                                    -9.022,
                                                    -3.057
                                                ],
                                                [
                                                    -7.994,
                                                    -1.763
                                                ],
                                                [
                                                    -7.994,
                                                    -1.762
                                                ],
                                                [
                                                    -5.79,
                                                    1.116
                                                ],
                                                [
                                                    -5.584,
                                                    1.384
                                                ],
                                                [
                                                    -5.259,
                                                    1.293
                                                ],
                                                [
                                                    1.965,
                                                    -0.716
                                                ],
                                                [
                                                    1.966,
                                                    -0.717
                                                ],
                                                [
                                                    3.517,
                                                    -1.152
                                                ],
                                                [
                                                    9.222,
                                                    -2.732
                                                ],
                                                [
                                                    9.736,
                                                    -2.828
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.001,
                                                    -0.003
                                                ],
                                                [
                                                    0.001,
                                                    -0.002
                                                ],
                                                [
                                                    -0.014,
                                                    0.035
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.007,
                                                    0.018
                                                ],
                                                [
                                                    -0.009,
                                                    0.017
                                                ],
                                                [
                                                    -0.001,
                                                    0.004
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.343,
                                                    -3.125
                                                ],
                                                [
                                                    -12.358,
                                                    -3.092
                                                ],
                                                [
                                                    -12.341,
                                                    -3.136
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            19.989,
                                            10.197
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.307,
                                                    0.021
                                                ],
                                                [
                                                    0.037,
                                                    5.669
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -4.489,
                                                    -1.872
                                                ],
                                                [
                                                    -3.872,
                                                    -0.009
                                                ],
                                                [
                                                    -2.896,
                                                    1.185
                                                ],
                                                [
                                                    -0.432,
                                                    3.09
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.741,
                                                    5.254
                                                ],
                                                [
                                                    -9.818,
                                                    -0.02
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.021,
                                                    3.431
                                                ],
                                                [
                                                    2.93,
                                                    1.222
                                                ],
                                                [
                                                    3.83,
                                                    0.008
                                                ],
                                                [
                                                    4.144,
                                                    -1.691
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    17.75,
                                                    -9.61
                                                ],
                                                [
                                                    17.75,
                                                    1.195
                                                ],
                                                [
                                                    0.095,
                                                    10.543
                                                ],
                                                [
                                                    -17.75,
                                                    0.241
                                                ],
                                                [
                                                    -17.75,
                                                    -10.564
                                                ],
                                                [
                                                    -10.303,
                                                    -2.216
                                                ],
                                                [
                                                    0.091,
                                                    -0.261
                                                ],
                                                [
                                                    10.356,
                                                    -2.129
                                                ],
                                                [
                                                    17.746,
                                                    -9.61
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.437
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            18.468,
                                            20.673
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -5.649
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -4.489,
                                                    -1.872
                                                ],
                                                [
                                                    -3.872,
                                                    -0.008
                                                ],
                                                [
                                                    -2.896,
                                                    1.185
                                                ],
                                                [
                                                    -0.432,
                                                    3.09
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.348,
                                                    0.021
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -9.797,
                                                    -0.021
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.021,
                                                    3.432
                                                ],
                                                [
                                                    2.93,
                                                    1.222
                                                ],
                                                [
                                                    3.83,
                                                    0.008
                                                ],
                                                [
                                                    4.144,
                                                    -1.691
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.745,
                                                    -5.292
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.035,
                                                    -10.257
                                                ],
                                                [
                                                    -17.748,
                                                    -0.07
                                                ],
                                                [
                                                    -17.748,
                                                    -0.033
                                                ],
                                                [
                                                    -10.301,
                                                    8.315
                                                ],
                                                [
                                                    0.093,
                                                    10.27
                                                ],
                                                [
                                                    10.358,
                                                    8.402
                                                ],
                                                [
                                                    17.748,
                                                    0.922
                                                ],
                                                [
                                                    17.748,
                                                    -0.765
                                                ],
                                                [
                                                    -0.035,
                                                    -10.262
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.437
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            18.466,
                                            10.982
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 7
                },
                {
                    "ty": 4,
                    "nm": "1 copy Outlines",
                    "sr": 1,
                    "st": -272,
                    "op": 603,
                    "ip": 15,
                    "ln": "34172",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                36,
                                28
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0,
                                        0
                                    ],
                                    "t": 14.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        153,
                                        153
                                    ],
                                    "t": 38.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        113,
                                        113
                                    ],
                                    "t": 42.994
                                },
                                {
                                    "s": [
                                        153,
                                        153
                                    ],
                                    "t": 49.994
                                }
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        717.946,
                                        1001.167
                                    ],
                                    "t": 27.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        717.946,
                                        1017.167
                                    ],
                                    "t": 87.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        717.946,
                                        1001.167
                                    ],
                                    "t": 147.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        717.946,
                                        1017.167
                                    ],
                                    "t": 207.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        717.946,
                                        1001.167
                                    ],
                                    "t": 269.992
                                },
                                {
                                    "s": [
                                        717.946,
                                        1017.167
                                    ],
                                    "t": 326.989
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.123,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.666
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.183,
                                                    -0.285
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.345,
                                                    -0.634
                                                ],
                                                [
                                                    -0.217,
                                                    -0.322
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.656,
                                                    0.428
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.183,
                                                    -0.285
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.666
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.223,
                                                    0.676
                                                ],
                                                [
                                                    0.172,
                                                    0.317
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.624,
                                                    -2.036
                                                ],
                                                [
                                                    0.692,
                                                    1.597
                                                ],
                                                [
                                                    -0.069,
                                                    3.023
                                                ],
                                                [
                                                    -0.069,
                                                    8.437
                                                ],
                                                [
                                                    -3.819,
                                                    7.544
                                                ],
                                                [
                                                    -5.624,
                                                    5.954
                                                ],
                                                [
                                                    -5.624,
                                                    -8.437
                                                ],
                                                [
                                                    -3.819,
                                                    -6.847
                                                ],
                                                [
                                                    4.202,
                                                    -4.935
                                                ],
                                                [
                                                    5.036,
                                                    -2.997
                                                ],
                                                [
                                                    5.619,
                                                    -2.036
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            6.125,
                                            28.622
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.568,
                                                    0.18
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.342,
                                                    0.027
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.752,
                                                    0.284
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.678,
                                                    0.049
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.921,
                                                    -7.353
                                                ],
                                                [
                                                    4.921,
                                                    7.244
                                                ],
                                                [
                                                    3.012,
                                                    7.719
                                                ],
                                                [
                                                    -4.921,
                                                    7.119
                                                ],
                                                [
                                                    -4.921,
                                                    -7.746
                                                ],
                                                [
                                                    -0.202,
                                                    -7.391
                                                ],
                                                [
                                                    3.012,
                                                    -7.146
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            60.26,
                                            37.774
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.018,
                                                    -0.039
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.822,
                                                    -0.283
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.259,
                                                    0.521
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.012,
                                                    0.038
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.018,
                                                    0.039
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.127,
                                                    0.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.81,
                                                    -0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.018,
                                                    -0.039
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.812,
                                                    -11.952
                                                ],
                                                [
                                                    2.812,
                                                    3.144
                                                ],
                                                [
                                                    2.764,
                                                    3.26
                                                ],
                                                [
                                                    -1.113,
                                                    11.071
                                                ],
                                                [
                                                    -2.812,
                                                    11.952
                                                ],
                                                [
                                                    -2.812,
                                                    -2.872
                                                ],
                                                [
                                                    -1.113,
                                                    -4.019
                                                ],
                                                [
                                                    2.764,
                                                    -11.83
                                                ],
                                                [
                                                    2.812,
                                                    -11.946
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            67.993,
                                            33.543
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.165,
                                                    0.201
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.259,
                                                    -0.152
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.259,
                                                    -0.152
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.164,
                                                    0.2
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.103,
                                                    -4.905
                                                ],
                                                [
                                                    2.103,
                                                    9.843
                                                ],
                                                [
                                                    1.468,
                                                    9.317
                                                ],
                                                [
                                                    -2.109,
                                                    4.91
                                                ],
                                                [
                                                    -2.109,
                                                    -9.843
                                                ],
                                                [
                                                    -0.55,
                                                    -7.926
                                                ],
                                                [
                                                    1.474,
                                                    -5.441
                                                ],
                                                [
                                                    2.109,
                                                    -4.916
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            33.544,
                                            45.495
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.875,
                                                    0.361
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.366,
                                                    -0.162
                                                ],
                                                [
                                                    -0.544,
                                                    -0.054
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.969,
                                                    -0.194
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.36,
                                                    0.263
                                                ],
                                                [
                                                    0.521,
                                                    0.065
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.806,
                                                    -6.942
                                                ],
                                                [
                                                    2.806,
                                                    7.734
                                                ],
                                                [
                                                    -2.812,
                                                    6.942
                                                ],
                                                [
                                                    -2.812,
                                                    -7.733
                                                ],
                                                [
                                                    1.215,
                                                    -7.114
                                                ],
                                                [
                                                    2.812,
                                                    -6.942
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            28.622,
                                            41.98
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.77,
                                                    0.033
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.66,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.655,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.77,
                                                    0.033
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.218,
                                                    -9.154
                                                ],
                                                [
                                                    4.218,
                                                    5.855
                                                ],
                                                [
                                                    -2.027,
                                                    8.68
                                                ],
                                                [
                                                    -4.218,
                                                    9.121
                                                ],
                                                [
                                                    -4.218,
                                                    -5.888
                                                ],
                                                [
                                                    -2.027,
                                                    -6.328
                                                ],
                                                [
                                                    1.161,
                                                    -7.771
                                                ],
                                                [
                                                    4.035,
                                                    -9.071
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            21.592,
                                            43.4
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.486,
                                                    -0.021
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.463,
                                                    0.161
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    0.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.481,
                                                    -0.021
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    0.245
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.463,
                                                    0.156
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.624,
                                                    -3.656
                                                ],
                                                [
                                                    5.624,
                                                    10.546
                                                ],
                                                [
                                                    4.194,
                                                    10.275
                                                ],
                                                [
                                                    -5.249,
                                                    4.375
                                                ],
                                                [
                                                    -5.624,
                                                    3.656
                                                ],
                                                [
                                                    -5.624,
                                                    -10.546
                                                ],
                                                [
                                                    -5.249,
                                                    -9.826
                                                ],
                                                [
                                                    4.194,
                                                    -3.927
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            11.749,
                                            41.98
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 8",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.191,
                                                    -0.185
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.777,
                                                    0.511
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.016,
                                                    0.006
                                                ],
                                                [
                                                    -0.107,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.234,
                                                    0.658
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.234,
                                                    0.657
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.192,
                                                    0.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.101,
                                                    -0.011
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.192,
                                                    -0.185
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.14,
                                                    -9.199
                                                ],
                                                [
                                                    9.14,
                                                    5.608
                                                ],
                                                [
                                                    6.917,
                                                    7.004
                                                ],
                                                [
                                                    -5.975,
                                                    9.015
                                                ],
                                                [
                                                    -9.14,
                                                    8.471
                                                ],
                                                [
                                                    -9.14,
                                                    -6.292
                                                ],
                                                [
                                                    -9.092,
                                                    -6.298
                                                ],
                                                [
                                                    -8.783,
                                                    -6.32
                                                ],
                                                [
                                                    -1.119,
                                                    -6.542
                                                ],
                                                [
                                                    0.322,
                                                    -6.765
                                                ],
                                                [
                                                    4.885,
                                                    -7.477
                                                ],
                                                [
                                                    6.911,
                                                    -7.792
                                                ],
                                                [
                                                    9.134,
                                                    -9.189
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.792,
                                            46.258
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 9",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.75,
                                                    -0.539
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.025,
                                                    0.2
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.874,
                                                    0.855
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.665,
                                                    0.65
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.049,
                                                    -0.188
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.072,
                                                    -0.694
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.402,
                                                    -8.437
                                                ],
                                                [
                                                    1.402,
                                                    6.693
                                                ],
                                                [
                                                    -0.677,
                                                    8.437
                                                ],
                                                [
                                                    -0.677,
                                                    -0.714
                                                ],
                                                [
                                                    -0.637,
                                                    -1.302
                                                ],
                                                [
                                                    -0.677,
                                                    -1.563
                                                ],
                                                [
                                                    -1.406,
                                                    -6.194
                                                ],
                                                [
                                                    1.406,
                                                    -8.431
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            53.932,
                                            38.464
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 10",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.016,
                                                    0.011
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.016,
                                                    0.006
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.016,
                                                    -0.011
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.705,
                                                    -6.327
                                                ],
                                                [
                                                    5.705,
                                                    -6.287
                                                ],
                                                [
                                                    5.753,
                                                    -6.293
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.037,
                                                    -0.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.042,
                                                    0.185
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -23.876,
                                                    -0.919
                                                ],
                                                [
                                                    -23.876,
                                                    -1.472
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.031,
                                                    0.207
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    -0.195
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    23.887,
                                                    5.717
                                                ],
                                                [
                                                    23.834,
                                                    5.446
                                                ],
                                                [
                                                    23.834,
                                                    6.327
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            30.031,
                                            46.198
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 11",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.245,
                                                    0.036
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.047,
                                                    -0.63
                                                ],
                                                [
                                                    1.067,
                                                    -0.114
                                                ],
                                                [
                                                    0.1,
                                                    -0.005
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.172,
                                                    0.021
                                                ],
                                                [
                                                    -0.058,
                                                    0.713
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.058,
                                                    -0.713
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.219,
                                                    -0.031
                                                ],
                                                [
                                                    0.047,
                                                    0.615
                                                ],
                                                [
                                                    -0.094,
                                                    0.01
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.057,
                                                    0.682
                                                ],
                                                [
                                                    -1.097,
                                                    -0.015
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.437,
                                                    -4.21
                                                ],
                                                [
                                                    -13.264,
                                                    -6.297
                                                ],
                                                [
                                                    -11.037,
                                                    -7.537
                                                ],
                                                [
                                                    -0.105,
                                                    -7.831
                                                ],
                                                [
                                                    2.117,
                                                    -6.628
                                                ],
                                                [
                                                    0.362,
                                                    -5.336
                                                ],
                                                [
                                                    0.068,
                                                    -5.316
                                                ],
                                                [
                                                    -7.449,
                                                    -5.104
                                                ],
                                                [
                                                    -8.925,
                                                    -4.882
                                                ],
                                                [
                                                    -9.356,
                                                    0.036
                                                ],
                                                [
                                                    -11.615,
                                                    1.198
                                                ],
                                                [
                                                    -13.779,
                                                    -0.052
                                                ],
                                                [
                                                    -13.432,
                                                    -4.21
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.282,
                                                    -0.036
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.058,
                                                    0.635
                                                ],
                                                [
                                                    -0.042,
                                                    0.103
                                                ],
                                                [
                                                    -1.019,
                                                    0.025
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.187,
                                                    -0.025
                                                ],
                                                [
                                                    -0.184,
                                                    -0.036
                                                ],
                                                [
                                                    0.047,
                                                    -0.568
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    0.728
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.251,
                                                    0.036
                                                ],
                                                [
                                                    -0.01,
                                                    -0.109
                                                ],
                                                [
                                                    0.194,
                                                    -0.532
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    -0.698
                                                ],
                                                [
                                                    0.194,
                                                    0
                                                ],
                                                [
                                                    0.877,
                                                    0.161
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    13.789,
                                                    0.057
                                                ],
                                                [
                                                    13.275,
                                                    6.261
                                                ],
                                                [
                                                    11.037,
                                                    7.532
                                                ],
                                                [
                                                    8.92,
                                                    7.589
                                                ],
                                                [
                                                    2.064,
                                                    7.775
                                                ],
                                                [
                                                    0.137,
                                                    7.826
                                                ],
                                                [
                                                    -2.112,
                                                    6.623
                                                ],
                                                [
                                                    -2.064,
                                                    6.297
                                                ],
                                                [
                                                    -0.063,
                                                    5.316
                                                ],
                                                [
                                                    8.915,
                                                    5.063
                                                ],
                                                [
                                                    9.351,
                                                    0.083
                                                ],
                                                [
                                                    9.361,
                                                    -0.036
                                                ],
                                                [
                                                    11.667,
                                                    -1.204
                                                ],
                                                [
                                                    12.24,
                                                    -1.142
                                                ],
                                                [
                                                    13.784,
                                                    0.057
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.651,
                                                    0.588
                                                ],
                                                [
                                                    -1.082,
                                                    0.371
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.578,
                                                    -0.548
                                                ],
                                                [
                                                    1.067,
                                                    -0.362
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.103,
                                                    0.377
                                                ],
                                                [
                                                    -0.641,
                                                    -0.574
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.045,
                                                    -0.357
                                                ],
                                                [
                                                    0.609,
                                                    0.583
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    13.201,
                                                    -3.053
                                                ],
                                                [
                                                    5.579,
                                                    -0.439
                                                ],
                                                [
                                                    -10.827,
                                                    5.181
                                                ],
                                                [
                                                    -13.91,
                                                    4.784
                                                ],
                                                [
                                                    -13.201,
                                                    3.038
                                                ],
                                                [
                                                    2.789,
                                                    -2.438
                                                ],
                                                [
                                                    10.958,
                                                    -5.238
                                                ],
                                                [
                                                    13.942,
                                                    -4.778
                                                ],
                                                [
                                                    13.206,
                                                    -3.058
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            35.845,
                                            19.581
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 12",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.908,
                                                    0.227
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.614,
                                                    0.945
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.541,
                                                    0.604
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.087,
                                                    -0.382
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.744,
                                                    0.191
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.497,
                                                    -0.222
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.079,
                                                    -0.837
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.135,
                                                    -0.796
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    -0.811
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.16
                                                ],
                                                [
                                                    -1.119,
                                                    -0.279
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.325,
                                                    -0.62
                                                ],
                                                [
                                                    -0.205,
                                                    -0.315
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.115,
                                                    -0.481
                                                ],
                                                [
                                                    -0.21,
                                                    -0.228
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.531,
                                                    -0.021
                                                ],
                                                [
                                                    -0.662,
                                                    0.315
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.213,
                                                    -0.155
                                                ],
                                                [
                                                    -0.483,
                                                    -0.051
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.231,
                                                    -0.145
                                                ],
                                                [
                                                    -0.016,
                                                    -0.01
                                                ],
                                                [
                                                    -0.105,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.232,
                                                    0.625
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.14,
                                                    0.796
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.567,
                                                    0.171
                                                ],
                                                [
                                                    -0.226,
                                                    0.486
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.011,
                                                    0.036
                                                ],
                                                [
                                                    0.073,
                                                    0.212
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.173,
                                                    -0.527
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    -0.991
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.667,
                                                    -0.62
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.098,
                                                    -0.325
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.675,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.62,
                                                    -0.811
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.47,
                                                    0.223
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.397,
                                                    0.646
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.35,
                                                    -0.062
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.074,
                                                    0.161
                                                ],
                                                [
                                                    0,
                                                    0.651
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    0.661
                                                ],
                                                [
                                                    0.163,
                                                    0.31
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.62,
                                                    0.419
                                                ],
                                                [
                                                    0.058,
                                                    0.248
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.505,
                                                    0.154
                                                ],
                                                [
                                                    0.772,
                                                    0.031
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.208,
                                                    0.253
                                                ],
                                                [
                                                    0.462,
                                                    0.062
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.147,
                                                    0.191
                                                ],
                                                [
                                                    0.016,
                                                    0.01
                                                ],
                                                [
                                                    0.1,
                                                    -0.01
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.176,
                                                    -0.175
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.397,
                                                    -0.646
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.678,
                                                    0.046
                                                ],
                                                [
                                                    0.709,
                                                    -0.217
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.016,
                                                    -0.036
                                                ],
                                                [
                                                    0.073,
                                                    -0.217
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    35.093,
                                                    1.072
                                                ],
                                                [
                                                    33.418,
                                                    -0.152
                                                ],
                                                [
                                                    25.837,
                                                    -2.028
                                                ],
                                                [
                                                    24.498,
                                                    -4.858
                                                ],
                                                [
                                                    29.436,
                                                    -8.619
                                                ],
                                                [
                                                    29.462,
                                                    -10.52
                                                ],
                                                [
                                                    19.161,
                                                    -16.368
                                                ],
                                                [
                                                    15.778,
                                                    -16.368
                                                ],
                                                [
                                                    9.153,
                                                    -13.568
                                                ],
                                                [
                                                    4.158,
                                                    -14.327
                                                ],
                                                [
                                                    0.959,
                                                    -18.532
                                                ],
                                                [
                                                    -2.729,
                                                    -19.545
                                                ],
                                                [
                                                    -15.468,
                                                    -17.634
                                                ],
                                                [
                                                    -17.721,
                                                    -15.81
                                                ],
                                                [
                                                    -16.702,
                                                    -11.202
                                                ],
                                                [
                                                    -20.364,
                                                    -9.12
                                                ],
                                                [
                                                    -28.396,
                                                    -9.694
                                                ],
                                                [
                                                    -31.616,
                                                    -8.521
                                                ],
                                                [
                                                    -35.051,
                                                    -1.186
                                                ],
                                                [
                                                    -35.161,
                                                    -0.7
                                                ],
                                                [
                                                    -33.454,
                                                    0.855
                                                ],
                                                [
                                                    -25.869,
                                                    2.725
                                                ],
                                                [
                                                    -25.081,
                                                    4.621
                                                ],
                                                [
                                                    -24.529,
                                                    5.561
                                                ],
                                                [
                                                    -29.194,
                                                    9.115
                                                ],
                                                [
                                                    -29.914,
                                                    10.51
                                                ],
                                                [
                                                    -29.504,
                                                    11.223
                                                ],
                                                [
                                                    -19.203,
                                                    17.071
                                                ],
                                                [
                                                    -17.642,
                                                    17.339
                                                ],
                                                [
                                                    -15.447,
                                                    16.926
                                                ],
                                                [
                                                    -12.253,
                                                    15.572
                                                ],
                                                [
                                                    -9.374,
                                                    14.353
                                                ],
                                                [
                                                    -9.19,
                                                    14.276
                                                ],
                                                [
                                                    -5.613,
                                                    14.87
                                                ],
                                                [
                                                    -4.195,
                                                    15.035
                                                ],
                                                [
                                                    -2.802,
                                                    16.864
                                                ],
                                                [
                                                    -0.995,
                                                    19.235
                                                ],
                                                [
                                                    -0.428,
                                                    19.736
                                                ],
                                                [
                                                    -0.381,
                                                    19.767
                                                ],
                                                [
                                                    -0.076,
                                                    19.746
                                                ],
                                                [
                                                    7.494,
                                                    19.535
                                                ],
                                                [
                                                    8.917,
                                                    19.323
                                                ],
                                                [
                                                    13.424,
                                                    18.646
                                                ],
                                                [
                                                    15.426,
                                                    18.346
                                                ],
                                                [
                                                    17.622,
                                                    17.019
                                                ],
                                                [
                                                    17.622,
                                                    16.228
                                                ],
                                                [
                                                    16.671,
                                                    11.92
                                                ],
                                                [
                                                    20.337,
                                                    9.838
                                                ],
                                                [
                                                    25.049,
                                                    10.174
                                                ],
                                                [
                                                    28.259,
                                                    10.407
                                                ],
                                                [
                                                    30.166,
                                                    10.21
                                                ],
                                                [
                                                    31.653,
                                                    9.141
                                                ],
                                                [
                                                    35.046,
                                                    1.857
                                                ],
                                                [
                                                    35.088,
                                                    1.749
                                                ],
                                                [
                                                    35.088,
                                                    1.098
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            35.661,
                                            20.104
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 13",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    27.231,
                                                    15.967
                                                ],
                                                [
                                                    27.216,
                                                    15.967
                                                ],
                                                [
                                                    28.622,
                                                    15.967
                                                ],
                                                [
                                                    27.226,
                                                    15.967
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 8
                },
                {
                    "ty": 4,
                    "nm": "1 copy Outlines",
                    "sr": 1,
                    "st": -272,
                    "op": 603,
                    "ip": 15,
                    "ln": "34171",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                36,
                                28
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0,
                                        0
                                    ],
                                    "t": 14.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        153,
                                        153
                                    ],
                                    "t": 38.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        113,
                                        113
                                    ],
                                    "t": 42.994
                                },
                                {
                                    "s": [
                                        153,
                                        153
                                    ],
                                    "t": 49.994
                                }
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        717.946,
                                        1001.167
                                    ],
                                    "t": 27.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        717.946,
                                        1017.167
                                    ],
                                    "t": 87.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        717.946,
                                        1001.167
                                    ],
                                    "t": 147.993
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        717.946,
                                        1017.167
                                    ],
                                    "t": 207.992
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        717.946,
                                        1001.167
                                    ],
                                    "t": 269.992
                                },
                                {
                                    "s": [
                                        717.946,
                                        1017.167
                                    ],
                                    "t": 326.989
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.123,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.666
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.183,
                                                    -0.285
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.345,
                                                    -0.634
                                                ],
                                                [
                                                    -0.217,
                                                    -0.322
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.656,
                                                    0.428
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.183,
                                                    -0.285
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.666
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.223,
                                                    0.676
                                                ],
                                                [
                                                    0.172,
                                                    0.317
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.624,
                                                    -2.036
                                                ],
                                                [
                                                    0.692,
                                                    1.597
                                                ],
                                                [
                                                    -0.069,
                                                    3.023
                                                ],
                                                [
                                                    -0.069,
                                                    8.437
                                                ],
                                                [
                                                    -3.819,
                                                    7.544
                                                ],
                                                [
                                                    -5.624,
                                                    5.954
                                                ],
                                                [
                                                    -5.624,
                                                    -8.437
                                                ],
                                                [
                                                    -3.819,
                                                    -6.847
                                                ],
                                                [
                                                    4.202,
                                                    -4.935
                                                ],
                                                [
                                                    5.036,
                                                    -2.997
                                                ],
                                                [
                                                    5.619,
                                                    -2.036
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            6.125,
                                            28.622
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.568,
                                                    0.18
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.342,
                                                    0.027
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.752,
                                                    0.284
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.678,
                                                    0.049
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.921,
                                                    -7.353
                                                ],
                                                [
                                                    4.921,
                                                    7.244
                                                ],
                                                [
                                                    3.012,
                                                    7.719
                                                ],
                                                [
                                                    -4.921,
                                                    7.119
                                                ],
                                                [
                                                    -4.921,
                                                    -7.746
                                                ],
                                                [
                                                    -0.202,
                                                    -7.391
                                                ],
                                                [
                                                    3.012,
                                                    -7.146
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            60.26,
                                            37.774
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.018,
                                                    -0.039
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.822,
                                                    -0.283
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.259,
                                                    0.521
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.012,
                                                    0.038
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.018,
                                                    0.039
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.127,
                                                    0.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.81,
                                                    -0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.018,
                                                    -0.039
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.812,
                                                    -11.952
                                                ],
                                                [
                                                    2.812,
                                                    3.144
                                                ],
                                                [
                                                    2.764,
                                                    3.26
                                                ],
                                                [
                                                    -1.113,
                                                    11.071
                                                ],
                                                [
                                                    -2.812,
                                                    11.952
                                                ],
                                                [
                                                    -2.812,
                                                    -2.872
                                                ],
                                                [
                                                    -1.113,
                                                    -4.019
                                                ],
                                                [
                                                    2.764,
                                                    -11.83
                                                ],
                                                [
                                                    2.812,
                                                    -11.946
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            67.993,
                                            33.543
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.165,
                                                    0.201
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.259,
                                                    -0.152
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.259,
                                                    -0.152
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.164,
                                                    0.2
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.103,
                                                    -4.905
                                                ],
                                                [
                                                    2.103,
                                                    9.843
                                                ],
                                                [
                                                    1.468,
                                                    9.317
                                                ],
                                                [
                                                    -2.109,
                                                    4.91
                                                ],
                                                [
                                                    -2.109,
                                                    -9.843
                                                ],
                                                [
                                                    -0.55,
                                                    -7.926
                                                ],
                                                [
                                                    1.474,
                                                    -5.441
                                                ],
                                                [
                                                    2.109,
                                                    -4.916
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            33.544,
                                            45.495
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.875,
                                                    0.361
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.366,
                                                    -0.162
                                                ],
                                                [
                                                    -0.544,
                                                    -0.054
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.969,
                                                    -0.194
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.36,
                                                    0.263
                                                ],
                                                [
                                                    0.521,
                                                    0.065
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.806,
                                                    -6.942
                                                ],
                                                [
                                                    2.806,
                                                    7.734
                                                ],
                                                [
                                                    -2.812,
                                                    6.942
                                                ],
                                                [
                                                    -2.812,
                                                    -7.733
                                                ],
                                                [
                                                    1.215,
                                                    -7.114
                                                ],
                                                [
                                                    2.812,
                                                    -6.942
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            28.622,
                                            41.98
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.77,
                                                    0.033
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.66,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.655,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.77,
                                                    0.033
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.218,
                                                    -9.154
                                                ],
                                                [
                                                    4.218,
                                                    5.855
                                                ],
                                                [
                                                    -2.027,
                                                    8.68
                                                ],
                                                [
                                                    -4.218,
                                                    9.121
                                                ],
                                                [
                                                    -4.218,
                                                    -5.888
                                                ],
                                                [
                                                    -2.027,
                                                    -6.328
                                                ],
                                                [
                                                    1.161,
                                                    -7.771
                                                ],
                                                [
                                                    4.035,
                                                    -9.071
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            21.592,
                                            43.4
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.486,
                                                    -0.021
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.463,
                                                    0.161
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    0.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.481,
                                                    -0.021
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    0.245
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.463,
                                                    0.156
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.624,
                                                    -3.656
                                                ],
                                                [
                                                    5.624,
                                                    10.546
                                                ],
                                                [
                                                    4.194,
                                                    10.275
                                                ],
                                                [
                                                    -5.249,
                                                    4.375
                                                ],
                                                [
                                                    -5.624,
                                                    3.656
                                                ],
                                                [
                                                    -5.624,
                                                    -10.546
                                                ],
                                                [
                                                    -5.249,
                                                    -9.826
                                                ],
                                                [
                                                    4.194,
                                                    -3.927
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            11.749,
                                            41.98
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 8",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.191,
                                                    -0.185
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.777,
                                                    0.511
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.016,
                                                    0.006
                                                ],
                                                [
                                                    -0.107,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.234,
                                                    0.658
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.234,
                                                    0.657
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.192,
                                                    0.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.101,
                                                    -0.011
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.192,
                                                    -0.185
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.14,
                                                    -9.199
                                                ],
                                                [
                                                    9.14,
                                                    5.608
                                                ],
                                                [
                                                    6.917,
                                                    7.004
                                                ],
                                                [
                                                    -5.975,
                                                    9.015
                                                ],
                                                [
                                                    -9.14,
                                                    8.471
                                                ],
                                                [
                                                    -9.14,
                                                    -6.292
                                                ],
                                                [
                                                    -9.092,
                                                    -6.298
                                                ],
                                                [
                                                    -8.783,
                                                    -6.32
                                                ],
                                                [
                                                    -1.119,
                                                    -6.542
                                                ],
                                                [
                                                    0.322,
                                                    -6.765
                                                ],
                                                [
                                                    4.885,
                                                    -7.477
                                                ],
                                                [
                                                    6.911,
                                                    -7.792
                                                ],
                                                [
                                                    9.134,
                                                    -9.189
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.792,
                                            46.258
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 9",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.75,
                                                    -0.539
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.025,
                                                    0.2
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.874,
                                                    0.855
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.665,
                                                    0.65
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.049,
                                                    -0.188
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.072,
                                                    -0.694
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.402,
                                                    -8.437
                                                ],
                                                [
                                                    1.402,
                                                    6.693
                                                ],
                                                [
                                                    -0.677,
                                                    8.437
                                                ],
                                                [
                                                    -0.677,
                                                    -0.714
                                                ],
                                                [
                                                    -0.637,
                                                    -1.302
                                                ],
                                                [
                                                    -0.677,
                                                    -1.563
                                                ],
                                                [
                                                    -1.406,
                                                    -6.194
                                                ],
                                                [
                                                    1.406,
                                                    -8.431
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            53.932,
                                            38.464
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 10",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.016,
                                                    0.011
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.016,
                                                    0.006
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.016,
                                                    -0.011
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.705,
                                                    -6.327
                                                ],
                                                [
                                                    5.705,
                                                    -6.287
                                                ],
                                                [
                                                    5.753,
                                                    -6.293
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.037,
                                                    -0.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.042,
                                                    0.185
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -23.876,
                                                    -0.919
                                                ],
                                                [
                                                    -23.876,
                                                    -1.472
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.031,
                                                    0.207
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    -0.195
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    23.887,
                                                    5.717
                                                ],
                                                [
                                                    23.834,
                                                    5.446
                                                ],
                                                [
                                                    23.834,
                                                    6.327
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            30.031,
                                            46.198
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 11",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.245,
                                                    0.036
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.047,
                                                    -0.63
                                                ],
                                                [
                                                    1.067,
                                                    -0.114
                                                ],
                                                [
                                                    0.1,
                                                    -0.005
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.172,
                                                    0.021
                                                ],
                                                [
                                                    -0.058,
                                                    0.713
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.058,
                                                    -0.713
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.219,
                                                    -0.031
                                                ],
                                                [
                                                    0.047,
                                                    0.615
                                                ],
                                                [
                                                    -0.094,
                                                    0.01
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.057,
                                                    0.682
                                                ],
                                                [
                                                    -1.097,
                                                    -0.015
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.437,
                                                    -4.21
                                                ],
                                                [
                                                    -13.264,
                                                    -6.297
                                                ],
                                                [
                                                    -11.037,
                                                    -7.537
                                                ],
                                                [
                                                    -0.105,
                                                    -7.831
                                                ],
                                                [
                                                    2.117,
                                                    -6.628
                                                ],
                                                [
                                                    0.362,
                                                    -5.336
                                                ],
                                                [
                                                    0.068,
                                                    -5.316
                                                ],
                                                [
                                                    -7.449,
                                                    -5.104
                                                ],
                                                [
                                                    -8.925,
                                                    -4.882
                                                ],
                                                [
                                                    -9.356,
                                                    0.036
                                                ],
                                                [
                                                    -11.615,
                                                    1.198
                                                ],
                                                [
                                                    -13.779,
                                                    -0.052
                                                ],
                                                [
                                                    -13.432,
                                                    -4.21
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.282,
                                                    -0.036
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.058,
                                                    0.635
                                                ],
                                                [
                                                    -0.042,
                                                    0.103
                                                ],
                                                [
                                                    -1.019,
                                                    0.025
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.187,
                                                    -0.025
                                                ],
                                                [
                                                    -0.184,
                                                    -0.036
                                                ],
                                                [
                                                    0.047,
                                                    -0.568
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    0.728
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.251,
                                                    0.036
                                                ],
                                                [
                                                    -0.01,
                                                    -0.109
                                                ],
                                                [
                                                    0.194,
                                                    -0.532
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    -0.698
                                                ],
                                                [
                                                    0.194,
                                                    0
                                                ],
                                                [
                                                    0.877,
                                                    0.161
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    13.789,
                                                    0.057
                                                ],
                                                [
                                                    13.275,
                                                    6.261
                                                ],
                                                [
                                                    11.037,
                                                    7.532
                                                ],
                                                [
                                                    8.92,
                                                    7.589
                                                ],
                                                [
                                                    2.064,
                                                    7.775
                                                ],
                                                [
                                                    0.137,
                                                    7.826
                                                ],
                                                [
                                                    -2.112,
                                                    6.623
                                                ],
                                                [
                                                    -2.064,
                                                    6.297
                                                ],
                                                [
                                                    -0.063,
                                                    5.316
                                                ],
                                                [
                                                    8.915,
                                                    5.063
                                                ],
                                                [
                                                    9.351,
                                                    0.083
                                                ],
                                                [
                                                    9.361,
                                                    -0.036
                                                ],
                                                [
                                                    11.667,
                                                    -1.204
                                                ],
                                                [
                                                    12.24,
                                                    -1.142
                                                ],
                                                [
                                                    13.784,
                                                    0.057
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.651,
                                                    0.588
                                                ],
                                                [
                                                    -1.082,
                                                    0.371
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.578,
                                                    -0.548
                                                ],
                                                [
                                                    1.067,
                                                    -0.362
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.103,
                                                    0.377
                                                ],
                                                [
                                                    -0.641,
                                                    -0.574
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.045,
                                                    -0.357
                                                ],
                                                [
                                                    0.609,
                                                    0.583
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    13.201,
                                                    -3.053
                                                ],
                                                [
                                                    5.579,
                                                    -0.439
                                                ],
                                                [
                                                    -10.827,
                                                    5.181
                                                ],
                                                [
                                                    -13.91,
                                                    4.784
                                                ],
                                                [
                                                    -13.201,
                                                    3.038
                                                ],
                                                [
                                                    2.789,
                                                    -2.438
                                                ],
                                                [
                                                    10.958,
                                                    -5.238
                                                ],
                                                [
                                                    13.942,
                                                    -4.778
                                                ],
                                                [
                                                    13.206,
                                                    -3.058
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            35.845,
                                            19.581
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 12",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.908,
                                                    0.227
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.614,
                                                    0.945
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.541,
                                                    0.604
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.087,
                                                    -0.382
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.744,
                                                    0.191
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.497,
                                                    -0.222
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.079,
                                                    -0.837
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.135,
                                                    -0.796
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    -0.811
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.16
                                                ],
                                                [
                                                    -1.119,
                                                    -0.279
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.325,
                                                    -0.62
                                                ],
                                                [
                                                    -0.205,
                                                    -0.315
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.115,
                                                    -0.481
                                                ],
                                                [
                                                    -0.21,
                                                    -0.228
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.531,
                                                    -0.021
                                                ],
                                                [
                                                    -0.662,
                                                    0.315
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.213,
                                                    -0.155
                                                ],
                                                [
                                                    -0.483,
                                                    -0.051
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.231,
                                                    -0.145
                                                ],
                                                [
                                                    -0.016,
                                                    -0.01
                                                ],
                                                [
                                                    -0.105,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.232,
                                                    0.625
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.14,
                                                    0.796
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.567,
                                                    0.171
                                                ],
                                                [
                                                    -0.226,
                                                    0.486
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.011,
                                                    0.036
                                                ],
                                                [
                                                    0.073,
                                                    0.212
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.173,
                                                    -0.527
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    -0.991
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.667,
                                                    -0.62
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.098,
                                                    -0.325
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.675,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.62,
                                                    -0.811
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.47,
                                                    0.223
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.397,
                                                    0.646
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.35,
                                                    -0.062
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.074,
                                                    0.161
                                                ],
                                                [
                                                    0,
                                                    0.651
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    0.661
                                                ],
                                                [
                                                    0.163,
                                                    0.31
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.62,
                                                    0.419
                                                ],
                                                [
                                                    0.058,
                                                    0.248
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.505,
                                                    0.154
                                                ],
                                                [
                                                    0.772,
                                                    0.031
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.208,
                                                    0.253
                                                ],
                                                [
                                                    0.462,
                                                    0.062
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.147,
                                                    0.191
                                                ],
                                                [
                                                    0.016,
                                                    0.01
                                                ],
                                                [
                                                    0.1,
                                                    -0.01
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.176,
                                                    -0.175
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.397,
                                                    -0.646
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.678,
                                                    0.046
                                                ],
                                                [
                                                    0.709,
                                                    -0.217
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.016,
                                                    -0.036
                                                ],
                                                [
                                                    0.073,
                                                    -0.217
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    35.093,
                                                    1.072
                                                ],
                                                [
                                                    33.418,
                                                    -0.152
                                                ],
                                                [
                                                    25.837,
                                                    -2.028
                                                ],
                                                [
                                                    24.498,
                                                    -4.858
                                                ],
                                                [
                                                    29.436,
                                                    -8.619
                                                ],
                                                [
                                                    29.462,
                                                    -10.52
                                                ],
                                                [
                                                    19.161,
                                                    -16.368
                                                ],
                                                [
                                                    15.778,
                                                    -16.368
                                                ],
                                                [
                                                    9.153,
                                                    -13.568
                                                ],
                                                [
                                                    4.158,
                                                    -14.327
                                                ],
                                                [
                                                    0.959,
                                                    -18.532
                                                ],
                                                [
                                                    -2.729,
                                                    -19.545
                                                ],
                                                [
                                                    -15.468,
                                                    -17.634
                                                ],
                                                [
                                                    -17.721,
                                                    -15.81
                                                ],
                                                [
                                                    -16.702,
                                                    -11.202
                                                ],
                                                [
                                                    -20.364,
                                                    -9.12
                                                ],
                                                [
                                                    -28.396,
                                                    -9.694
                                                ],
                                                [
                                                    -31.616,
                                                    -8.521
                                                ],
                                                [
                                                    -35.051,
                                                    -1.186
                                                ],
                                                [
                                                    -35.161,
                                                    -0.7
                                                ],
                                                [
                                                    -33.454,
                                                    0.855
                                                ],
                                                [
                                                    -25.869,
                                                    2.725
                                                ],
                                                [
                                                    -25.081,
                                                    4.621
                                                ],
                                                [
                                                    -24.529,
                                                    5.561
                                                ],
                                                [
                                                    -29.194,
                                                    9.115
                                                ],
                                                [
                                                    -29.914,
                                                    10.51
                                                ],
                                                [
                                                    -29.504,
                                                    11.223
                                                ],
                                                [
                                                    -19.203,
                                                    17.071
                                                ],
                                                [
                                                    -17.642,
                                                    17.339
                                                ],
                                                [
                                                    -15.447,
                                                    16.926
                                                ],
                                                [
                                                    -12.253,
                                                    15.572
                                                ],
                                                [
                                                    -9.374,
                                                    14.353
                                                ],
                                                [
                                                    -9.19,
                                                    14.276
                                                ],
                                                [
                                                    -5.613,
                                                    14.87
                                                ],
                                                [
                                                    -4.195,
                                                    15.035
                                                ],
                                                [
                                                    -2.802,
                                                    16.864
                                                ],
                                                [
                                                    -0.995,
                                                    19.235
                                                ],
                                                [
                                                    -0.428,
                                                    19.736
                                                ],
                                                [
                                                    -0.381,
                                                    19.767
                                                ],
                                                [
                                                    -0.076,
                                                    19.746
                                                ],
                                                [
                                                    7.494,
                                                    19.535
                                                ],
                                                [
                                                    8.917,
                                                    19.323
                                                ],
                                                [
                                                    13.424,
                                                    18.646
                                                ],
                                                [
                                                    15.426,
                                                    18.346
                                                ],
                                                [
                                                    17.622,
                                                    17.019
                                                ],
                                                [
                                                    17.622,
                                                    16.228
                                                ],
                                                [
                                                    16.671,
                                                    11.92
                                                ],
                                                [
                                                    20.337,
                                                    9.838
                                                ],
                                                [
                                                    25.049,
                                                    10.174
                                                ],
                                                [
                                                    28.259,
                                                    10.407
                                                ],
                                                [
                                                    30.166,
                                                    10.21
                                                ],
                                                [
                                                    31.653,
                                                    9.141
                                                ],
                                                [
                                                    35.046,
                                                    1.857
                                                ],
                                                [
                                                    35.088,
                                                    1.749
                                                ],
                                                [
                                                    35.088,
                                                    1.098
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            35.661,
                                            20.104
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 13",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    27.231,
                                                    15.967
                                                ],
                                                [
                                                    27.216,
                                                    15.967
                                                ],
                                                [
                                                    28.622,
                                                    15.967
                                                ],
                                                [
                                                    27.226,
                                                    15.967
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 9
                },
                {
                    "ty": 0,
                    "nm": "1.svg",
                    "sr": 1,
                    "st": -286,
                    "op": 9714,
                    "ip": 0,
                    "ln": "34170",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                128,
                                99
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0,
                                        0
                                    ],
                                    "t": -0.004
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 19.996
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        98,
                                        98
                                    ],
                                    "t": 24.996
                                },
                                {
                                    "s": [
                                        111,
                                        111
                                    ],
                                    "t": 30.994
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                715.089,
                                1178.183
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 256,
                    "h": 198,
                    "refId": "11",
                    "ind": 10
                }
            ]
        },
        {
            "nm": "1.svg",
            "id": "11",
            "fr": 60,
            "layers": [
                {
                    "ty": 4,
                    "nm": "1.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 10000,
                    "ip": 0,
                    "ln": "34169",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                128,
                                99
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                128,
                                99
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -3.132,
                                                    0.088
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.572,
                                                    2.064
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.54
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.361,
                                                    -1.941
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.379,
                                                    -0.44
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -4.663,
                                                    0.129
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.361,
                                                    -1.941
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.54
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.167,
                                                    0.675
                                                ],
                                                [
                                                    2.832,
                                                    0.909
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    59.056,
                                                    9.155
                                                ],
                                                [
                                                    59.056,
                                                    58.42
                                                ],
                                                [
                                                    46.071,
                                                    55.517
                                                ],
                                                [
                                                    -54.012,
                                                    -2.264
                                                ],
                                                [
                                                    -59.056,
                                                    -9.284
                                                ],
                                                [
                                                    -59.056,
                                                    -58.549
                                                ],
                                                [
                                                    -54.012,
                                                    -51.529
                                                ],
                                                [
                                                    -23.462,
                                                    -33.893
                                                ],
                                                [
                                                    46.071,
                                                    6.252
                                                ],
                                                [
                                                    49.913,
                                                    7.924
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            59.556,
                                            138.522
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    2.511
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.308,
                                                    -1.906
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.064,
                                                    -0.111
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.742,
                                                    0.405
                                                ],
                                                [
                                                    -1.688,
                                                    0.974
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.511
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.096,
                                                    1.783
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.847,
                                                    -0.053
                                                ],
                                                [
                                                    2.087,
                                                    -0.475
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.308,
                                                    -1.906
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    68.413,
                                                    -64.364
                                                ],
                                                [
                                                    68.413,
                                                    -15.099
                                                ],
                                                [
                                                    63.458,
                                                    -8.178
                                                ],
                                                [
                                                    -57.253,
                                                    61.514
                                                ],
                                                [
                                                    -68.413,
                                                    64.364
                                                ],
                                                [
                                                    -68.413,
                                                    15.1
                                                ],
                                                [
                                                    -62.982,
                                                    14.419
                                                ],
                                                [
                                                    -57.253,
                                                    12.249
                                                ],
                                                [
                                                    -52.848,
                                                    9.71
                                                ],
                                                [
                                                    2.217,
                                                    -22.084
                                                ],
                                                [
                                                    32.82,
                                                    -39.755
                                                ],
                                                [
                                                    63.458,
                                                    -57.443
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            187.025,
                                            132.578
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.877,
                                                    -1.085
                                                ],
                                                [
                                                    1.894,
                                                    1.09
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.877,
                                                    1.085
                                                ],
                                                [
                                                    -1.895,
                                                    -1.091
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.883,
                                                    1.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.888,
                                                    -1.096
                                                ],
                                                [
                                                    1.883,
                                                    -1.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.888,
                                                    1.091
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    44.655,
                                                    25.782
                                                ],
                                                [
                                                    37.823,
                                                    25.771
                                                ],
                                                [
                                                    -5.061,
                                                    1.009
                                                ],
                                                [
                                                    -22.973,
                                                    -9.331
                                                ],
                                                [
                                                    -44.632,
                                                    -21.835
                                                ],
                                                [
                                                    -44.655,
                                                    -25.782
                                                ],
                                                [
                                                    -37.822,
                                                    -25.764
                                                ],
                                                [
                                                    -16.164,
                                                    -13.26
                                                ],
                                                [
                                                    1.742,
                                                    -2.921
                                                ],
                                                [
                                                    44.632,
                                                    21.841
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            102.2,
                                            89.052
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.877,
                                                    -1.085
                                                ],
                                                [
                                                    1.888,
                                                    1.091
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.883,
                                                    1.085
                                                ],
                                                [
                                                    -1.895,
                                                    -1.091
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.876,
                                                    1.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.895,
                                                    -1.091
                                                ],
                                                [
                                                    1.877,
                                                    -1.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.894,
                                                    1.091
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    44.655,
                                                    25.779
                                                ],
                                                [
                                                    37.829,
                                                    25.768
                                                ],
                                                [
                                                    -4.821,
                                                    1.141
                                                ],
                                                [
                                                    -22.726,
                                                    -9.193
                                                ],
                                                [
                                                    -44.625,
                                                    -21.837
                                                ],
                                                [
                                                    -44.649,
                                                    -25.779
                                                ],
                                                [
                                                    -37.822,
                                                    -25.767
                                                ],
                                                [
                                                    -15.923,
                                                    -13.122
                                                ],
                                                [
                                                    1.982,
                                                    -2.783
                                                ],
                                                [
                                                    44.632,
                                                    21.838
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            86.006,
                                            98.128
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.363,
                                                    -0.903
                                                ],
                                                [
                                                    0.663,
                                                    -0.381
                                                ],
                                                [
                                                    1.895,
                                                    1.091
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.882,
                                                    1.085
                                                ],
                                                [
                                                    -1.894,
                                                    -1.097
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.188,
                                                    0.493
                                                ],
                                                [
                                                    -1.877,
                                                    1.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.894,
                                                    -1.091
                                                ],
                                                [
                                                    1.877,
                                                    -1.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.231,
                                                    0.71
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    31.562,
                                                    16.078
                                                ],
                                                [
                                                    30.283,
                                                    17.415
                                                ],
                                                [
                                                    23.456,
                                                    17.404
                                                ],
                                                [
                                                    -7.885,
                                                    -0.695
                                                ],
                                                [
                                                    -30.019,
                                                    -13.474
                                                ],
                                                [
                                                    -30.043,
                                                    -17.415
                                                ],
                                                [
                                                    -23.216,
                                                    -17.398
                                                ],
                                                [
                                                    -1.082,
                                                    -4.618
                                                ],
                                                [
                                                    21.826,
                                                    8.606
                                                ],
                                                [
                                                    30.26,
                                                    13.474
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            55.208,
                                            98.838
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    5.829,
                                                    -3.367
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.87,
                                                    3.39
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -5.835,
                                                    3.367
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -5.871,
                                                    -3.39
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -5.829,
                                                    3.366
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -5.877,
                                                    -3.39
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.83,
                                                    -3.366
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.87,
                                                    3.39
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    61.631,
                                                    15.979
                                                ],
                                                [
                                                    60.129,
                                                    16.847
                                                ],
                                                [
                                                    45.491,
                                                    25.298
                                                ],
                                                [
                                                    38.688,
                                                    29.222
                                                ],
                                                [
                                                    29.521,
                                                    34.518
                                                ],
                                                [
                                                    27.679,
                                                    35.58
                                                ],
                                                [
                                                    6.49,
                                                    35.538
                                                ],
                                                [
                                                    -29.521,
                                                    14.747
                                                ],
                                                [
                                                    -47.426,
                                                    4.407
                                                ],
                                                [
                                                    -61.548,
                                                    -3.745
                                                ],
                                                [
                                                    -61.625,
                                                    -15.979
                                                ],
                                                [
                                                    -27.679,
                                                    -35.579
                                                ],
                                                [
                                                    -6.489,
                                                    -35.538
                                                ],
                                                [
                                                    61.555,
                                                    3.745
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            142.611,
                                            66.1
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.877,
                                                    1.085
                                                ],
                                                [
                                                    -1.894,
                                                    -1.096
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.882,
                                                    -1.085
                                                ],
                                                [
                                                    1.226,
                                                    0
                                                ],
                                                [
                                                    0.95,
                                                    0.545
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.882,
                                                    -1.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.894,
                                                    1.091
                                                ],
                                                [
                                                    -0.933,
                                                    0.539
                                                ],
                                                [
                                                    -1.226,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.896,
                                                    -1.097
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -10.527,
                                                    -5.938
                                                ],
                                                [
                                                    -3.695,
                                                    -5.921
                                                ],
                                                [
                                                    32.227,
                                                    14.817
                                                ],
                                                [
                                                    32.251,
                                                    18.759
                                                ],
                                                [
                                                    28.861,
                                                    19.568
                                                ],
                                                [
                                                    25.424,
                                                    18.747
                                                ],
                                                [
                                                    -10.497,
                                                    -1.991
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -3.753,
                                                    2.17
                                                ],
                                                [
                                                    -3.783,
                                                    -2.187
                                                ],
                                                [
                                                    3.753,
                                                    -2.17
                                                ],
                                                [
                                                    3.782,
                                                    2.188
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    3.76,
                                                    -2.17
                                                ],
                                                [
                                                    3.789,
                                                    2.182
                                                ],
                                                [
                                                    -3.76,
                                                    2.17
                                                ],
                                                [
                                                    -3.789,
                                                    -2.181
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -30.38,
                                                    -17.398
                                                ],
                                                [
                                                    -16.721,
                                                    -17.369
                                                ],
                                                [
                                                    -16.668,
                                                    -9.486
                                                ],
                                                [
                                                    -30.327,
                                                    -9.516
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            168.667,
                                            34.984
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 8",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    3.36,
                                                    1.941
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    6.645,
                                                    -3.836
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.51
                                                ],
                                                [
                                                    -3.36,
                                                    -1.942
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.38,
                                                    -0.44
                                                ],
                                                [
                                                    -3.132,
                                                    0.088
                                                ],
                                                [
                                                    -1.742,
                                                    0.405
                                                ],
                                                [
                                                    -1.689,
                                                    0.974
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.511
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -6.691,
                                                    -3.865
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.307,
                                                    1.906
                                                ],
                                                [
                                                    0,
                                                    2.511
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.168,
                                                    0.675
                                                ],
                                                [
                                                    2.832,
                                                    0.909
                                                ],
                                                [
                                                    1.847,
                                                    -0.052
                                                ],
                                                [
                                                    2.087,
                                                    -0.475
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.308,
                                                    -1.906
                                                ],
                                                [
                                                    0,
                                                    -2.51
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    122.426,
                                                    -12.451
                                                ],
                                                [
                                                    22.342,
                                                    -70.231
                                                ],
                                                [
                                                    -1.803,
                                                    -70.284
                                                ],
                                                [
                                                    -122.514,
                                                    -0.592
                                                ],
                                                [
                                                    -127.469,
                                                    6.328
                                                ],
                                                [
                                                    -122.426,
                                                    13.349
                                                ],
                                                [
                                                    -91.876,
                                                    30.985
                                                ],
                                                [
                                                    -22.343,
                                                    71.129
                                                ],
                                                [
                                                    -18.5,
                                                    72.801
                                                ],
                                                [
                                                    -9.357,
                                                    74.032
                                                ],
                                                [
                                                    -3.926,
                                                    73.352
                                                ],
                                                [
                                                    1.803,
                                                    71.182
                                                ],
                                                [
                                                    6.208,
                                                    68.643
                                                ],
                                                [
                                                    61.273,
                                                    36.849
                                                ],
                                                [
                                                    91.876,
                                                    19.178
                                                ],
                                                [
                                                    122.514,
                                                    1.49
                                                ],
                                                [
                                                    127.469,
                                                    -5.431
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.877,
                                                    1.085
                                                ],
                                                [
                                                    -1.894,
                                                    -1.096
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.882,
                                                    -1.085
                                                ],
                                                [
                                                    1.226,
                                                    0
                                                ],
                                                [
                                                    0.95,
                                                    0.545
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.882,
                                                    -1.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.895,
                                                    1.091
                                                ],
                                                [
                                                    -0.933,
                                                    0.539
                                                ],
                                                [
                                                    -1.226,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.894,
                                                    -1.097
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    30.624,
                                                    -44.625
                                                ],
                                                [
                                                    37.456,
                                                    -44.608
                                                ],
                                                [
                                                    73.378,
                                                    -23.87
                                                ],
                                                [
                                                    73.402,
                                                    -19.928
                                                ],
                                                [
                                                    70.012,
                                                    -19.119
                                                ],
                                                [
                                                    66.575,
                                                    -19.94
                                                ],
                                                [
                                                    30.652,
                                                    -40.678
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -3.753,
                                                    2.17
                                                ],
                                                [
                                                    -3.782,
                                                    -2.187
                                                ],
                                                [
                                                    3.754,
                                                    -2.17
                                                ],
                                                [
                                                    3.783,
                                                    2.188
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    3.758,
                                                    -2.17
                                                ],
                                                [
                                                    3.789,
                                                    2.182
                                                ],
                                                [
                                                    -3.759,
                                                    2.17
                                                ],
                                                [
                                                    -3.789,
                                                    -2.182
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    10.771,
                                                    -56.085
                                                ],
                                                [
                                                    24.43,
                                                    -56.056
                                                ],
                                                [
                                                    24.482,
                                                    -48.174
                                                ],
                                                [
                                                    10.824,
                                                    -48.203
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.364,
                                                    -0.903
                                                ],
                                                [
                                                    0.663,
                                                    -0.382
                                                ],
                                                [
                                                    1.894,
                                                    1.091
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.883,
                                                    1.085
                                                ],
                                                [
                                                    -1.895,
                                                    -1.097
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.187,
                                                    0.493
                                                ],
                                                [
                                                    -1.877,
                                                    1.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.895,
                                                    -1.091
                                                ],
                                                [
                                                    1.877,
                                                    -1.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.232,
                                                    0.709
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -41.198,
                                                    41.271
                                                ],
                                                [
                                                    -42.476,
                                                    42.609
                                                ],
                                                [
                                                    -49.303,
                                                    42.597
                                                ],
                                                [
                                                    -80.645,
                                                    24.498
                                                ],
                                                [
                                                    -102.778,
                                                    11.718
                                                ],
                                                [
                                                    -102.802,
                                                    7.777
                                                ],
                                                [
                                                    -95.975,
                                                    7.795
                                                ],
                                                [
                                                    -73.841,
                                                    20.574
                                                ],
                                                [
                                                    -50.933,
                                                    33.8
                                                ],
                                                [
                                                    -42.5,
                                                    38.668
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.877,
                                                    -1.085
                                                ],
                                                [
                                                    1.888,
                                                    1.09
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.883,
                                                    1.085
                                                ],
                                                [
                                                    -1.894,
                                                    -1.091
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.877,
                                                    1.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.894,
                                                    -1.091
                                                ],
                                                [
                                                    1.877,
                                                    -1.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.894,
                                                    1.091
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.695,
                                                    50.262
                                                ],
                                                [
                                                    -4.131,
                                                    50.251
                                                ],
                                                [
                                                    -46.781,
                                                    25.624
                                                ],
                                                [
                                                    -64.686,
                                                    15.29
                                                ],
                                                [
                                                    -86.586,
                                                    2.645
                                                ],
                                                [
                                                    -86.609,
                                                    -1.296
                                                ],
                                                [
                                                    -79.783,
                                                    -1.284
                                                ],
                                                [
                                                    -57.883,
                                                    11.36
                                                ],
                                                [
                                                    -39.978,
                                                    21.7
                                                ],
                                                [
                                                    2.672,
                                                    46.321
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.877,
                                                    -1.085
                                                ],
                                                [
                                                    1.895,
                                                    1.091
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.877,
                                                    1.085
                                                ],
                                                [
                                                    -1.894,
                                                    -1.091
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.883,
                                                    1.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.888,
                                                    -1.096
                                                ],
                                                [
                                                    1.882,
                                                    -1.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.888,
                                                    1.091
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.887,
                                                    41.189
                                                ],
                                                [
                                                    12.055,
                                                    41.178
                                                ],
                                                [
                                                    -30.829,
                                                    16.416
                                                ],
                                                [
                                                    -48.74,
                                                    6.076
                                                ],
                                                [
                                                    -70.399,
                                                    -6.428
                                                ],
                                                [
                                                    -70.422,
                                                    -10.375
                                                ],
                                                [
                                                    -63.59,
                                                    -10.357
                                                ],
                                                [
                                                    -41.931,
                                                    2.147
                                                ],
                                                [
                                                    -24.026,
                                                    12.487
                                                ],
                                                [
                                                    18.865,
                                                    37.248
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    5.829,
                                                    -3.367
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.871,
                                                    3.389
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -5.836,
                                                    3.367
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -5.87,
                                                    -3.39
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -5.83,
                                                    3.366
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -5.877,
                                                    -3.389
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.829,
                                                    -3.366
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.871,
                                                    3.39
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    76.276,
                                                    8.434
                                                ],
                                                [
                                                    74.773,
                                                    9.302
                                                ],
                                                [
                                                    60.135,
                                                    17.753
                                                ],
                                                [
                                                    53.331,
                                                    21.677
                                                ],
                                                [
                                                    44.165,
                                                    26.973
                                                ],
                                                [
                                                    42.323,
                                                    28.035
                                                ],
                                                [
                                                    21.133,
                                                    27.994
                                                ],
                                                [
                                                    -14.876,
                                                    7.202
                                                ],
                                                [
                                                    -32.782,
                                                    -3.137
                                                ],
                                                [
                                                    -46.904,
                                                    -11.29
                                                ],
                                                [
                                                    -46.98,
                                                    -23.524
                                                ],
                                                [
                                                    -13.035,
                                                    -43.124
                                                ],
                                                [
                                                    8.154,
                                                    -43.083
                                                ],
                                                [
                                                    76.199,
                                                    -3.8
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            127.969,
                                            73.645
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "Comp_67",
            "id": "12",
            "fr": 60,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Shape Layer 9",
                    "sr": 1,
                    "st": 0,
                    "op": 142,
                    "ip": 0,
                    "ln": "34143",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                170.977,
                                1.924
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        110.653,
                                        100
                                    ],
                                    "t": 0
                                },
                                {
                                    "s": [
                                        13.653,
                                        100
                                    ],
                                    "t": 98.997
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                2801.825,
                                900.424
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            1532.4,
                                            117.4
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            769.075,
                                            0.345
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            113.894,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            164.903,
                                            2.269
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 4",
                    "sr": 1,
                    "st": 0,
                    "op": 601,
                    "ip": 0,
                    "ln": "34142",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                3050,
                                861
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 20
                        }
                    },
                    "shapes": [
                        {
                            "ty": "rc",
                            "nm": "undefined",
                            "d": 1,
                            "p": {
                                "a": 0,
                                "k": [
                                    44,
                                    44
                                ]
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    88,
                                    88
                                ]
                            }
                        },
                        {
                            "ty": "fl",
                            "nm": "undefined",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 0
                            }
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 3",
                    "sr": 1,
                    "st": 0,
                    "op": 601,
                    "ip": 0,
                    "ln": "34141",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                133.33,
                                133.33
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                3050,
                                861
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 20
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "undefined",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "undefined",
                                    "it": [
                                        {
                                            "ty": "sh",
                                            "nm": "Path 1",
                                            "d": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "c": false,
                                                    "i": [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            44.01,
                                                            3.89
                                                        ],
                                                        [
                                                            44.01,
                                                            83.9
                                                        ]
                                                    ]
                                                }
                                            }
                                        },
                                        {
                                            "ty": "sh",
                                            "nm": "Path 2",
                                            "d": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "c": false,
                                                    "i": [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            84.01,
                                                            43.9
                                                        ],
                                                        [
                                                            4,
                                                            43.9
                                                        ]
                                                    ]
                                                }
                                            }
                                        },
                                        {
                                            "ty": "st",
                                            "nm": "undefined",
                                            "lc": 2,
                                            "lj": 1,
                                            "ml": 4,
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            },
                                            "w": {
                                                "a": 0,
                                                "k": 7.5
                                            },
                                            "c": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0,
                                                    0
                                                ]
                                            }
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    75,
                                                    75
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 2",
                    "sr": 1,
                    "st": 0,
                    "op": 9710,
                    "ip": 0,
                    "ln": "34140",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                3220,
                                861
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 20
                        }
                    },
                    "shapes": [
                        {
                            "ty": "rc",
                            "nm": "undefined",
                            "d": 1,
                            "p": {
                                "a": 0,
                                "k": [
                                    52,
                                    45.5
                                ]
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    104,
                                    91
                                ]
                            }
                        },
                        {
                            "ty": "fl",
                            "nm": "undefined",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 0
                            }
                        }
                    ],
                    "ind": 4
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 9710,
                    "ip": 0,
                    "ln": "34139",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                133.33,
                                133.33
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                3220,
                                861
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 20
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "undefined",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "undefined",
                                    "it": [
                                        {
                                            "ty": "sh",
                                            "nm": "Path 1",
                                            "d": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "c": false,
                                                    "i": [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            4.22,
                                                            4.22
                                                        ],
                                                        [
                                                            -4.24,
                                                            4.21
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -8.41,
                                                            -8.41
                                                        ],
                                                        [
                                                            8.42,
                                                            -8.41
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            14.15,
                                                            13.58
                                                        ],
                                                        [
                                                            -14.12,
                                                            14.12
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "o": [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -4.22,
                                                            4.22
                                                        ],
                                                        [
                                                            -4.23,
                                                            -4.23
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            8.41,
                                                            -8.41
                                                        ],
                                                        [
                                                            8.42,
                                                            8.41
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            -13.35,
                                                            13.91
                                                        ],
                                                        [
                                                            -13.97,
                                                            -13.41
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    "v": [
                                                        [
                                                            79.56,
                                                            25.81
                                                        ],
                                                        [
                                                            44.06,
                                                            61.31
                                                        ],
                                                        [
                                                            28.77,
                                                            61.31
                                                        ],
                                                        [
                                                            28.8,
                                                            46.01
                                                        ],
                                                        [
                                                            56.32,
                                                            18.64
                                                        ],
                                                        [
                                                            63.24,
                                                            11.72
                                                        ],
                                                        [
                                                            93.7,
                                                            11.72
                                                        ],
                                                        [
                                                            93.7,
                                                            42.18
                                                        ],
                                                        [
                                                            86.89,
                                                            48.99
                                                        ],
                                                        [
                                                            61.08,
                                                            74.8
                                                        ],
                                                        [
                                                            13.36,
                                                            77.24
                                                        ],
                                                        [
                                                            15.88,
                                                            29.6
                                                        ],
                                                        [
                                                            41.59,
                                                            3.89
                                                        ]
                                                    ]
                                                }
                                            }
                                        },
                                        {
                                            "ty": "st",
                                            "nm": "undefined",
                                            "lc": 2,
                                            "lj": 2,
                                            "ml": 4,
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            },
                                            "w": {
                                                "a": 0,
                                                "k": 7.5
                                            },
                                            "c": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0,
                                                    0
                                                ]
                                            }
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    75,
                                                    75
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    0,
                                                    0
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 5
                },
                {
                    "ty": 4,
                    "nm": "What\xc3\xa2\xc2\x80\xc2\x99s my current subscription? Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 146,
                    "ip": 0,
                    "ln": "34138",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                1715.678,
                                933.875
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "W",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -795.021,
                                                    -71.729
                                                ],
                                                [
                                                    -776.271,
                                                    0
                                                ],
                                                [
                                                    -766.066,
                                                    0
                                                ],
                                                [
                                                    -749.416,
                                                    -59.473
                                                ],
                                                [
                                                    -732.863,
                                                    0
                                                ],
                                                [
                                                    -722.658,
                                                    0
                                                ],
                                                [
                                                    -703.811,
                                                    -71.729
                                                ],
                                                [
                                                    -714.463,
                                                    -71.729
                                                ],
                                                [
                                                    -727.986,
                                                    -13.343
                                                ],
                                                [
                                                    -744.236,
                                                    -71.729
                                                ],
                                                [
                                                    -754.738,
                                                    -71.729
                                                ],
                                                [
                                                    -770.952,
                                                    -13.453
                                                ],
                                                [
                                                    -784.473,
                                                    -71.729
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "h",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.962,
                                                    2.507
                                                ],
                                                [
                                                    -3.646,
                                                    0
                                                ],
                                                [
                                                    -1.595,
                                                    -2.864
                                                ],
                                                [
                                                    0,
                                                    -3.841
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.465,
                                                    2.897
                                                ],
                                                [
                                                    7.584,
                                                    0
                                                ],
                                                [
                                                    2.832,
                                                    -1.856
                                                ],
                                                [
                                                    2.082,
                                                    -2.637
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.966
                                                ],
                                                [
                                                    2.962,
                                                    -2.507
                                                ],
                                                [
                                                    4.395,
                                                    0
                                                ],
                                                [
                                                    0.977,
                                                    1.79
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -5.143
                                                ],
                                                [
                                                    -2.702,
                                                    -5.306
                                                ],
                                                [
                                                    -4.232,
                                                    0
                                                ],
                                                [
                                                    -1.66,
                                                    1.074
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -690.322,
                                                    0
                                                ],
                                                [
                                                    -681.533,
                                                    0
                                                ],
                                                [
                                                    -681.533,
                                                    -27.734
                                                ],
                                                [
                                                    -677.09,
                                                    -41.943
                                                ],
                                                [
                                                    -667.178,
                                                    -45.703
                                                ],
                                                [
                                                    -658.194,
                                                    -41.406
                                                ],
                                                [
                                                    -656.729,
                                                    -32.959
                                                ],
                                                [
                                                    -656.729,
                                                    0
                                                ],
                                                [
                                                    -647.695,
                                                    0
                                                ],
                                                [
                                                    -647.695,
                                                    -33.545
                                                ],
                                                [
                                                    -649.893,
                                                    -45.605
                                                ],
                                                [
                                                    -665.322,
                                                    -53.564
                                                ],
                                                [
                                                    -675.918,
                                                    -50.781
                                                ],
                                                [
                                                    -681.533,
                                                    -45.215
                                                ],
                                                [
                                                    -681.533,
                                                    -71.973
                                                ],
                                                [
                                                    -690.322,
                                                    -71.973
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "a",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    2.533
                                                ],
                                                [
                                                    -2.718,
                                                    1.526
                                                ],
                                                [
                                                    -3.184,
                                                    0.423
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.69,
                                                    0.457
                                                ],
                                                [
                                                    -1.073,
                                                    0.686
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.883,
                                                    -2.372
                                                ],
                                                [
                                                    3.092,
                                                    0
                                                ],
                                                [
                                                    1.856,
                                                    1.462
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -3.345
                                                ],
                                                [
                                                    1.605,
                                                    -0.91
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.624,
                                                    -0.195
                                                ],
                                                [
                                                    1.689,
                                                    -0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    5.395
                                                ],
                                                [
                                                    -2.897,
                                                    1.43
                                                ],
                                                [
                                                    -2.539,
                                                    0
                                                ],
                                                [
                                                    -1.855,
                                                    -1.462
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -622.269,
                                                    -13.897
                                                ],
                                                [
                                                    -618.192,
                                                    -21.204
                                                ],
                                                [
                                                    -611.009,
                                                    -23.203
                                                ],
                                                [
                                                    -605.698,
                                                    -23.885
                                                ],
                                                [
                                                    -600.727,
                                                    -24.863
                                                ],
                                                [
                                                    -596.585,
                                                    -26.578
                                                ],
                                                [
                                                    -596.585,
                                                    -19.509
                                                ],
                                                [
                                                    -603.91,
                                                    -7.858
                                                ],
                                                [
                                                    -612.894,
                                                    -5.713
                                                ],
                                                [
                                                    -619.486,
                                                    -7.905
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.028,
                                                    -2.666
                                                ],
                                                [
                                                    0,
                                                    -4.844
                                                ],
                                                [
                                                    -3.077,
                                                    -2.942
                                                ],
                                                [
                                                    -4.85,
                                                    0
                                                ],
                                                [
                                                    -3.353,
                                                    1.724
                                                ],
                                                [
                                                    -1.791,
                                                    2.344
                                                ],
                                                [
                                                    -0.717,
                                                    -1.139
                                                ],
                                                [
                                                    -3.028,
                                                    0
                                                ],
                                                [
                                                    -0.716,
                                                    0.097
                                                ],
                                                [
                                                    -1.367,
                                                    0.391
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.488,
                                                    -0.049
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.374,
                                                    0.553
                                                ],
                                                [
                                                    0,
                                                    0.912
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.804,
                                                    2.344
                                                ],
                                                [
                                                    6.145,
                                                    0
                                                ],
                                                [
                                                    4.015,
                                                    -2.529
                                                ],
                                                [
                                                    0.162,
                                                    -6.464
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.072,
                                                    1.374
                                                ],
                                                [
                                                    -4.58,
                                                    0
                                                ],
                                                [
                                                    -2.128,
                                                    -1.355
                                                ],
                                                [
                                                    0,
                                                    -3.006
                                                ],
                                                [
                                                    0.39,
                                                    -0.784
                                                ],
                                                [
                                                    2.018,
                                                    -0.26
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -4.915,
                                                    0.618
                                                ],
                                                [
                                                    -3.027,
                                                    2.665
                                                ],
                                                [
                                                    0,
                                                    4.422
                                                ],
                                                [
                                                    3.076,
                                                    2.942
                                                ],
                                                [
                                                    4.036,
                                                    0
                                                ],
                                                [
                                                    3.353,
                                                    -1.725
                                                ],
                                                [
                                                    0.293,
                                                    2.083
                                                ],
                                                [
                                                    1.367,
                                                    2.148
                                                ],
                                                [
                                                    1.236,
                                                    0
                                                ],
                                                [
                                                    0.716,
                                                    -0.098
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.554,
                                                    0.097
                                                ],
                                                [
                                                    -0.488,
                                                    0.049
                                                ],
                                                [
                                                    -1.204,
                                                    0
                                                ],
                                                [
                                                    -0.374,
                                                    -0.552
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -4.948
                                                ],
                                                [
                                                    -3.837,
                                                    -2.344
                                                ],
                                                [
                                                    -5.299,
                                                    0
                                                ],
                                                [
                                                    -4.016,
                                                    2.53
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.325,
                                                    -2.715
                                                ],
                                                [
                                                    1.916,
                                                    -2.486
                                                ],
                                                [
                                                    3.963,
                                                    0
                                                ],
                                                [
                                                    2.127,
                                                    1.357
                                                ],
                                                [
                                                    0,
                                                    1.471
                                                ],
                                                [
                                                    -0.684,
                                                    1.43
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -614.994,
                                                    -29.893
                                                ],
                                                [
                                                    -626.908,
                                                    -24.966
                                                ],
                                                [
                                                    -631.449,
                                                    -13.702
                                                ],
                                                [
                                                    -626.834,
                                                    -2.656
                                                ],
                                                [
                                                    -614.945,
                                                    1.758
                                                ],
                                                [
                                                    -603.861,
                                                    -0.829
                                                ],
                                                [
                                                    -596.146,
                                                    -6.932
                                                ],
                                                [
                                                    -594.632,
                                                    -2.099
                                                ],
                                                [
                                                    -588.04,
                                                    1.123
                                                ],
                                                [
                                                    -585.111,
                                                    0.977
                                                ],
                                                [
                                                    -581.986,
                                                    0.244
                                                ],
                                                [
                                                    -581.986,
                                                    -6.249
                                                ],
                                                [
                                                    -583.548,
                                                    -6.03
                                                ],
                                                [
                                                    -584.867,
                                                    -5.957
                                                ],
                                                [
                                                    -587.235,
                                                    -6.786
                                                ],
                                                [
                                                    -587.796,
                                                    -8.982
                                                ],
                                                [
                                                    -587.796,
                                                    -39.111
                                                ],
                                                [
                                                    -593.502,
                                                    -50.049
                                                ],
                                                [
                                                    -608.475,
                                                    -53.564
                                                ],
                                                [
                                                    -622.447,
                                                    -49.77
                                                ],
                                                [
                                                    -628.714,
                                                    -36.279
                                                ],
                                                [
                                                    -620.511,
                                                    -36.279
                                                ],
                                                [
                                                    -618.416,
                                                    -42.413
                                                ],
                                                [
                                                    -608.67,
                                                    -46.143
                                                ],
                                                [
                                                    -599.533,
                                                    -44.109
                                                ],
                                                [
                                                    -596.341,
                                                    -37.565
                                                ],
                                                [
                                                    -596.926,
                                                    -34.183
                                                ],
                                                [
                                                    -600.979,
                                                    -31.648
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.465,
                                                    -2.1
                                                ],
                                                [
                                                    -4.102,
                                                    0
                                                ],
                                                [
                                                    -1.091,
                                                    0.129
                                                ],
                                                [
                                                    -1.009,
                                                    0.293
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.488,
                                                    -0.022
                                                ],
                                                [
                                                    0.423,
                                                    0
                                                ],
                                                [
                                                    0.684,
                                                    0.358
                                                ],
                                                [
                                                    0,
                                                    1.823
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    3.353
                                                ],
                                                [
                                                    1.465,
                                                    2.099
                                                ],
                                                [
                                                    1.269,
                                                    0
                                                ],
                                                [
                                                    1.09,
                                                    -0.131
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    0.087
                                                ],
                                                [
                                                    -0.488,
                                                    0.021
                                                ],
                                                [
                                                    -1.595,
                                                    0
                                                ],
                                                [
                                                    -1.238,
                                                    -0.618
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -565.934,
                                                    -52.295
                                                ],
                                                [
                                                    -573.014,
                                                    -52.295
                                                ],
                                                [
                                                    -573.014,
                                                    -45.117
                                                ],
                                                [
                                                    -565.934,
                                                    -45.117
                                                ],
                                                [
                                                    -565.934,
                                                    -10.498
                                                ],
                                                [
                                                    -563.737,
                                                    -2.319
                                                ],
                                                [
                                                    -555.387,
                                                    0.83
                                                ],
                                                [
                                                    -551.847,
                                                    0.635
                                                ],
                                                [
                                                    -548.698,
                                                    0
                                                ],
                                                [
                                                    -548.698,
                                                    -6.982
                                                ],
                                                [
                                                    -550.407,
                                                    -6.819
                                                ],
                                                [
                                                    -551.774,
                                                    -6.787
                                                ],
                                                [
                                                    -555.192,
                                                    -7.324
                                                ],
                                                [
                                                    -557.047,
                                                    -10.986
                                                ],
                                                [
                                                    -557.047,
                                                    -45.117
                                                ],
                                                [
                                                    -548.698,
                                                    -45.117
                                                ],
                                                [
                                                    -548.698,
                                                    -52.295
                                                ],
                                                [
                                                    -557.047,
                                                    -52.295
                                                ],
                                                [
                                                    -557.047,
                                                    -66.895
                                                ],
                                                [
                                                    -565.934,
                                                    -66.895
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "\xc3\xa2\xc2\x80\xc2\x99",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.726,
                                                    2.914
                                                ],
                                                [
                                                    0,
                                                    4.167
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.017,
                                                    -0.178
                                                ],
                                                [
                                                    0,
                                                    -0.228
                                                ],
                                                [
                                                    0.936,
                                                    -1.725
                                                ],
                                                [
                                                    1.806,
                                                    -0.293
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    3.515,
                                                    -0.423
                                                ],
                                                [
                                                    1.725,
                                                    -2.913
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.066,
                                                    0.228
                                                ],
                                                [
                                                    0.016,
                                                    0.18
                                                ],
                                                [
                                                    0,
                                                    2.246
                                                ],
                                                [
                                                    -0.936,
                                                    1.726
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -532.353,
                                                    -46.289
                                                ],
                                                [
                                                    -524.492,
                                                    -51.294
                                                ],
                                                [
                                                    -521.904,
                                                    -61.914
                                                ],
                                                [
                                                    -521.904,
                                                    -71.729
                                                ],
                                                [
                                                    -532.353,
                                                    -71.729
                                                ],
                                                [
                                                    -532.353,
                                                    -61.084
                                                ],
                                                [
                                                    -526.983,
                                                    -61.084
                                                ],
                                                [
                                                    -526.86,
                                                    -60.474
                                                ],
                                                [
                                                    -526.836,
                                                    -59.863
                                                ],
                                                [
                                                    -528.24,
                                                    -53.906
                                                ],
                                                [
                                                    -532.353,
                                                    -50.879
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "s",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.279,
                                                    -3.532
                                                ],
                                                [
                                                    -7.877,
                                                    0
                                                ],
                                                [
                                                    -3.576,
                                                    3.385
                                                ],
                                                [
                                                    0,
                                                    4.656
                                                ],
                                                [
                                                    3.418,
                                                    2.246
                                                ],
                                                [
                                                    6.434,
                                                    1.531
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.326,
                                                    0.811
                                                ],
                                                [
                                                    0,
                                                    2.27
                                                ],
                                                [
                                                    -1.749,
                                                    1.265
                                                ],
                                                [
                                                    -3.399,
                                                    0
                                                ],
                                                [
                                                    -2.066,
                                                    -2.298
                                                ],
                                                [
                                                    -0.167,
                                                    -1.974
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.21,
                                                    2.93
                                                ],
                                                [
                                                    7.984,
                                                    0
                                                ],
                                                [
                                                    3.611,
                                                    -3.06
                                                ],
                                                [
                                                    0,
                                                    -4.947
                                                ],
                                                [
                                                    -3.838,
                                                    -2.376
                                                ],
                                                [
                                                    -4.532,
                                                    -1.107
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.291,
                                                    -0.716
                                                ],
                                                [
                                                    0,
                                                    -2.246
                                                ],
                                                [
                                                    2.525,
                                                    -1.416
                                                ],
                                                [
                                                    3.322,
                                                    0
                                                ],
                                                [
                                                    2.259,
                                                    2.832
                                                ],
                                                [
                                                    0.265,
                                                    2.929
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.231,
                                                    5.208
                                                ],
                                                [
                                                    3.28,
                                                    3.532
                                                ],
                                                [
                                                    7.317,
                                                    0
                                                ],
                                                [
                                                    3.576,
                                                    -3.385
                                                ],
                                                [
                                                    0,
                                                    -4.817
                                                ],
                                                [
                                                    -2.19,
                                                    -1.432
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.587,
                                                    -0.618
                                                ],
                                                [
                                                    -2.299,
                                                    -1.362
                                                ],
                                                [
                                                    0,
                                                    -2.076
                                                ],
                                                [
                                                    1.75,
                                                    -1.265
                                                ],
                                                [
                                                    5.098,
                                                    0
                                                ],
                                                [
                                                    1.265,
                                                    1.619
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    -3.385
                                                ],
                                                [
                                                    -3.53,
                                                    -4.621
                                                ],
                                                [
                                                    -6.103,
                                                    0
                                                ],
                                                [
                                                    -3.613,
                                                    3.06
                                                ],
                                                [
                                                    0,
                                                    4.2
                                                ],
                                                [
                                                    2.15,
                                                    1.367
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.804,
                                                    0.945
                                                ],
                                                [
                                                    2.018,
                                                    1.172
                                                ],
                                                [
                                                    0,
                                                    2.962
                                                ],
                                                [
                                                    -2.525,
                                                    1.416
                                                ],
                                                [
                                                    -5.581,
                                                    0
                                                ],
                                                [
                                                    -1.23,
                                                    -1.562
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -509.515,
                                                    -16.406
                                                ],
                                                [
                                                    -504.25,
                                                    -3.296
                                                ],
                                                [
                                                    -487.516,
                                                    2.002
                                                ],
                                                [
                                                    -471.178,
                                                    -3.076
                                                ],
                                                [
                                                    -465.813,
                                                    -15.137
                                                ],
                                                [
                                                    -470.94,
                                                    -25.732
                                                ],
                                                [
                                                    -483.875,
                                                    -30.176
                                                ],
                                                [
                                                    -489.796,
                                                    -31.592
                                                ],
                                                [
                                                    -495.666,
                                                    -33.736
                                                ],
                                                [
                                                    -499.114,
                                                    -39.185
                                                ],
                                                [
                                                    -496.491,
                                                    -44.196
                                                ],
                                                [
                                                    -488.768,
                                                    -46.094
                                                ],
                                                [
                                                    -478.021,
                                                    -42.646
                                                ],
                                                [
                                                    -475.872,
                                                    -37.256
                                                ],
                                                [
                                                    -467.571,
                                                    -37.256
                                                ],
                                                [
                                                    -470.789,
                                                    -46.729
                                                ],
                                                [
                                                    -488.059,
                                                    -53.662
                                                ],
                                                [
                                                    -502.631,
                                                    -49.072
                                                ],
                                                [
                                                    -508.05,
                                                    -37.061
                                                ],
                                                [
                                                    -502.293,
                                                    -27.197
                                                ],
                                                [
                                                    -492.27,
                                                    -23.486
                                                ],
                                                [
                                                    -485.174,
                                                    -21.729
                                                ],
                                                [
                                                    -477.532,
                                                    -19.238
                                                ],
                                                [
                                                    -474.505,
                                                    -14.111
                                                ],
                                                [
                                                    -478.293,
                                                    -7.544
                                                ],
                                                [
                                                    -487.064,
                                                    -5.42
                                                ],
                                                [
                                                    -498.825,
                                                    -9.668
                                                ],
                                                [
                                                    -501.067,
                                                    -16.406
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "m",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.718,
                                                    2.572
                                                ],
                                                [
                                                    -3.32,
                                                    0
                                                ],
                                                [
                                                    -1.335,
                                                    -2.441
                                                ],
                                                [
                                                    0,
                                                    -3.548
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.49,
                                                    2.312
                                                ],
                                                [
                                                    -3.45,
                                                    0
                                                ],
                                                [
                                                    -1.741,
                                                    -1.301
                                                ],
                                                [
                                                    0,
                                                    -3.483
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.367,
                                                    2.735
                                                ],
                                                [
                                                    7.032,
                                                    0
                                                ],
                                                [
                                                    2.636,
                                                    -1.351
                                                ],
                                                [
                                                    1.953,
                                                    -2.799
                                                ],
                                                [
                                                    1.432,
                                                    1.172
                                                ],
                                                [
                                                    4.166,
                                                    0
                                                ],
                                                [
                                                    2.897,
                                                    -1.985
                                                ],
                                                [
                                                    2.082,
                                                    -2.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.739
                                                ],
                                                [
                                                    2.718,
                                                    -2.571
                                                ],
                                                [
                                                    3.645,
                                                    0
                                                ],
                                                [
                                                    0.846,
                                                    1.629
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -5.403
                                                ],
                                                [
                                                    2.49,
                                                    -2.311
                                                ],
                                                [
                                                    2.507,
                                                    0
                                                ],
                                                [
                                                    1.741,
                                                    1.302
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -4.622
                                                ],
                                                [
                                                    -2.539,
                                                    -5.078
                                                ],
                                                [
                                                    -3.288,
                                                    0
                                                ],
                                                [
                                                    -2.637,
                                                    1.351
                                                ],
                                                [
                                                    -1.172,
                                                    -2.278
                                                ],
                                                [
                                                    -2.54,
                                                    -2.05
                                                ],
                                                [
                                                    -3.679,
                                                    0
                                                ],
                                                [
                                                    -1.693,
                                                    1.172
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -417.109,
                                                    0
                                                ],
                                                [
                                                    -408.32,
                                                    0
                                                ],
                                                [
                                                    -408.32,
                                                    -27.734
                                                ],
                                                [
                                                    -404.243,
                                                    -41.699
                                                ],
                                                [
                                                    -395.185,
                                                    -45.557
                                                ],
                                                [
                                                    -387.714,
                                                    -41.895
                                                ],
                                                [
                                                    -386.445,
                                                    -34.131
                                                ],
                                                [
                                                    -386.445,
                                                    0
                                                ],
                                                [
                                                    -377.509,
                                                    0
                                                ],
                                                [
                                                    -377.509,
                                                    -30.42
                                                ],
                                                [
                                                    -373.774,
                                                    -41.992
                                                ],
                                                [
                                                    -364.863,
                                                    -45.459
                                                ],
                                                [
                                                    -358.491,
                                                    -43.506
                                                ],
                                                [
                                                    -355.878,
                                                    -36.328
                                                ],
                                                [
                                                    -355.878,
                                                    0
                                                ],
                                                [
                                                    -346.747,
                                                    0
                                                ],
                                                [
                                                    -346.747,
                                                    -34.814
                                                ],
                                                [
                                                    -348.798,
                                                    -45.85
                                                ],
                                                [
                                                    -363.154,
                                                    -53.467
                                                ],
                                                [
                                                    -372.04,
                                                    -51.44
                                                ],
                                                [
                                                    -378.925,
                                                    -45.215
                                                ],
                                                [
                                                    -382.831,
                                                    -50.391
                                                ],
                                                [
                                                    -392.89,
                                                    -53.467
                                                ],
                                                [
                                                    -402.753,
                                                    -50.488
                                                ],
                                                [
                                                    -408.417,
                                                    -44.873
                                                ],
                                                [
                                                    -408.417,
                                                    -52.295
                                                ],
                                                [
                                                    -417.109,
                                                    -52.295
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "y",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.007,
                                                    -2.404
                                                ],
                                                [
                                                    0.162,
                                                    -0.26
                                                ],
                                                [
                                                    0.763,
                                                    -0.537
                                                ],
                                                [
                                                    1.624,
                                                    0
                                                ],
                                                [
                                                    0.683,
                                                    0.098
                                                ],
                                                [
                                                    1.528,
                                                    0.423
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.667,
                                                    -0.098
                                                ],
                                                [
                                                    -1.236,
                                                    0
                                                ],
                                                [
                                                    -2.081,
                                                    2.927
                                                ],
                                                [
                                                    -5.073,
                                                    13.336
                                                ],
                                                [
                                                    -3.19,
                                                    8.989
                                                ],
                                                [
                                                    -1.237,
                                                    3.355
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.455,
                                                    1.169
                                                ],
                                                [
                                                    -1.007,
                                                    2.404
                                                ],
                                                [
                                                    -0.52,
                                                    0.78
                                                ],
                                                [
                                                    -0.764,
                                                    0.535
                                                ],
                                                [
                                                    -0.521,
                                                    0
                                                ],
                                                [
                                                    -0.682,
                                                    -0.097
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.975,
                                                    0.26
                                                ],
                                                [
                                                    0.667,
                                                    0.098
                                                ],
                                                [
                                                    5.073,
                                                    0
                                                ],
                                                [
                                                    2.081,
                                                    -2.928
                                                ],
                                                [
                                                    2.149,
                                                    -5.667
                                                ],
                                                [
                                                    4.264,
                                                    -11.952
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -309.529,
                                                    -9.698
                                                ],
                                                [
                                                    -323.543,
                                                    -52.295
                                                ],
                                                [
                                                    -333.504,
                                                    -52.295
                                                ],
                                                [
                                                    -314.168,
                                                    1.538
                                                ],
                                                [
                                                    -316.362,
                                                    6.898
                                                ],
                                                [
                                                    -318.116,
                                                    10.894
                                                ],
                                                [
                                                    -320.042,
                                                    12.868
                                                ],
                                                [
                                                    -323.624,
                                                    13.672
                                                ],
                                                [
                                                    -325.429,
                                                    13.525
                                                ],
                                                [
                                                    -328.743,
                                                    12.744
                                                ],
                                                [
                                                    -328.743,
                                                    20.752
                                                ],
                                                [
                                                    -326.279,
                                                    21.289
                                                ],
                                                [
                                                    -323.425,
                                                    21.436
                                                ],
                                                [
                                                    -312.693,
                                                    17.044
                                                ],
                                                [
                                                    -301.961,
                                                    -7.352
                                                ],
                                                [
                                                    -293.953,
                                                    -29.335
                                                ],
                                                [
                                                    -285.701,
                                                    -52.295
                                                ],
                                                [
                                                    -295.418,
                                                    -52.295
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "c",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    5.892,
                                                    0
                                                ],
                                                [
                                                    4.46,
                                                    -5.11
                                                ],
                                                [
                                                    0,
                                                    -9.18
                                                ],
                                                [
                                                    -4.069,
                                                    -4.997
                                                ],
                                                [
                                                    -6.836,
                                                    0
                                                ],
                                                [
                                                    -3.906,
                                                    3.207
                                                ],
                                                [
                                                    -0.976,
                                                    6.934
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.132,
                                                    -2.221
                                                ],
                                                [
                                                    3.646,
                                                    0
                                                ],
                                                [
                                                    2.213,
                                                    3.577
                                                ],
                                                [
                                                    0,
                                                    5.234
                                                ],
                                                [
                                                    -1.562,
                                                    3.544
                                                ],
                                                [
                                                    -5.599,
                                                    0
                                                ],
                                                [
                                                    -1.856,
                                                    -2.132
                                                ],
                                                [
                                                    -0.521,
                                                    -3.222
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.694,
                                                    2.865
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -6.901,
                                                    0
                                                ],
                                                [
                                                    -4.46,
                                                    5.111
                                                ],
                                                [
                                                    0,
                                                    7.487
                                                ],
                                                [
                                                    4.069,
                                                    4.997
                                                ],
                                                [
                                                    6.086,
                                                    0
                                                ],
                                                [
                                                    3.906,
                                                    -3.206
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.814,
                                                    3.859
                                                ],
                                                [
                                                    -2.132,
                                                    2.221
                                                ],
                                                [
                                                    -4.753,
                                                    0
                                                ],
                                                [
                                                    -2.214,
                                                    -3.577
                                                ],
                                                [
                                                    0,
                                                    -5.202
                                                ],
                                                [
                                                    2.409,
                                                    -5.462
                                                ],
                                                [
                                                    4.102,
                                                    0
                                                ],
                                                [
                                                    1.855,
                                                    2.132
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.749,
                                                    -6.998
                                                ],
                                                [
                                                    -3.695,
                                                    -2.864
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -218.759,
                                                    -53.809
                                                ],
                                                [
                                                    -235.8,
                                                    -46.143
                                                ],
                                                [
                                                    -242.489,
                                                    -24.707
                                                ],
                                                [
                                                    -236.386,
                                                    -5.981
                                                ],
                                                [
                                                    -220.028,
                                                    1.514
                                                ],
                                                [
                                                    -205.038,
                                                    -3.296
                                                ],
                                                [
                                                    -197.714,
                                                    -18.506
                                                ],
                                                [
                                                    -206.259,
                                                    -18.506
                                                ],
                                                [
                                                    -210.678,
                                                    -9.386
                                                ],
                                                [
                                                    -219.345,
                                                    -6.055
                                                ],
                                                [
                                                    -229.794,
                                                    -11.419
                                                ],
                                                [
                                                    -233.114,
                                                    -24.635
                                                ],
                                                [
                                                    -230.771,
                                                    -37.754
                                                ],
                                                [
                                                    -218.759,
                                                    -45.947
                                                ],
                                                [
                                                    -209.823,
                                                    -42.749
                                                ],
                                                [
                                                    -206.259,
                                                    -34.717
                                                ],
                                                [
                                                    -197.714,
                                                    -34.717
                                                ],
                                                [
                                                    -204.379,
                                                    -49.512
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "u",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.437,
                                                    -2.668
                                                ],
                                                [
                                                    -7.315,
                                                    0
                                                ],
                                                [
                                                    -3.29,
                                                    2.735
                                                ],
                                                [
                                                    -1.119,
                                                    1.986
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.172,
                                                    -2.929
                                                ],
                                                [
                                                    5.959,
                                                    0
                                                ],
                                                [
                                                    1.521,
                                                    3.125
                                                ],
                                                [
                                                    0,
                                                    2.669
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    4.46
                                                ],
                                                [
                                                    2.65,
                                                    4.981
                                                ],
                                                [
                                                    4.695,
                                                    0
                                                ],
                                                [
                                                    1.661,
                                                    -1.367
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    5.111
                                                ],
                                                [
                                                    -2.156,
                                                    5.469
                                                ],
                                                [
                                                    -4.153,
                                                    0
                                                ],
                                                [
                                                    -0.825,
                                                    -1.692
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -183.42,
                                                    -52.295
                                                ],
                                                [
                                                    -183.42,
                                                    -16.748
                                                ],
                                                [
                                                    -181.264,
                                                    -6.055
                                                ],
                                                [
                                                    -166.316,
                                                    1.416
                                                ],
                                                [
                                                    -154.338,
                                                    -2.686
                                                ],
                                                [
                                                    -150.168,
                                                    -7.715
                                                ],
                                                [
                                                    -150.266,
                                                    0
                                                ],
                                                [
                                                    -141.965,
                                                    0
                                                ],
                                                [
                                                    -141.965,
                                                    -52.295
                                                ],
                                                [
                                                    -150.754,
                                                    -52.295
                                                ],
                                                [
                                                    -150.754,
                                                    -26.611
                                                ],
                                                [
                                                    -152.513,
                                                    -14.551
                                                ],
                                                [
                                                    -164.687,
                                                    -6.348
                                                ],
                                                [
                                                    -173.199,
                                                    -11.035
                                                ],
                                                [
                                                    -174.436,
                                                    -17.578
                                                ],
                                                [
                                                    -174.436,
                                                    -52.295
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "r",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.376,
                                                    2.849
                                                ],
                                                [
                                                    -4.427,
                                                    0
                                                ],
                                                [
                                                    -0.44,
                                                    -0.032
                                                ],
                                                [
                                                    -0.521,
                                                    -0.098
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.391,
                                                    0.033
                                                ],
                                                [
                                                    0.163,
                                                    0
                                                ],
                                                [
                                                    2.668,
                                                    -2.522
                                                ],
                                                [
                                                    0.684,
                                                    -1.758
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -3.711
                                                ],
                                                [
                                                    2.376,
                                                    -2.848
                                                ],
                                                [
                                                    0.521,
                                                    0
                                                ],
                                                [
                                                    0.439,
                                                    0.033
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.944,
                                                    -0.097
                                                ],
                                                [
                                                    -0.391,
                                                    -0.032
                                                ],
                                                [
                                                    -3.484,
                                                    0
                                                ],
                                                [
                                                    -2.67,
                                                    2.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -121.665,
                                                    0
                                                ],
                                                [
                                                    -112.876,
                                                    0
                                                ],
                                                [
                                                    -112.876,
                                                    -30.078
                                                ],
                                                [
                                                    -109.312,
                                                    -39.917
                                                ],
                                                [
                                                    -99.107,
                                                    -44.189
                                                ],
                                                [
                                                    -97.666,
                                                    -44.141
                                                ],
                                                [
                                                    -96.226,
                                                    -43.945
                                                ],
                                                [
                                                    -96.226,
                                                    -53.223
                                                ],
                                                [
                                                    -98.228,
                                                    -53.418
                                                ],
                                                [
                                                    -99.058,
                                                    -53.467
                                                ],
                                                [
                                                    -108.286,
                                                    -49.683
                                                ],
                                                [
                                                    -113.316,
                                                    -43.262
                                                ],
                                                [
                                                    -113.316,
                                                    -52.295
                                                ],
                                                [
                                                    -121.665,
                                                    -52.295
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "r",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.377,
                                                    2.849
                                                ],
                                                [
                                                    -4.427,
                                                    0
                                                ],
                                                [
                                                    -0.439,
                                                    -0.032
                                                ],
                                                [
                                                    -0.521,
                                                    -0.098
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.39,
                                                    0.033
                                                ],
                                                [
                                                    0.162,
                                                    0
                                                ],
                                                [
                                                    2.669,
                                                    -2.522
                                                ],
                                                [
                                                    0.684,
                                                    -1.758
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -3.711
                                                ],
                                                [
                                                    2.376,
                                                    -2.848
                                                ],
                                                [
                                                    0.52,
                                                    0
                                                ],
                                                [
                                                    0.44,
                                                    0.033
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.945,
                                                    -0.097
                                                ],
                                                [
                                                    -0.391,
                                                    -0.032
                                                ],
                                                [
                                                    -3.484,
                                                    0
                                                ],
                                                [
                                                    -2.669,
                                                    2.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -82.665,
                                                    0
                                                ],
                                                [
                                                    -73.876,
                                                    0
                                                ],
                                                [
                                                    -73.876,
                                                    -30.078
                                                ],
                                                [
                                                    -70.311,
                                                    -39.917
                                                ],
                                                [
                                                    -60.106,
                                                    -44.189
                                                ],
                                                [
                                                    -58.666,
                                                    -44.141
                                                ],
                                                [
                                                    -57.225,
                                                    -43.945
                                                ],
                                                [
                                                    -57.225,
                                                    -53.223
                                                ],
                                                [
                                                    -59.227,
                                                    -53.418
                                                ],
                                                [
                                                    -60.057,
                                                    -53.467
                                                ],
                                                [
                                                    -69.286,
                                                    -49.683
                                                ],
                                                [
                                                    -74.315,
                                                    -43.262
                                                ],
                                                [
                                                    -74.315,
                                                    -52.295
                                                ],
                                                [
                                                    -82.665,
                                                    -52.295
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "e",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    3.688,
                                                    0
                                                ],
                                                [
                                                    4.529,
                                                    -5.241
                                                ],
                                                [
                                                    0,
                                                    -8.399
                                                ],
                                                [
                                                    -4.497,
                                                    -4.736
                                                ],
                                                [
                                                    -6.47,
                                                    0
                                                ],
                                                [
                                                    -2.1,
                                                    0.521
                                                ],
                                                [
                                                    -2.649,
                                                    2.604
                                                ],
                                                [
                                                    -1.286,
                                                    2.36
                                                ],
                                                [
                                                    -0.228,
                                                    1.921
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.518,
                                                    -1.765
                                                ],
                                                [
                                                    4.554,
                                                    0
                                                ],
                                                [
                                                    2.326,
                                                    3.215
                                                ],
                                                [
                                                    0.162,
                                                    5.321
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.517,
                                                    2.409
                                                ],
                                                [
                                                    1.748,
                                                    2.637
                                                ],
                                                [
                                                    3.462,
                                                    1.741
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -7.312,
                                                    0
                                                ],
                                                [
                                                    -4.529,
                                                    5.241
                                                ],
                                                [
                                                    0,
                                                    8.528
                                                ],
                                                [
                                                    4.497,
                                                    4.736
                                                ],
                                                [
                                                    2.649,
                                                    0
                                                ],
                                                [
                                                    3.909,
                                                    -0.911
                                                ],
                                                [
                                                    1.583,
                                                    -1.497
                                                ],
                                                [
                                                    1.286,
                                                    -2.36
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.633,
                                                    2.322
                                                ],
                                                [
                                                    -2.713,
                                                    3.042
                                                ],
                                                [
                                                    -4.876,
                                                    0
                                                ],
                                                [
                                                    -2.325,
                                                    -3.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -5.273
                                                ],
                                                [
                                                    -0.583,
                                                    -3.516
                                                ],
                                                [
                                                    -1.812,
                                                    -2.766
                                                ],
                                                [
                                                    -3.462,
                                                    -1.742
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -22.331,
                                                    -53.467
                                                ],
                                                [
                                                    -40.093,
                                                    -45.605
                                                ],
                                                [
                                                    -46.887,
                                                    -25.146
                                                ],
                                                [
                                                    -40.142,
                                                    -5.249
                                                ],
                                                [
                                                    -23.692,
                                                    1.855
                                                ],
                                                [
                                                    -16.569,
                                                    1.074
                                                ],
                                                [
                                                    -6.732,
                                                    -4.199
                                                ],
                                                [
                                                    -2.429,
                                                    -9.985
                                                ],
                                                [
                                                    -0.158,
                                                    -16.406
                                                ],
                                                [
                                                    -8.801,
                                                    -16.406
                                                ],
                                                [
                                                    -12.028,
                                                    -10.275
                                                ],
                                                [
                                                    -22.929,
                                                    -5.713
                                                ],
                                                [
                                                    -33.732,
                                                    -10.535
                                                ],
                                                [
                                                    -37.463,
                                                    -23.34
                                                ],
                                                [
                                                    0.574,
                                                    -23.34
                                                ],
                                                [
                                                    -0.202,
                                                    -34.863
                                                ],
                                                [
                                                    -3.697,
                                                    -44.092
                                                ],
                                                [
                                                    -11.607,
                                                    -50.854
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.712,
                                                    2.914
                                                ],
                                                [
                                                    -4.002,
                                                    0
                                                ],
                                                [
                                                    -2.389,
                                                    -4.231
                                                ],
                                                [
                                                    -0.355,
                                                    -3.809
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.161,
                                                    -4.492
                                                ],
                                                [
                                                    2.711,
                                                    -2.913
                                                ],
                                                [
                                                    5.584,
                                                    0
                                                ],
                                                [
                                                    1.29,
                                                    2.279
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -37.267,
                                                    -30.322
                                                ],
                                                [
                                                    -32.958,
                                                    -41.431
                                                ],
                                                [
                                                    -22.888,
                                                    -45.801
                                                ],
                                                [
                                                    -10.928,
                                                    -39.453
                                                ],
                                                [
                                                    -8.459,
                                                    -30.322
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.439,
                                                    1.839
                                                ],
                                                [
                                                    -1.465,
                                                    1.726
                                                ],
                                                [
                                                    -2.41,
                                                    0.717
                                                ],
                                                [
                                                    -2.084,
                                                    0
                                                ],
                                                [
                                                    -1.563,
                                                    -3.255
                                                ],
                                                [
                                                    0,
                                                    -3.19
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.432,
                                                    2.832
                                                ],
                                                [
                                                    7.422,
                                                    0
                                                ],
                                                [
                                                    2.767,
                                                    -1.334
                                                ],
                                                [
                                                    2.473,
                                                    -3.059
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -3.418
                                                ],
                                                [
                                                    0.44,
                                                    -1.839
                                                ],
                                                [
                                                    1.823,
                                                    -2.148
                                                ],
                                                [
                                                    1.334,
                                                    -0.423
                                                ],
                                                [
                                                    4.101,
                                                    0
                                                ],
                                                [
                                                    0.943,
                                                    1.953
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -5.273
                                                ],
                                                [
                                                    -2.605,
                                                    -5.176
                                                ],
                                                [
                                                    -3.386,
                                                    0
                                                ],
                                                [
                                                    -2.767,
                                                    1.335
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    17.407,
                                                    0
                                                ],
                                                [
                                                    26.196,
                                                    0
                                                ],
                                                [
                                                    26.196,
                                                    -27.393
                                                ],
                                                [
                                                    26.855,
                                                    -35.278
                                                ],
                                                [
                                                    29.712,
                                                    -40.625
                                                ],
                                                [
                                                    36.06,
                                                    -44.922
                                                ],
                                                [
                                                    41.187,
                                                    -45.557
                                                ],
                                                [
                                                    49.683,
                                                    -40.674
                                                ],
                                                [
                                                    51.099,
                                                    -32.959
                                                ],
                                                [
                                                    51.099,
                                                    0
                                                ],
                                                [
                                                    60.034,
                                                    0
                                                ],
                                                [
                                                    60.034,
                                                    -33.545
                                                ],
                                                [
                                                    57.886,
                                                    -45.703
                                                ],
                                                [
                                                    42.847,
                                                    -53.467
                                                ],
                                                [
                                                    33.618,
                                                    -51.465
                                                ],
                                                [
                                                    25.757,
                                                    -44.873
                                                ],
                                                [
                                                    25.757,
                                                    -52.295
                                                ],
                                                [
                                                    17.407,
                                                    -52.295
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.465,
                                                    -2.1
                                                ],
                                                [
                                                    -4.101,
                                                    0
                                                ],
                                                [
                                                    -1.091,
                                                    0.129
                                                ],
                                                [
                                                    -1.01,
                                                    0.293
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.488,
                                                    -0.022
                                                ],
                                                [
                                                    0.423,
                                                    0
                                                ],
                                                [
                                                    0.684,
                                                    0.358
                                                ],
                                                [
                                                    0,
                                                    1.823
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    3.353
                                                ],
                                                [
                                                    1.464,
                                                    2.099
                                                ],
                                                [
                                                    1.27,
                                                    0
                                                ],
                                                [
                                                    1.09,
                                                    -0.131
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.652,
                                                    0.087
                                                ],
                                                [
                                                    -0.489,
                                                    0.021
                                                ],
                                                [
                                                    -1.595,
                                                    0
                                                ],
                                                [
                                                    -1.237,
                                                    -0.618
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    80.48,
                                                    -52.295
                                                ],
                                                [
                                                    73.4,
                                                    -52.295
                                                ],
                                                [
                                                    73.4,
                                                    -45.117
                                                ],
                                                [
                                                    80.48,
                                                    -45.117
                                                ],
                                                [
                                                    80.48,
                                                    -10.498
                                                ],
                                                [
                                                    82.678,
                                                    -2.319
                                                ],
                                                [
                                                    91.027,
                                                    0.83
                                                ],
                                                [
                                                    94.567,
                                                    0.635
                                                ],
                                                [
                                                    97.717,
                                                    0
                                                ],
                                                [
                                                    97.717,
                                                    -6.982
                                                ],
                                                [
                                                    96.008,
                                                    -6.819
                                                ],
                                                [
                                                    94.64,
                                                    -6.787
                                                ],
                                                [
                                                    91.222,
                                                    -7.324
                                                ],
                                                [
                                                    89.367,
                                                    -10.986
                                                ],
                                                [
                                                    89.367,
                                                    -45.117
                                                ],
                                                [
                                                    97.717,
                                                    -45.117
                                                ],
                                                [
                                                    97.717,
                                                    -52.295
                                                ],
                                                [
                                                    89.367,
                                                    -52.295
                                                ],
                                                [
                                                    89.367,
                                                    -66.895
                                                ],
                                                [
                                                    80.48,
                                                    -66.895
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "s",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.279,
                                                    -3.532
                                                ],
                                                [
                                                    -7.877,
                                                    0
                                                ],
                                                [
                                                    -3.576,
                                                    3.385
                                                ],
                                                [
                                                    0,
                                                    4.656
                                                ],
                                                [
                                                    3.418,
                                                    2.246
                                                ],
                                                [
                                                    6.433,
                                                    1.531
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.326,
                                                    0.811
                                                ],
                                                [
                                                    0,
                                                    2.27
                                                ],
                                                [
                                                    -1.749,
                                                    1.265
                                                ],
                                                [
                                                    -3.399,
                                                    0
                                                ],
                                                [
                                                    -2.066,
                                                    -2.298
                                                ],
                                                [
                                                    -0.167,
                                                    -1.974
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.211,
                                                    2.93
                                                ],
                                                [
                                                    7.984,
                                                    0
                                                ],
                                                [
                                                    3.612,
                                                    -3.06
                                                ],
                                                [
                                                    0,
                                                    -4.947
                                                ],
                                                [
                                                    -3.837,
                                                    -2.376
                                                ],
                                                [
                                                    -4.532,
                                                    -1.107
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.291,
                                                    -0.716
                                                ],
                                                [
                                                    0,
                                                    -2.246
                                                ],
                                                [
                                                    2.525,
                                                    -1.416
                                                ],
                                                [
                                                    3.322,
                                                    0
                                                ],
                                                [
                                                    2.259,
                                                    2.832
                                                ],
                                                [
                                                    0.266,
                                                    2.929
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.231,
                                                    5.208
                                                ],
                                                [
                                                    3.279,
                                                    3.532
                                                ],
                                                [
                                                    7.316,
                                                    0
                                                ],
                                                [
                                                    3.576,
                                                    -3.385
                                                ],
                                                [
                                                    0,
                                                    -4.817
                                                ],
                                                [
                                                    -2.189,
                                                    -1.432
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.587,
                                                    -0.618
                                                ],
                                                [
                                                    -2.299,
                                                    -1.362
                                                ],
                                                [
                                                    0,
                                                    -2.076
                                                ],
                                                [
                                                    1.75,
                                                    -1.265
                                                ],
                                                [
                                                    5.098,
                                                    0
                                                ],
                                                [
                                                    1.265,
                                                    1.619
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.064,
                                                    -3.385
                                                ],
                                                [
                                                    -3.529,
                                                    -4.621
                                                ],
                                                [
                                                    -6.103,
                                                    0
                                                ],
                                                [
                                                    -3.612,
                                                    3.06
                                                ],
                                                [
                                                    0,
                                                    4.2
                                                ],
                                                [
                                                    2.15,
                                                    1.367
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.804,
                                                    0.945
                                                ],
                                                [
                                                    2.018,
                                                    1.172
                                                ],
                                                [
                                                    0,
                                                    2.962
                                                ],
                                                [
                                                    -2.525,
                                                    1.416
                                                ],
                                                [
                                                    -5.581,
                                                    0
                                                ],
                                                [
                                                    -1.23,
                                                    -1.562
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    142.466,
                                                    -16.406
                                                ],
                                                [
                                                    147.731,
                                                    -3.296
                                                ],
                                                [
                                                    164.465,
                                                    2.002
                                                ],
                                                [
                                                    180.803,
                                                    -3.076
                                                ],
                                                [
                                                    186.167,
                                                    -15.137
                                                ],
                                                [
                                                    181.04,
                                                    -25.732
                                                ],
                                                [
                                                    168.106,
                                                    -30.176
                                                ],
                                                [
                                                    162.185,
                                                    -31.592
                                                ],
                                                [
                                                    156.315,
                                                    -33.736
                                                ],
                                                [
                                                    152.867,
                                                    -39.185
                                                ],
                                                [
                                                    155.49,
                                                    -44.196
                                                ],
                                                [
                                                    163.213,
                                                    -46.094
                                                ],
                                                [
                                                    173.96,
                                                    -42.646
                                                ],
                                                [
                                                    176.109,
                                                    -37.256
                                                ],
                                                [
                                                    184.41,
                                                    -37.256
                                                ],
                                                [
                                                    181.191,
                                                    -46.729
                                                ],
                                                [
                                                    163.922,
                                                    -53.662
                                                ],
                                                [
                                                    149.349,
                                                    -49.072
                                                ],
                                                [
                                                    143.931,
                                                    -37.061
                                                ],
                                                [
                                                    149.687,
                                                    -27.197
                                                ],
                                                [
                                                    159.711,
                                                    -23.486
                                                ],
                                                [
                                                    166.807,
                                                    -21.729
                                                ],
                                                [
                                                    174.449,
                                                    -19.238
                                                ],
                                                [
                                                    177.476,
                                                    -14.111
                                                ],
                                                [
                                                    173.688,
                                                    -7.544
                                                ],
                                                [
                                                    164.917,
                                                    -5.42
                                                ],
                                                [
                                                    153.156,
                                                    -9.668
                                                ],
                                                [
                                                    150.913,
                                                    -16.406
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "u",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.438,
                                                    -2.668
                                                ],
                                                [
                                                    -7.315,
                                                    0
                                                ],
                                                [
                                                    -3.29,
                                                    2.735
                                                ],
                                                [
                                                    -1.119,
                                                    1.986
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.173,
                                                    -2.929
                                                ],
                                                [
                                                    5.959,
                                                    0
                                                ],
                                                [
                                                    1.521,
                                                    3.125
                                                ],
                                                [
                                                    0,
                                                    2.669
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    4.46
                                                ],
                                                [
                                                    2.65,
                                                    4.981
                                                ],
                                                [
                                                    4.695,
                                                    0
                                                ],
                                                [
                                                    1.661,
                                                    -1.367
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    5.111
                                                ],
                                                [
                                                    -2.156,
                                                    5.469
                                                ],
                                                [
                                                    -4.154,
                                                    0
                                                ],
                                                [
                                                    -0.825,
                                                    -1.692
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    201.194,
                                                    -52.295
                                                ],
                                                [
                                                    201.194,
                                                    -16.748
                                                ],
                                                [
                                                    203.35,
                                                    -6.055
                                                ],
                                                [
                                                    218.298,
                                                    1.416
                                                ],
                                                [
                                                    230.275,
                                                    -2.686
                                                ],
                                                [
                                                    234.445,
                                                    -7.715
                                                ],
                                                [
                                                    234.348,
                                                    0
                                                ],
                                                [
                                                    242.649,
                                                    0
                                                ],
                                                [
                                                    242.649,
                                                    -52.295
                                                ],
                                                [
                                                    233.86,
                                                    -52.295
                                                ],
                                                [
                                                    233.86,
                                                    -26.611
                                                ],
                                                [
                                                    232.1,
                                                    -14.551
                                                ],
                                                [
                                                    219.927,
                                                    -6.348
                                                ],
                                                [
                                                    211.415,
                                                    -11.035
                                                ],
                                                [
                                                    210.178,
                                                    -17.578
                                                ],
                                                [
                                                    210.178,
                                                    -52.295
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "b",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.635,
                                                    -1.139
                                                ],
                                                [
                                                    -3.987,
                                                    0
                                                ],
                                                [
                                                    -4.02,
                                                    5.469
                                                ],
                                                [
                                                    0,
                                                    8.268
                                                ],
                                                [
                                                    4.068,
                                                    4.476
                                                ],
                                                [
                                                    6.535,
                                                    0
                                                ],
                                                [
                                                    2.68,
                                                    -1.318
                                                ],
                                                [
                                                    1.928,
                                                    -2.507
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.862,
                                                    2.507
                                                ],
                                                [
                                                    2.745,
                                                    1.921
                                                ],
                                                [
                                                    7.124,
                                                    0
                                                ],
                                                [
                                                    4.019,
                                                    -5.469
                                                ],
                                                [
                                                    0,
                                                    -8.724
                                                ],
                                                [
                                                    -4.068,
                                                    -4.476
                                                ],
                                                [
                                                    -3.137,
                                                    0
                                                ],
                                                [
                                                    -2.679,
                                                    1.319
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    261.972,
                                                    0
                                                ],
                                                [
                                                    270.077,
                                                    0
                                                ],
                                                [
                                                    270.077,
                                                    -6.689
                                                ],
                                                [
                                                    275.322,
                                                    -1.221
                                                ],
                                                [
                                                    285.419,
                                                    1.66
                                                ],
                                                [
                                                    302.134,
                                                    -6.543
                                                ],
                                                [
                                                    308.163,
                                                    -27.148
                                                ],
                                                [
                                                    302.06,
                                                    -46.948
                                                ],
                                                [
                                                    286.154,
                                                    -53.662
                                                ],
                                                [
                                                    277.428,
                                                    -51.685
                                                ],
                                                [
                                                    270.517,
                                                    -45.947
                                                ],
                                                [
                                                    270.517,
                                                    -71.973
                                                ],
                                                [
                                                    261.972,
                                                    -71.973
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    4.768,
                                                    0
                                                ],
                                                [
                                                    2.318,
                                                    5.762
                                                ],
                                                [
                                                    0,
                                                    4.916
                                                ],
                                                [
                                                    -3.021,
                                                    2.962
                                                ],
                                                [
                                                    -4.018,
                                                    0
                                                ],
                                                [
                                                    -2.369,
                                                    -3.613
                                                ],
                                                [
                                                    0,
                                                    -5.501
                                                ],
                                                [
                                                    2.368,
                                                    -3.775
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -6.337,
                                                    0
                                                ],
                                                [
                                                    -1.241,
                                                    -3.059
                                                ],
                                                [
                                                    0,
                                                    -6.803
                                                ],
                                                [
                                                    3.021,
                                                    -2.962
                                                ],
                                                [
                                                    4.605,
                                                    0
                                                ],
                                                [
                                                    2.368,
                                                    3.613
                                                ],
                                                [
                                                    0,
                                                    6.185
                                                ],
                                                [
                                                    -2.369,
                                                    3.777
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    284.873,
                                                    -6.104
                                                ],
                                                [
                                                    271.89,
                                                    -14.746
                                                ],
                                                [
                                                    270.028,
                                                    -26.709
                                                ],
                                                [
                                                    274.56,
                                                    -41.357
                                                ],
                                                [
                                                    285.118,
                                                    -45.801
                                                ],
                                                [
                                                    295.578,
                                                    -40.381
                                                ],
                                                [
                                                    299.13,
                                                    -26.709
                                                ],
                                                [
                                                    295.578,
                                                    -11.768
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "s",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.279,
                                                    -3.532
                                                ],
                                                [
                                                    -7.876,
                                                    0
                                                ],
                                                [
                                                    -3.576,
                                                    3.385
                                                ],
                                                [
                                                    0,
                                                    4.656
                                                ],
                                                [
                                                    3.418,
                                                    2.246
                                                ],
                                                [
                                                    6.434,
                                                    1.531
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.325,
                                                    0.811
                                                ],
                                                [
                                                    0,
                                                    2.27
                                                ],
                                                [
                                                    -1.75,
                                                    1.265
                                                ],
                                                [
                                                    -3.399,
                                                    0
                                                ],
                                                [
                                                    -2.066,
                                                    -2.298
                                                ],
                                                [
                                                    -0.167,
                                                    -1.974
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.21,
                                                    2.93
                                                ],
                                                [
                                                    7.983,
                                                    0
                                                ],
                                                [
                                                    3.612,
                                                    -3.06
                                                ],
                                                [
                                                    0,
                                                    -4.947
                                                ],
                                                [
                                                    -3.838,
                                                    -2.376
                                                ],
                                                [
                                                    -4.532,
                                                    -1.107
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.291,
                                                    -0.716
                                                ],
                                                [
                                                    0,
                                                    -2.246
                                                ],
                                                [
                                                    2.526,
                                                    -1.416
                                                ],
                                                [
                                                    3.321,
                                                    0
                                                ],
                                                [
                                                    2.259,
                                                    2.832
                                                ],
                                                [
                                                    0.265,
                                                    2.929
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.23,
                                                    5.208
                                                ],
                                                [
                                                    3.279,
                                                    3.532
                                                ],
                                                [
                                                    7.317,
                                                    0
                                                ],
                                                [
                                                    3.575,
                                                    -3.385
                                                ],
                                                [
                                                    0,
                                                    -4.817
                                                ],
                                                [
                                                    -2.19,
                                                    -1.432
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.588,
                                                    -0.618
                                                ],
                                                [
                                                    -2.3,
                                                    -1.362
                                                ],
                                                [
                                                    0,
                                                    -2.076
                                                ],
                                                [
                                                    1.749,
                                                    -1.265
                                                ],
                                                [
                                                    5.098,
                                                    0
                                                ],
                                                [
                                                    1.266,
                                                    1.619
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    -3.385
                                                ],
                                                [
                                                    -3.529,
                                                    -4.621
                                                ],
                                                [
                                                    -6.104,
                                                    0
                                                ],
                                                [
                                                    -3.613,
                                                    3.06
                                                ],
                                                [
                                                    0,
                                                    4.2
                                                ],
                                                [
                                                    2.15,
                                                    1.367
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.804,
                                                    0.945
                                                ],
                                                [
                                                    2.018,
                                                    1.172
                                                ],
                                                [
                                                    0,
                                                    2.962
                                                ],
                                                [
                                                    -2.525,
                                                    1.416
                                                ],
                                                [
                                                    -5.582,
                                                    0
                                                ],
                                                [
                                                    -1.23,
                                                    -1.562
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    320.797,
                                                    -16.406
                                                ],
                                                [
                                                    326.062,
                                                    -3.296
                                                ],
                                                [
                                                    342.795,
                                                    2.002
                                                ],
                                                [
                                                    359.134,
                                                    -3.076
                                                ],
                                                [
                                                    364.498,
                                                    -15.137
                                                ],
                                                [
                                                    359.371,
                                                    -25.732
                                                ],
                                                [
                                                    346.436,
                                                    -30.176
                                                ],
                                                [
                                                    340.516,
                                                    -31.592
                                                ],
                                                [
                                                    334.646,
                                                    -33.736
                                                ],
                                                [
                                                    331.197,
                                                    -39.185
                                                ],
                                                [
                                                    333.821,
                                                    -44.196
                                                ],
                                                [
                                                    341.543,
                                                    -46.094
                                                ],
                                                [
                                                    352.29,
                                                    -42.646
                                                ],
                                                [
                                                    354.439,
                                                    -37.256
                                                ],
                                                [
                                                    362.74,
                                                    -37.256
                                                ],
                                                [
                                                    359.522,
                                                    -46.729
                                                ],
                                                [
                                                    342.253,
                                                    -53.662
                                                ],
                                                [
                                                    327.68,
                                                    -49.072
                                                ],
                                                [
                                                    322.261,
                                                    -37.061
                                                ],
                                                [
                                                    328.018,
                                                    -27.197
                                                ],
                                                [
                                                    338.041,
                                                    -23.486
                                                ],
                                                [
                                                    345.137,
                                                    -21.729
                                                ],
                                                [
                                                    352.779,
                                                    -19.238
                                                ],
                                                [
                                                    355.806,
                                                    -14.111
                                                ],
                                                [
                                                    352.018,
                                                    -7.544
                                                ],
                                                [
                                                    343.248,
                                                    -5.42
                                                ],
                                                [
                                                    331.486,
                                                    -9.668
                                                ],
                                                [
                                                    329.244,
                                                    -16.406
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "c",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    5.892,
                                                    0
                                                ],
                                                [
                                                    4.46,
                                                    -5.11
                                                ],
                                                [
                                                    0,
                                                    -9.18
                                                ],
                                                [
                                                    -4.069,
                                                    -4.997
                                                ],
                                                [
                                                    -6.836,
                                                    0
                                                ],
                                                [
                                                    -3.906,
                                                    3.207
                                                ],
                                                [
                                                    -0.976,
                                                    6.934
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.132,
                                                    -2.221
                                                ],
                                                [
                                                    3.646,
                                                    0
                                                ],
                                                [
                                                    2.214,
                                                    3.577
                                                ],
                                                [
                                                    0,
                                                    5.234
                                                ],
                                                [
                                                    -1.563,
                                                    3.544
                                                ],
                                                [
                                                    -5.599,
                                                    0
                                                ],
                                                [
                                                    -1.856,
                                                    -2.132
                                                ],
                                                [
                                                    -0.521,
                                                    -3.222
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.694,
                                                    2.865
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -6.901,
                                                    0
                                                ],
                                                [
                                                    -4.46,
                                                    5.111
                                                ],
                                                [
                                                    0,
                                                    7.487
                                                ],
                                                [
                                                    4.069,
                                                    4.997
                                                ],
                                                [
                                                    6.087,
                                                    0
                                                ],
                                                [
                                                    3.906,
                                                    -3.206
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.814,
                                                    3.859
                                                ],
                                                [
                                                    -2.132,
                                                    2.221
                                                ],
                                                [
                                                    -4.753,
                                                    0
                                                ],
                                                [
                                                    -2.214,
                                                    -3.577
                                                ],
                                                [
                                                    0,
                                                    -5.202
                                                ],
                                                [
                                                    2.408,
                                                    -5.462
                                                ],
                                                [
                                                    4.102,
                                                    0
                                                ],
                                                [
                                                    1.855,
                                                    2.132
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.749,
                                                    -6.998
                                                ],
                                                [
                                                    -3.695,
                                                    -2.864
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    399.885,
                                                    -53.809
                                                ],
                                                [
                                                    382.844,
                                                    -46.143
                                                ],
                                                [
                                                    376.155,
                                                    -24.707
                                                ],
                                                [
                                                    382.258,
                                                    -5.981
                                                ],
                                                [
                                                    398.616,
                                                    1.514
                                                ],
                                                [
                                                    413.606,
                                                    -3.296
                                                ],
                                                [
                                                    420.93,
                                                    -18.506
                                                ],
                                                [
                                                    412.385,
                                                    -18.506
                                                ],
                                                [
                                                    407.966,
                                                    -9.386
                                                ],
                                                [
                                                    399.299,
                                                    -6.055
                                                ],
                                                [
                                                    388.85,
                                                    -11.419
                                                ],
                                                [
                                                    385.53,
                                                    -24.635
                                                ],
                                                [
                                                    387.874,
                                                    -37.754
                                                ],
                                                [
                                                    399.885,
                                                    -45.947
                                                ],
                                                [
                                                    408.821,
                                                    -42.749
                                                ],
                                                [
                                                    412.385,
                                                    -34.717
                                                ],
                                                [
                                                    420.93,
                                                    -34.717
                                                ],
                                                [
                                                    414.265,
                                                    -49.512
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "r",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.377,
                                                    2.849
                                                ],
                                                [
                                                    -4.427,
                                                    0
                                                ],
                                                [
                                                    -0.439,
                                                    -0.032
                                                ],
                                                [
                                                    -0.521,
                                                    -0.098
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.391,
                                                    0.033
                                                ],
                                                [
                                                    0.162,
                                                    0
                                                ],
                                                [
                                                    2.669,
                                                    -2.522
                                                ],
                                                [
                                                    0.684,
                                                    -1.758
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -3.711
                                                ],
                                                [
                                                    2.376,
                                                    -2.848
                                                ],
                                                [
                                                    0.52,
                                                    0
                                                ],
                                                [
                                                    0.44,
                                                    0.033
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.945,
                                                    -0.097
                                                ],
                                                [
                                                    -0.391,
                                                    -0.032
                                                ],
                                                [
                                                    -3.484,
                                                    0
                                                ],
                                                [
                                                    -2.669,
                                                    2.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    435.663,
                                                    0
                                                ],
                                                [
                                                    444.453,
                                                    0
                                                ],
                                                [
                                                    444.453,
                                                    -30.078
                                                ],
                                                [
                                                    448.017,
                                                    -39.917
                                                ],
                                                [
                                                    458.222,
                                                    -44.189
                                                ],
                                                [
                                                    459.662,
                                                    -44.141
                                                ],
                                                [
                                                    461.103,
                                                    -43.945
                                                ],
                                                [
                                                    461.103,
                                                    -53.223
                                                ],
                                                [
                                                    459.101,
                                                    -53.418
                                                ],
                                                [
                                                    458.271,
                                                    -53.467
                                                ],
                                                [
                                                    449.042,
                                                    -49.683
                                                ],
                                                [
                                                    444.013,
                                                    -43.262
                                                ],
                                                [
                                                    444.013,
                                                    -52.295
                                                ],
                                                [
                                                    435.663,
                                                    -52.295
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "i",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    474.42,
                                                    0
                                                ],
                                                [
                                                    483.356,
                                                    0
                                                ],
                                                [
                                                    483.356,
                                                    -52.051
                                                ],
                                                [
                                                    474.42,
                                                    -52.051
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    474.42,
                                                    -61.768
                                                ],
                                                [
                                                    483.356,
                                                    -61.768
                                                ],
                                                [
                                                    483.356,
                                                    -71.729
                                                ],
                                                [
                                                    474.42,
                                                    -71.729
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "p",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    4.116,
                                                    0
                                                ],
                                                [
                                                    2.285,
                                                    5.404
                                                ],
                                                [
                                                    0,
                                                    4.036
                                                ],
                                                [
                                                    -1.209,
                                                    3.256
                                                ],
                                                [
                                                    -6.108,
                                                    0
                                                ],
                                                [
                                                    -2.287,
                                                    -5.762
                                                ],
                                                [
                                                    0,
                                                    -4.166
                                                ],
                                                [
                                                    2.727,
                                                    -3.434
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -6.076,
                                                    0
                                                ],
                                                [
                                                    -1.209,
                                                    -2.832
                                                ],
                                                [
                                                    0,
                                                    -5.013
                                                ],
                                                [
                                                    2.253,
                                                    -6.086
                                                ],
                                                [
                                                    6.076,
                                                    0
                                                ],
                                                [
                                                    1.208,
                                                    2.995
                                                ],
                                                [
                                                    0,
                                                    6.836
                                                ],
                                                [
                                                    -2.728,
                                                    3.435
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    524.407,
                                                    -5.908
                                                ],
                                                [
                                                    511.865,
                                                    -14.014
                                                ],
                                                [
                                                    510.052,
                                                    -24.316
                                                ],
                                                [
                                                    511.865,
                                                    -36.719
                                                ],
                                                [
                                                    524.407,
                                                    -45.85
                                                ],
                                                [
                                                    536.95,
                                                    -37.207
                                                ],
                                                [
                                                    538.763,
                                                    -26.465
                                                ],
                                                [
                                                    534.672,
                                                    -11.06
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.569,
                                                    -0.977
                                                ],
                                                [
                                                    -3.955,
                                                    0
                                                ],
                                                [
                                                    -3.791,
                                                    3.092
                                                ],
                                                [
                                                    0,
                                                    11.394
                                                ],
                                                [
                                                    4.144,
                                                    4.541
                                                ],
                                                [
                                                    5.94,
                                                    0
                                                ],
                                                [
                                                    2.97,
                                                    -1.953
                                                ],
                                                [
                                                    1.763,
                                                    -2.376
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.928,
                                                    2.376
                                                ],
                                                [
                                                    2.679,
                                                    1.725
                                                ],
                                                [
                                                    5.032,
                                                    0
                                                ],
                                                [
                                                    5.98,
                                                    -4.883
                                                ],
                                                [
                                                    0,
                                                    -8.43
                                                ],
                                                [
                                                    -4.145,
                                                    -4.541
                                                ],
                                                [
                                                    -4.014,
                                                    0
                                                ],
                                                [
                                                    -2.089,
                                                    1.303
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    501.604,
                                                    20.85
                                                ],
                                                [
                                                    510.394,
                                                    20.85
                                                ],
                                                [
                                                    510.394,
                                                    -5.859
                                                ],
                                                [
                                                    515.639,
                                                    -0.83
                                                ],
                                                [
                                                    525.59,
                                                    1.758
                                                ],
                                                [
                                                    538.825,
                                                    -2.881
                                                ],
                                                [
                                                    547.796,
                                                    -27.295
                                                ],
                                                [
                                                    541.579,
                                                    -46.753
                                                ],
                                                [
                                                    526.451,
                                                    -53.564
                                                ],
                                                [
                                                    515.975,
                                                    -50.635
                                                ],
                                                [
                                                    510.198,
                                                    -45.117
                                                ],
                                                [
                                                    510.198,
                                                    -52.051
                                                ],
                                                [
                                                    501.604,
                                                    -52.051
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.465,
                                                    -2.1
                                                ],
                                                [
                                                    -4.102,
                                                    0
                                                ],
                                                [
                                                    -1.091,
                                                    0.129
                                                ],
                                                [
                                                    -1.009,
                                                    0.293
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.489,
                                                    -0.022
                                                ],
                                                [
                                                    0.423,
                                                    0
                                                ],
                                                [
                                                    0.684,
                                                    0.358
                                                ],
                                                [
                                                    0,
                                                    1.823
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    3.353
                                                ],
                                                [
                                                    1.465,
                                                    2.099
                                                ],
                                                [
                                                    1.269,
                                                    0
                                                ],
                                                [
                                                    1.09,
                                                    -0.131
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    0.087
                                                ],
                                                [
                                                    -0.488,
                                                    0.021
                                                ],
                                                [
                                                    -1.595,
                                                    0
                                                ],
                                                [
                                                    -1.237,
                                                    -0.618
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    565.41,
                                                    -52.295
                                                ],
                                                [
                                                    558.33,
                                                    -52.295
                                                ],
                                                [
                                                    558.33,
                                                    -45.117
                                                ],
                                                [
                                                    565.41,
                                                    -45.117
                                                ],
                                                [
                                                    565.41,
                                                    -10.498
                                                ],
                                                [
                                                    567.607,
                                                    -2.319
                                                ],
                                                [
                                                    575.957,
                                                    0.83
                                                ],
                                                [
                                                    579.497,
                                                    0.635
                                                ],
                                                [
                                                    582.646,
                                                    0
                                                ],
                                                [
                                                    582.646,
                                                    -6.982
                                                ],
                                                [
                                                    580.937,
                                                    -6.819
                                                ],
                                                [
                                                    579.57,
                                                    -6.787
                                                ],
                                                [
                                                    576.152,
                                                    -7.324
                                                ],
                                                [
                                                    574.297,
                                                    -10.986
                                                ],
                                                [
                                                    574.297,
                                                    -45.117
                                                ],
                                                [
                                                    582.646,
                                                    -45.117
                                                ],
                                                [
                                                    582.646,
                                                    -52.295
                                                ],
                                                [
                                                    574.297,
                                                    -52.295
                                                ],
                                                [
                                                    574.297,
                                                    -66.895
                                                ],
                                                [
                                                    565.41,
                                                    -66.895
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "i",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    597.135,
                                                    0
                                                ],
                                                [
                                                    606.071,
                                                    0
                                                ],
                                                [
                                                    606.071,
                                                    -52.051
                                                ],
                                                [
                                                    597.135,
                                                    -52.051
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    597.135,
                                                    -61.768
                                                ],
                                                [
                                                    606.071,
                                                    -61.768
                                                ],
                                                [
                                                    606.071,
                                                    -71.729
                                                ],
                                                [
                                                    597.135,
                                                    -71.729
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "o",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    5.761,
                                                    0
                                                ],
                                                [
                                                    2.414,
                                                    3.706
                                                ],
                                                [
                                                    0,
                                                    5.561
                                                ],
                                                [
                                                    -2.414,
                                                    4.097
                                                ],
                                                [
                                                    -5.311,
                                                    0
                                                ],
                                                [
                                                    -2.446,
                                                    -4.812
                                                ],
                                                [
                                                    0,
                                                    -4.877
                                                ],
                                                [
                                                    2.141,
                                                    -4.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -5.247,
                                                    0
                                                ],
                                                [
                                                    -2.414,
                                                    -3.707
                                                ],
                                                [
                                                    0,
                                                    -5.787
                                                ],
                                                [
                                                    2.414,
                                                    -4.097
                                                ],
                                                [
                                                    5.987,
                                                    0
                                                ],
                                                [
                                                    1.545,
                                                    3.056
                                                ],
                                                [
                                                    0,
                                                    5.397
                                                ],
                                                [
                                                    -2.14,
                                                    4.406
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    645.633,
                                                    -5.713
                                                ],
                                                [
                                                    634.142,
                                                    -11.272
                                                ],
                                                [
                                                    630.521,
                                                    -25.172
                                                ],
                                                [
                                                    634.142,
                                                    -39.997
                                                ],
                                                [
                                                    645.729,
                                                    -46.143
                                                ],
                                                [
                                                    658.379,
                                                    -38.924
                                                ],
                                                [
                                                    660.697,
                                                    -27.025
                                                ],
                                                [
                                                    657.485,
                                                    -12.321
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    6.691,
                                                    0
                                                ],
                                                [
                                                    4.428,
                                                    -5.203
                                                ],
                                                [
                                                    0,
                                                    -8.782
                                                ],
                                                [
                                                    -4.202,
                                                    -4.863
                                                ],
                                                [
                                                    -7.144,
                                                    0
                                                ],
                                                [
                                                    -4.073,
                                                    5.496
                                                ],
                                                [
                                                    0,
                                                    8.425
                                                ],
                                                [
                                                    4.622,
                                                    4.489
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -7.467,
                                                    0
                                                ],
                                                [
                                                    -4.428,
                                                    5.204
                                                ],
                                                [
                                                    0,
                                                    8.196
                                                ],
                                                [
                                                    4.203,
                                                    4.862
                                                ],
                                                [
                                                    8.566,
                                                    0
                                                ],
                                                [
                                                    4.072,
                                                    -5.496
                                                ],
                                                [
                                                    0,
                                                    -8.716
                                                ],
                                                [
                                                    -4.623,
                                                    -4.488
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    645.973,
                                                    -53.809
                                                ],
                                                [
                                                    628.13,
                                                    -46.003
                                                ],
                                                [
                                                    621.488,
                                                    -25.025
                                                ],
                                                [
                                                    627.79,
                                                    -5.437
                                                ],
                                                [
                                                    644.809,
                                                    1.855
                                                ],
                                                [
                                                    663.767,
                                                    -6.389
                                                ],
                                                [
                                                    669.876,
                                                    -27.27
                                                ],
                                                [
                                                    662.943,
                                                    -47.076
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.44,
                                                    1.839
                                                ],
                                                [
                                                    -1.465,
                                                    1.726
                                                ],
                                                [
                                                    -2.41,
                                                    0.717
                                                ],
                                                [
                                                    -2.084,
                                                    0
                                                ],
                                                [
                                                    -1.563,
                                                    -3.255
                                                ],
                                                [
                                                    0,
                                                    -3.19
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.432,
                                                    2.832
                                                ],
                                                [
                                                    7.422,
                                                    0
                                                ],
                                                [
                                                    2.767,
                                                    -1.334
                                                ],
                                                [
                                                    2.473,
                                                    -3.059
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -3.418
                                                ],
                                                [
                                                    0.439,
                                                    -1.839
                                                ],
                                                [
                                                    1.823,
                                                    -2.148
                                                ],
                                                [
                                                    1.334,
                                                    -0.423
                                                ],
                                                [
                                                    4.101,
                                                    0
                                                ],
                                                [
                                                    0.943,
                                                    1.953
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -5.273
                                                ],
                                                [
                                                    -2.605,
                                                    -5.176
                                                ],
                                                [
                                                    -3.386,
                                                    0
                                                ],
                                                [
                                                    -2.767,
                                                    1.335
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    686.367,
                                                    0
                                                ],
                                                [
                                                    695.156,
                                                    0
                                                ],
                                                [
                                                    695.156,
                                                    -27.393
                                                ],
                                                [
                                                    695.816,
                                                    -35.278
                                                ],
                                                [
                                                    698.672,
                                                    -40.625
                                                ],
                                                [
                                                    705.02,
                                                    -44.922
                                                ],
                                                [
                                                    710.147,
                                                    -45.557
                                                ],
                                                [
                                                    718.643,
                                                    -40.674
                                                ],
                                                [
                                                    720.059,
                                                    -32.959
                                                ],
                                                [
                                                    720.059,
                                                    0
                                                ],
                                                [
                                                    728.994,
                                                    0
                                                ],
                                                [
                                                    728.994,
                                                    -33.545
                                                ],
                                                [
                                                    726.846,
                                                    -45.703
                                                ],
                                                [
                                                    711.807,
                                                    -53.467
                                                ],
                                                [
                                                    702.578,
                                                    -51.465
                                                ],
                                                [
                                                    694.717,
                                                    -44.873
                                                ],
                                                [
                                                    694.717,
                                                    -52.295
                                                ],
                                                [
                                                    686.367,
                                                    -52.295
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "?",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    765.505,
                                                    0
                                                ],
                                                [
                                                    775.222,
                                                    0
                                                ],
                                                [
                                                    775.222,
                                                    -10.156
                                                ],
                                                [
                                                    765.505,
                                                    -10.156
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -7.031
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.196,
                                                    2.246
                                                ],
                                                [
                                                    -5.551,
                                                    0
                                                ],
                                                [
                                                    -1.944,
                                                    -2.344
                                                ],
                                                [
                                                    0,
                                                    -3.19
                                                ],
                                                [
                                                    1.352,
                                                    -2.115
                                                ],
                                                [
                                                    1.194,
                                                    -1.106
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.107,
                                                    -2.848
                                                ],
                                                [
                                                    0,
                                                    -4.654
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.964,
                                                    2.099
                                                ],
                                                [
                                                    -3.191,
                                                    3.027
                                                ],
                                                [
                                                    -1.416,
                                                    2.149
                                                ],
                                                [
                                                    0,
                                                    3.451
                                                ],
                                                [
                                                    3.904,
                                                    3.662
                                                ],
                                                [
                                                    6.492,
                                                    0
                                                ],
                                                [
                                                    4.02,
                                                    -4.28
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.166,
                                                    -4.231
                                                ],
                                                [
                                                    2.127,
                                                    -4.036
                                                ],
                                                [
                                                    4.486,
                                                    0
                                                ],
                                                [
                                                    1.944,
                                                    2.343
                                                ],
                                                [
                                                    0,
                                                    2.279
                                                ],
                                                [
                                                    -0.744,
                                                    1.205
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.819,
                                                    3.679
                                                ],
                                                [
                                                    -1.107,
                                                    2.849
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -4.101
                                                ],
                                                [
                                                    0.962,
                                                    -2.1
                                                ],
                                                [
                                                    4.387,
                                                    -4.166
                                                ],
                                                [
                                                    1.416,
                                                    -2.148
                                                ],
                                                [
                                                    0,
                                                    -5.696
                                                ],
                                                [
                                                    -3.905,
                                                    -3.662
                                                ],
                                                [
                                                    -7.019,
                                                    0
                                                ],
                                                [
                                                    -4.021,
                                                    4.281
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    748.854,
                                                    -49.268
                                                ],
                                                [
                                                    757.546,
                                                    -49.268
                                                ],
                                                [
                                                    759.59,
                                                    -58.984
                                                ],
                                                [
                                                    771.106,
                                                    -65.039
                                                ],
                                                [
                                                    780.752,
                                                    -61.523
                                                ],
                                                [
                                                    783.669,
                                                    -53.223
                                                ],
                                                [
                                                    781.641,
                                                    -46.631
                                                ],
                                                [
                                                    778.733,
                                                    -43.164
                                                ],
                                                [
                                                    774.748,
                                                    -39.307
                                                ],
                                                [
                                                    767.36,
                                                    -29.517
                                                ],
                                                [
                                                    765.7,
                                                    -18.262
                                                ],
                                                [
                                                    774.392,
                                                    -18.262
                                                ],
                                                [
                                                    775.837,
                                                    -27.563
                                                ],
                                                [
                                                    782.068,
                                                    -35.254
                                                ],
                                                [
                                                    790.773,
                                                    -44.727
                                                ],
                                                [
                                                    792.897,
                                                    -53.125
                                                ],
                                                [
                                                    787.04,
                                                    -67.163
                                                ],
                                                [
                                                    771.444,
                                                    -72.656
                                                ],
                                                [
                                                    754.885,
                                                    -66.235
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 6
                },
                {
                    "ty": 0,
                    "nm": "Comp_121",
                    "sr": 1,
                    "st": 0,
                    "op": 1636,
                    "ip": 0,
                    "ln": "34137",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                530.5,
                                275
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        100,
                                        100
                                    ],
                                    "t": 114.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        111.923,
                                        111.923
                                    ],
                                    "t": 137.997
                                },
                                {
                                    "s": [
                                        99,
                                        99
                                    ],
                                    "t": 160.997
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                3842.987,
                                898.599
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "ef": [
                        {
                            "ty": 25,
                            "nm": "Drop Shadow",
                            "en": 1,
                            "ef": [
                                {
                                    "ty": 2,
                                    "nm": "Shadow Color",
                                    "v": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Opacity",
                                    "v": {
                                        "a": 0,
                                        "k": 26
                                    }
                                },
                                {
                                    "ty": 1,
                                    "nm": "Direction",
                                    "v": {
                                        "a": 0,
                                        "k": 170.54
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Distance",
                                    "v": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    43.448
                                                ],
                                                "t": 0
                                            },
                                            {
                                                "o": {
                                                    "x": 0,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.645,
                                                    "y": 0.631
                                                },
                                                "s": [
                                                    43.448
                                                ],
                                                "t": 30
                                            },
                                            {
                                                "o": {
                                                    "x": 0.208,
                                                    "y": 0.616
                                                },
                                                "i": {
                                                    "x": 1,
                                                    "y": 1
                                                },
                                                "s": [
                                                    22.529
                                                ],
                                                "t": 74.997
                                            },
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    15.207
                                                ],
                                                "t": 119.997
                                            },
                                            {
                                                "o": {
                                                    "x": 0,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.372,
                                                    "y": 0.659
                                                },
                                                "s": [
                                                    15.207
                                                ],
                                                "t": 149.997
                                            },
                                            {
                                                "o": {
                                                    "x": 0.237,
                                                    "y": 0.695
                                                },
                                                "i": {
                                                    "x": 0.574,
                                                    "y": 0.999
                                                },
                                                "s": [
                                                    15.883
                                                ],
                                                "t": 157.497
                                            },
                                            {
                                                "o": {
                                                    "x": 0.752,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.365,
                                                    "y": 0.684
                                                },
                                                "s": [
                                                    16.007
                                                ],
                                                "t": 164.997
                                            },
                                            {
                                                "o": {
                                                    "x": 0.217,
                                                    "y": 0.647
                                                },
                                                "i": {
                                                    "x": 0.538,
                                                    "y": 0.999
                                                },
                                                "s": [
                                                    15.321
                                                ],
                                                "t": 172.497
                                            },
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    15.207
                                                ],
                                                "t": 179.997
                                            },
                                            {
                                                "s": [
                                                    15.207
                                                ],
                                                "t": 599.989
                                            }
                                        ]
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Softness",
                                    "v": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    114.29
                                                ],
                                                "t": 0
                                            },
                                            {
                                                "o": {
                                                    "x": 0,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.645,
                                                    "y": 0.631
                                                },
                                                "s": [
                                                    114.29
                                                ],
                                                "t": 30
                                            },
                                            {
                                                "o": {
                                                    "x": 0.208,
                                                    "y": 0.616
                                                },
                                                "i": {
                                                    "x": 1,
                                                    "y": 1
                                                },
                                                "s": [
                                                    59.26
                                                ],
                                                "t": 74.997
                                            },
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    40
                                                ],
                                                "t": 119.997
                                            },
                                            {
                                                "o": {
                                                    "x": 0,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.372,
                                                    "y": 0.659
                                                },
                                                "s": [
                                                    40
                                                ],
                                                "t": 149.997
                                            },
                                            {
                                                "o": {
                                                    "x": 0.237,
                                                    "y": 0.695
                                                },
                                                "i": {
                                                    "x": 0.574,
                                                    "y": 0.999
                                                },
                                                "s": [
                                                    41.78
                                                ],
                                                "t": 157.497
                                            },
                                            {
                                                "o": {
                                                    "x": 0.752,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.365,
                                                    "y": 0.684
                                                },
                                                "s": [
                                                    42.11
                                                ],
                                                "t": 164.997
                                            },
                                            {
                                                "o": {
                                                    "x": 0.217,
                                                    "y": 0.647
                                                },
                                                "i": {
                                                    "x": 0.538,
                                                    "y": 0.999
                                                },
                                                "s": [
                                                    40.3
                                                ],
                                                "t": 172.497
                                            },
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    40
                                                ],
                                                "t": 179.997
                                            },
                                            {
                                                "s": [
                                                    40
                                                ],
                                                "t": 599.989
                                            }
                                        ]
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Shadow Only",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            ]
                        }
                    ],
                    "w": 1061,
                    "h": 550,
                    "refId": "13",
                    "ind": 7
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 5",
                    "sr": 1,
                    "st": 0,
                    "op": 9354,
                    "ip": 0,
                    "ln": "34122",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                761.535,
                                756.495
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "ef": [
                        {
                            "ty": 25,
                            "nm": "Drop Shadow",
                            "en": 1,
                            "ef": [
                                {
                                    "ty": 2,
                                    "nm": "Shadow Color",
                                    "v": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Opacity",
                                    "v": {
                                        "a": 0,
                                        "k": 38
                                    }
                                },
                                {
                                    "ty": 1,
                                    "nm": "Direction",
                                    "v": {
                                        "a": 0,
                                        "k": 158.2
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Distance",
                                    "v": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    76.931
                                                ],
                                                "t": 0
                                            },
                                            {
                                                "o": {
                                                    "x": 0,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.646,
                                                    "y": 0.632
                                                },
                                                "s": [
                                                    76.931
                                                ],
                                                "t": 30
                                            },
                                            {
                                                "o": {
                                                    "x": 0.208,
                                                    "y": 0.615
                                                },
                                                "i": {
                                                    "x": 0.456,
                                                    "y": 1
                                                },
                                                "s": [
                                                    39.89
                                                ],
                                                "t": 74.997
                                            },
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    26.926
                                                ],
                                                "t": 119.997
                                            },
                                            {
                                                "s": [
                                                    26.926
                                                ],
                                                "t": 599.989
                                            }
                                        ]
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Softness",
                                    "v": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    285.71
                                                ],
                                                "t": 0
                                            },
                                            {
                                                "o": {
                                                    "x": 0,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.646,
                                                    "y": 0.632
                                                },
                                                "s": [
                                                    285.71
                                                ],
                                                "t": 30
                                            },
                                            {
                                                "o": {
                                                    "x": 0.208,
                                                    "y": 0.615
                                                },
                                                "i": {
                                                    "x": 0.456,
                                                    "y": 1
                                                },
                                                "s": [
                                                    148.15
                                                ],
                                                "t": 74.997
                                            },
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    100
                                                ],
                                                "t": 119.997
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 599.989
                                            }
                                        ]
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Shadow Only",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            ]
                        }
                    ],
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "undefined",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "undefined",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            1745,
                                            143.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            4215.29,
                                            1012.29
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "undefined",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "undefined",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "undefined",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            1745,
                                            143.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 999
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            3490,
                                            287
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "undefined",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 8
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 8",
                    "sr": 1,
                    "st": 0,
                    "op": 9970,
                    "ip": 0,
                    "ln": "34121",
                    "hasMask": false,
                    "td": 1,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                714.258,
                                719.714
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "rc",
                            "nm": "undefined",
                            "d": 1,
                            "p": {
                                "a": 0,
                                "k": [
                                    1791,
                                    183.5
                                ]
                            },
                            "r": {
                                "a": 0,
                                "k": 999
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    3582,
                                    367
                                ]
                            }
                        },
                        {
                            "ty": "fl",
                            "nm": "undefined",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100
                            }
                        }
                    ],
                    "ind": 9
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 7",
                    "sr": 1,
                    "st": 0,
                    "op": 9970,
                    "ip": 0,
                    "ln": "34120",
                    "tt": 1,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                714.258,
                                719.714
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "undefined",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "undefined",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            1791,
                                            183.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            3584,
                                            369
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "undefined",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "undefined",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "undefined",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            1791,
                                            183.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 999
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            3582,
                                            367
                                        ]
                                    }
                                },
                                {
                                    "ty": "gs",
                                    "nm": "undefined",
                                    "e": {
                                        "a": 0,
                                        "k": [
                                            3549.21,
                                            532.291
                                        ]
                                    },
                                    "g": {
                                        "p": 2,
                                        "k": {
                                            "a": 0,
                                            "k": [
                                                0,
                                                1,
                                                1,
                                                1,
                                                1,
                                                0,
                                                0,
                                                0
                                            ]
                                        }
                                    },
                                    "t": 1,
                                    "a": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "h": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            32.79,
                                            -165.291
                                        ]
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 10,
                    "tp": 9
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 6",
                    "sr": 1,
                    "st": 0,
                    "op": 9970,
                    "ip": 0,
                    "ln": "34119",
                    "tt": 1,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                714.258,
                                719.714
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "rc",
                            "nm": "undefined",
                            "d": 1,
                            "p": {
                                "a": 0,
                                "k": [
                                    1791,
                                    183.5
                                ]
                            },
                            "r": {
                                "a": 0,
                                "k": 999
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    3582,
                                    367
                                ]
                            }
                        },
                        {
                            "ty": "fl",
                            "nm": "undefined",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 34.9
                            }
                        }
                    ],
                    "ind": 11,
                    "tp": 9
                }
            ]
        },
        {
            "nm": "Comp_121",
            "id": "13",
            "fr": 60,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Send Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 9999,
                    "ip": 0,
                    "ln": "34136",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -1.27,
                                -46.433
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                532.439,
                                272.849
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "S",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -6.4,
                                                    -5.882
                                                ],
                                                [
                                                    -11.308,
                                                    0
                                                ],
                                                [
                                                    -7.326,
                                                    4.444
                                                ],
                                                [
                                                    0,
                                                    10.326
                                                ],
                                                [
                                                    5.741,
                                                    4.359
                                                ],
                                                [
                                                    6.109,
                                                    1.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.419,
                                                    1.355
                                                ],
                                                [
                                                    0,
                                                    4.57
                                                ],
                                                [
                                                    -3.124,
                                                    3.132
                                                ],
                                                [
                                                    -7.141,
                                                    0
                                                ],
                                                [
                                                    -3.693,
                                                    -4.866
                                                ],
                                                [
                                                    -0.609,
                                                    -4.993
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    6.65,
                                                    4.719
                                                ],
                                                [
                                                    9.512,
                                                    0
                                                ],
                                                [
                                                    5.641,
                                                    -5.374
                                                ],
                                                [
                                                    0,
                                                    -8.379
                                                ],
                                                [
                                                    -5.739,
                                                    -3.893
                                                ],
                                                [
                                                    -7.994,
                                                    -1.862
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.117,
                                                    -2.116
                                                ],
                                                [
                                                    0,
                                                    -5.078
                                                ],
                                                [
                                                    7.256,
                                                    -2.623
                                                ],
                                                [
                                                    4.566,
                                                    0
                                                ],
                                                [
                                                    4.036,
                                                    6.179
                                                ],
                                                [
                                                    0.286,
                                                    5.29
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.127,
                                                    10.072
                                                ],
                                                [
                                                    6.397,
                                                    5.925
                                                ],
                                                [
                                                    9.698,
                                                    0
                                                ],
                                                [
                                                    7.325,
                                                    -4.443
                                                ],
                                                [
                                                    0,
                                                    -8.293
                                                ],
                                                [
                                                    -3.32,
                                                    -2.497
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -8.528,
                                                    -2.031
                                                ],
                                                [
                                                    -3.691,
                                                    -2.116
                                                ],
                                                [
                                                    0,
                                                    -4.147
                                                ],
                                                [
                                                    3.124,
                                                    -3.132
                                                ],
                                                [
                                                    8.844,
                                                    0
                                                ],
                                                [
                                                    1.987,
                                                    2.666
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -10.367
                                                ],
                                                [
                                                    -6.651,
                                                    -4.718
                                                ],
                                                [
                                                    -10.337,
                                                    0
                                                ],
                                                [
                                                    -5.642,
                                                    5.374
                                                ],
                                                [
                                                    0,
                                                    7.744
                                                ],
                                                [
                                                    3.321,
                                                    2.243
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    6.642,
                                                    1.567
                                                ],
                                                [
                                                    3.074,
                                                    2.158
                                                ],
                                                [
                                                    0,
                                                    6.772
                                                ],
                                                [
                                                    -3.752,
                                                    1.355
                                                ],
                                                [
                                                    -10.191,
                                                    0
                                                ],
                                                [
                                                    -2.119,
                                                    -3.301
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -156.635,
                                                    -30.088
                                                ],
                                                [
                                                    -147.226,
                                                    -6.157
                                                ],
                                                [
                                                    -120.669,
                                                    2.729
                                                ],
                                                [
                                                    -95.133,
                                                    -3.936
                                                ],
                                                [
                                                    -84.145,
                                                    -26.089
                                                ],
                                                [
                                                    -92.756,
                                                    -45.068
                                                ],
                                                [
                                                    -106.901,
                                                    -50.972
                                                ],
                                                [
                                                    -119.571,
                                                    -53.955
                                                ],
                                                [
                                                    -135.992,
                                                    -59.033
                                                ],
                                                [
                                                    -141.528,
                                                    -69.062
                                                ],
                                                [
                                                    -136.842,
                                                    -79.98
                                                ],
                                                [
                                                    -121.444,
                                                    -84.678
                                                ],
                                                [
                                                    -102.639,
                                                    -77.378
                                                ],
                                                [
                                                    -98.744,
                                                    -65.889
                                                ],
                                                [
                                                    -86.874,
                                                    -65.889
                                                ],
                                                [
                                                    -96.85,
                                                    -88.518
                                                ],
                                                [
                                                    -121.095,
                                                    -95.596
                                                ],
                                                [
                                                    -145.062,
                                                    -87.534
                                                ],
                                                [
                                                    -153.525,
                                                    -66.904
                                                ],
                                                [
                                                    -144.916,
                                                    -49.448
                                                ],
                                                [
                                                    -127.944,
                                                    -43.291
                                                ],
                                                [
                                                    -115.707,
                                                    -40.435
                                                ],
                                                [
                                                    -101.071,
                                                    -34.912
                                                ],
                                                [
                                                    -96.459,
                                                    -24.058
                                                ],
                                                [
                                                    -107.343,
                                                    -9.966
                                                ],
                                                [
                                                    -119.818,
                                                    -7.935
                                                ],
                                                [
                                                    -141.158,
                                                    -17.202
                                                ],
                                                [
                                                    -144.765,
                                                    -30.088
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "e",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    4.795,
                                                    0
                                                ],
                                                [
                                                    5.887,
                                                    -6.813
                                                ],
                                                [
                                                    0,
                                                    -10.918
                                                ],
                                                [
                                                    -5.845,
                                                    -6.157
                                                ],
                                                [
                                                    -8.411,
                                                    0
                                                ],
                                                [
                                                    -2.731,
                                                    0.677
                                                ],
                                                [
                                                    -3.444,
                                                    3.386
                                                ],
                                                [
                                                    -1.672,
                                                    3.069
                                                ],
                                                [
                                                    -0.297,
                                                    2.497
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.974,
                                                    -2.295
                                                ],
                                                [
                                                    5.92,
                                                    0
                                                ],
                                                [
                                                    3.023,
                                                    4.179
                                                ],
                                                [
                                                    0.21,
                                                    6.917
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.673,
                                                    3.132
                                                ],
                                                [
                                                    2.271,
                                                    3.427
                                                ],
                                                [
                                                    4.5,
                                                    2.264
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -9.505,
                                                    0
                                                ],
                                                [
                                                    -5.889,
                                                    6.814
                                                ],
                                                [
                                                    0,
                                                    11.087
                                                ],
                                                [
                                                    5.846,
                                                    6.157
                                                ],
                                                [
                                                    3.444,
                                                    0
                                                ],
                                                [
                                                    5.081,
                                                    -1.185
                                                ],
                                                [
                                                    2.057,
                                                    -1.946
                                                ],
                                                [
                                                    1.671,
                                                    -3.068
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.823,
                                                    3.019
                                                ],
                                                [
                                                    -3.527,
                                                    3.954
                                                ],
                                                [
                                                    -6.34,
                                                    0
                                                ],
                                                [
                                                    -3.023,
                                                    -4.18
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.855
                                                ],
                                                [
                                                    -0.758,
                                                    -4.571
                                                ],
                                                [
                                                    -2.356,
                                                    -3.597
                                                ],
                                                [
                                                    -4.5,
                                                    -2.263
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -32.372,
                                                    -69.507
                                                ],
                                                [
                                                    -55.461,
                                                    -59.287
                                                ],
                                                [
                                                    -64.293,
                                                    -32.69
                                                ],
                                                [
                                                    -55.526,
                                                    -6.824
                                                ],
                                                [
                                                    -34.141,
                                                    2.412
                                                ],
                                                [
                                                    -24.88,
                                                    1.396
                                                ],
                                                [
                                                    -12.092,
                                                    -5.459
                                                ],
                                                [
                                                    -6.498,
                                                    -12.981
                                                ],
                                                [
                                                    -3.546,
                                                    -21.328
                                                ],
                                                [
                                                    -14.782,
                                                    -21.328
                                                ],
                                                [
                                                    -18.977,
                                                    -13.357
                                                ],
                                                [
                                                    -33.148,
                                                    -7.427
                                                ],
                                                [
                                                    -47.192,
                                                    -13.696
                                                ],
                                                [
                                                    -52.042,
                                                    -30.342
                                                ],
                                                [
                                                    -2.594,
                                                    -30.342
                                                ],
                                                [
                                                    -3.604,
                                                    -45.322
                                                ],
                                                [
                                                    -8.146,
                                                    -57.319
                                                ],
                                                [
                                                    -18.43,
                                                    -66.111
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.525,
                                                    3.788
                                                ],
                                                [
                                                    -5.203,
                                                    0
                                                ],
                                                [
                                                    -3.105,
                                                    -5.501
                                                ],
                                                [
                                                    -0.463,
                                                    -4.951
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.209,
                                                    -5.84
                                                ],
                                                [
                                                    3.525,
                                                    -3.787
                                                ],
                                                [
                                                    7.259,
                                                    0
                                                ],
                                                [
                                                    1.678,
                                                    2.963
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -51.788,
                                                    -39.419
                                                ],
                                                [
                                                    -46.187,
                                                    -53.86
                                                ],
                                                [
                                                    -33.095,
                                                    -59.541
                                                ],
                                                [
                                                    -17.548,
                                                    -51.289
                                                ],
                                                [
                                                    -14.337,
                                                    -39.419
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.571,
                                                    2.391
                                                ],
                                                [
                                                    -1.905,
                                                    2.243
                                                ],
                                                [
                                                    -3.133,
                                                    0.931
                                                ],
                                                [
                                                    -2.709,
                                                    0
                                                ],
                                                [
                                                    -2.032,
                                                    -4.231
                                                ],
                                                [
                                                    0,
                                                    -4.146
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.861,
                                                    3.682
                                                ],
                                                [
                                                    9.648,
                                                    0
                                                ],
                                                [
                                                    3.596,
                                                    -1.735
                                                ],
                                                [
                                                    3.215,
                                                    -3.977
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -4.444
                                                ],
                                                [
                                                    0.572,
                                                    -2.39
                                                ],
                                                [
                                                    2.369,
                                                    -2.793
                                                ],
                                                [
                                                    1.734,
                                                    -0.55
                                                ],
                                                [
                                                    5.332,
                                                    0
                                                ],
                                                [
                                                    1.226,
                                                    2.539
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.856
                                                ],
                                                [
                                                    -3.387,
                                                    -6.729
                                                ],
                                                [
                                                    -4.402,
                                                    0
                                                ],
                                                [
                                                    -3.598,
                                                    1.735
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    19.288,
                                                    0
                                                ],
                                                [
                                                    30.714,
                                                    0
                                                ],
                                                [
                                                    30.714,
                                                    -35.61
                                                ],
                                                [
                                                    31.571,
                                                    -45.862
                                                ],
                                                [
                                                    35.285,
                                                    -52.812
                                                ],
                                                [
                                                    43.537,
                                                    -58.398
                                                ],
                                                [
                                                    50.202,
                                                    -59.224
                                                ],
                                                [
                                                    61.247,
                                                    -52.876
                                                ],
                                                [
                                                    63.087,
                                                    -42.847
                                                ],
                                                [
                                                    63.087,
                                                    0
                                                ],
                                                [
                                                    74.704,
                                                    0
                                                ],
                                                [
                                                    74.704,
                                                    -43.608
                                                ],
                                                [
                                                    71.911,
                                                    -59.414
                                                ],
                                                [
                                                    52.36,
                                                    -69.507
                                                ],
                                                [
                                                    40.363,
                                                    -66.904
                                                ],
                                                [
                                                    30.143,
                                                    -58.335
                                                ],
                                                [
                                                    30.143,
                                                    -67.983
                                                ],
                                                [
                                                    19.288,
                                                    -67.983
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "d",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    7.279
                                                ],
                                                [
                                                    -3.558,
                                                    4.402
                                                ],
                                                [
                                                    -5.727,
                                                    0
                                                ],
                                                [
                                                    -3.495,
                                                    -4.126
                                                ],
                                                [
                                                    0,
                                                    -8.59
                                                ],
                                                [
                                                    3.389,
                                                    -4.549
                                                ],
                                                [
                                                    5.262,
                                                    0
                                                ],
                                                [
                                                    3.073,
                                                    4.91
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -8.548
                                                ],
                                                [
                                                    3.557,
                                                    -4.401
                                                ],
                                                [
                                                    5.136,
                                                    0
                                                ],
                                                [
                                                    3.494,
                                                    4.126
                                                ],
                                                [
                                                    0,
                                                    8.506
                                                ],
                                                [
                                                    -3.39,
                                                    4.549
                                                ],
                                                [
                                                    -6.779,
                                                    0
                                                ],
                                                [
                                                    -3.074,
                                                    -4.909
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    106.235,
                                                    -33.198
                                                ],
                                                [
                                                    111.571,
                                                    -52.622
                                                ],
                                                [
                                                    125.497,
                                                    -59.224
                                                ],
                                                [
                                                    138.444,
                                                    -53.035
                                                ],
                                                [
                                                    143.686,
                                                    -33.96
                                                ],
                                                [
                                                    138.602,
                                                    -14.377
                                                ],
                                                [
                                                    125.624,
                                                    -7.554
                                                ],
                                                [
                                                    110.845,
                                                    -14.917
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    5.185,
                                                    0
                                                ],
                                                [
                                                    5.037,
                                                    -7.257
                                                ],
                                                [
                                                    0,
                                                    -9.903
                                                ],
                                                [
                                                    -5.523,
                                                    -6.369
                                                ],
                                                [
                                                    -7.546,
                                                    0
                                                ],
                                                [
                                                    -3.626,
                                                    1.862
                                                ],
                                                [
                                                    -2.656,
                                                    4.189
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.024,
                                                    1.27
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -9.359,
                                                    0
                                                ],
                                                [
                                                    -5.038,
                                                    7.258
                                                ],
                                                [
                                                    0,
                                                    10.579
                                                ],
                                                [
                                                    5.522,
                                                    6.369
                                                ],
                                                [
                                                    4.68,
                                                    0
                                                ],
                                                [
                                                    3.626,
                                                    -1.862
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.571,
                                                    -3.173
                                                ],
                                                [
                                                    -3.499,
                                                    -2.2
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    123.324,
                                                    -69.189
                                                ],
                                                [
                                                    101.73,
                                                    -58.303
                                                ],
                                                [
                                                    94.174,
                                                    -32.563
                                                ],
                                                [
                                                    102.458,
                                                    -7.141
                                                ],
                                                [
                                                    122.06,
                                                    2.412
                                                ],
                                                [
                                                    134.517,
                                                    -0.381
                                                ],
                                                [
                                                    143.94,
                                                    -9.458
                                                ],
                                                [
                                                    143.94,
                                                    0
                                                ],
                                                [
                                                    154.223,
                                                    0
                                                ],
                                                [
                                                    154.223,
                                                    -93.564
                                                ],
                                                [
                                                    143.241,
                                                    -93.564
                                                ],
                                                [
                                                    143.241,
                                                    -59.224
                                                ],
                                                [
                                                    136.349,
                                                    -65.889
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 4",
                    "sr": 1,
                    "st": 0,
                    "op": 9984,
                    "ip": 0,
                    "ln": "34135",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                163.245,
                                163.245
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "rc",
                            "nm": "undefined",
                            "d": 1,
                            "p": {
                                "a": 0,
                                "k": [
                                    372.697,
                                    117.143
                                ]
                            },
                            "r": {
                                "a": 0,
                                "k": 1000
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    745.394,
                                    234.286
                                ]
                            }
                        },
                        {
                            "ty": "fl",
                            "nm": "undefined",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.4196,
                                    0.2902,
                                    0.8
                                ]
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100
                            }
                        }
                    ],
                    "ind": 2
                }
            ]
        },
        {
            "nm": "Comp_715",
            "id": "14",
            "fr": 60,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Webpage header.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 6326,
                    "ip": 0,
                    "ln": "34316",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                278,
                                31.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                194.842,
                                197.011
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                1730.921,
                                1251.75
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 556,
                    "h": 63,
                    "refId": "15",
                    "ind": 1
                },
                {
                    "ty": 0,
                    "nm": "Comp_718",
                    "sr": 1,
                    "st": 0,
                    "op": 9999,
                    "ip": 0,
                    "ln": "34098",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "ef": [
                        {
                            "ty": 25,
                            "nm": "Drop Shadow",
                            "en": 0,
                            "ef": [
                                {
                                    "ty": 2,
                                    "nm": "Shadow Color",
                                    "v": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Opacity",
                                    "v": {
                                        "a": 0,
                                        "k": 64
                                    }
                                },
                                {
                                    "ty": 1,
                                    "nm": "Direction",
                                    "v": {
                                        "a": 0,
                                        "k": -126.87
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Distance",
                                    "v": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    250
                                                ],
                                                "t": 0
                                            },
                                            {
                                                "o": {
                                                    "x": 0,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.264,
                                                    "y": 0.814
                                                },
                                                "s": [
                                                    250
                                                ],
                                                "t": 165.176
                                            },
                                            {
                                                "o": {
                                                    "x": 0.286,
                                                    "y": 0.474
                                                },
                                                "i": {
                                                    "x": 0.627,
                                                    "y": 0.782
                                                },
                                                "s": [
                                                    147.865
                                                ],
                                                "t": 176.426
                                            },
                                            {
                                                "o": {
                                                    "x": 0.192,
                                                    "y": 0.479
                                                },
                                                "i": {
                                                    "x": 0.504,
                                                    "y": 0.999
                                                },
                                                "s": [
                                                    132.283
                                                ],
                                                "t": 187.676
                                            },
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    125
                                                ],
                                                "t": 210.176
                                            },
                                            {
                                                "s": [
                                                    125
                                                ],
                                                "t": 599.989
                                            }
                                        ]
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Softness",
                                    "v": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    800
                                                ],
                                                "t": 0
                                            },
                                            {
                                                "o": {
                                                    "x": 0,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.264,
                                                    "y": 0.814
                                                },
                                                "s": [
                                                    800
                                                ],
                                                "t": 165.176
                                            },
                                            {
                                                "o": {
                                                    "x": 0.286,
                                                    "y": 0.474
                                                },
                                                "i": {
                                                    "x": 0.627,
                                                    "y": 0.782
                                                },
                                                "s": [
                                                    473.17
                                                ],
                                                "t": 176.426
                                            },
                                            {
                                                "o": {
                                                    "x": 0.192,
                                                    "y": 0.479
                                                },
                                                "i": {
                                                    "x": 0.504,
                                                    "y": 0.999
                                                },
                                                "s": [
                                                    423.31
                                                ],
                                                "t": 187.676
                                            },
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    400
                                                ],
                                                "t": 210.176
                                            },
                                            {
                                                "s": [
                                                    400
                                                ],
                                                "t": 599.989
                                            }
                                        ]
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Shadow Only",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            ]
                        },
                        {
                            "ty": 29,
                            "nm": "Gaussian Blur",
                            "en": 1,
                            "ef": [
                                {
                                    "ty": 0,
                                    "nm": "Blurriness",
                                    "v": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    166.67
                                                ],
                                                "t": 0
                                            },
                                            {
                                                "o": {
                                                    "x": 0,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.264,
                                                    "y": 0.814
                                                },
                                                "s": [
                                                    166.67
                                                ],
                                                "t": 165.176
                                            },
                                            {
                                                "o": {
                                                    "x": 0.286,
                                                    "y": 0.474
                                                },
                                                "i": {
                                                    "x": 0.627,
                                                    "y": 0.782
                                                },
                                                "s": [
                                                    30.49
                                                ],
                                                "t": 176.426
                                            },
                                            {
                                                "o": {
                                                    "x": 0.192,
                                                    "y": 0.479
                                                },
                                                "i": {
                                                    "x": 0.504,
                                                    "y": 0.999
                                                },
                                                "s": [
                                                    9.71
                                                ],
                                                "t": 187.676
                                            },
                                            {
                                                "h": 1,
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 210.176
                                            },
                                            {
                                                "s": [
                                                    0
                                                ],
                                                "t": 599.989
                                            }
                                        ]
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Blur Dimensions",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": " ",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            ]
                        }
                    ],
                    "w": 3543,
                    "h": 3542,
                    "refId": "16",
                    "ind": 2
                }
            ]
        },
        {
            "nm": "Webpage header.svg",
            "id": "15",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Webpage header.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 6326,
                    "ip": 0,
                    "ln": "34302",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                278,
                                31.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                278,
                                31.5
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.784,
                                                    0
                                                ],
                                                [
                                                    0.584,
                                                    0.36
                                                ],
                                                [
                                                    0.312,
                                                    0.664
                                                ],
                                                [
                                                    0,
                                                    0.904
                                                ],
                                                [
                                                    -0.311,
                                                    0.672
                                                ],
                                                [
                                                    -0.576,
                                                    0.36
                                                ],
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.577,
                                                    -0.36
                                                ],
                                                [
                                                    -0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.912
                                                ],
                                                [
                                                    0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0.583,
                                                    -0.36
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.36
                                                ],
                                                [
                                                    -0.311,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.912
                                                ],
                                                [
                                                    0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0.584,
                                                    -0.36
                                                ],
                                                [
                                                    0.784,
                                                    0
                                                ],
                                                [
                                                    0.583,
                                                    0.36
                                                ],
                                                [
                                                    0.312,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.904
                                                ],
                                                [
                                                    -0.312,
                                                    0.664
                                                ],
                                                [
                                                    -0.577,
                                                    0.36
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.242,
                                                    4.452
                                                ],
                                                [
                                                    -15.294,
                                                    3.912
                                                ],
                                                [
                                                    -16.626,
                                                    2.376
                                                ],
                                                [
                                                    -17.094,
                                                    0.012
                                                ],
                                                [
                                                    -16.626,
                                                    -2.364
                                                ],
                                                [
                                                    -15.294,
                                                    -3.912
                                                ],
                                                [
                                                    -13.242,
                                                    -4.452
                                                ],
                                                [
                                                    -11.201,
                                                    -3.912
                                                ],
                                                [
                                                    -9.858,
                                                    -2.364
                                                ],
                                                [
                                                    -9.39,
                                                    0.012
                                                ],
                                                [
                                                    -9.858,
                                                    2.376
                                                ],
                                                [
                                                    -11.201,
                                                    3.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.6,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.264
                                                ],
                                                [
                                                    -0.216,
                                                    0.512
                                                ],
                                                [
                                                    0,
                                                    0.736
                                                ],
                                                [
                                                    0.216,
                                                    0.52
                                                ],
                                                [
                                                    0.416,
                                                    0.272
                                                ],
                                                [
                                                    0.6,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.272
                                                ],
                                                [
                                                    0.216,
                                                    -0.52
                                                ],
                                                [
                                                    0,
                                                    -0.736
                                                ],
                                                [
                                                    -0.216,
                                                    -0.52
                                                ],
                                                [
                                                    -0.416,
                                                    -0.272
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.6,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.272
                                                ],
                                                [
                                                    0.216,
                                                    -0.52
                                                ],
                                                [
                                                    0,
                                                    -0.736
                                                ],
                                                [
                                                    -0.216,
                                                    -0.52
                                                ],
                                                [
                                                    -0.416,
                                                    -0.272
                                                ],
                                                [
                                                    -0.6,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.272
                                                ],
                                                [
                                                    -0.216,
                                                    0.52
                                                ],
                                                [
                                                    0,
                                                    0.736
                                                ],
                                                [
                                                    0.216,
                                                    0.512
                                                ],
                                                [
                                                    0.416,
                                                    0.264
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.242,
                                                    3.468
                                                ],
                                                [
                                                    -11.718,
                                                    3.072
                                                ],
                                                [
                                                    -10.77,
                                                    1.896
                                                ],
                                                [
                                                    -10.446,
                                                    0.012
                                                ],
                                                [
                                                    -10.77,
                                                    -1.872
                                                ],
                                                [
                                                    -11.718,
                                                    -3.06
                                                ],
                                                [
                                                    -13.242,
                                                    -3.468
                                                ],
                                                [
                                                    -14.766,
                                                    -3.06
                                                ],
                                                [
                                                    -15.714,
                                                    -1.872
                                                ],
                                                [
                                                    -16.038,
                                                    0.012
                                                ],
                                                [
                                                    -15.714,
                                                    1.896
                                                ],
                                                [
                                                    -14.766,
                                                    3.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0.272
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.368,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.712
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0.264
                                                ],
                                                [
                                                    0.2,
                                                    0.136
                                                ],
                                                [
                                                    0.32,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.584
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.104,
                                                    -0.544
                                                ],
                                                [
                                                    0.376,
                                                    -0.28
                                                ],
                                                [
                                                    0.696,
                                                    0
                                                ],
                                                [
                                                    0.368,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.4
                                                ],
                                                [
                                                    -0.096,
                                                    -0.272
                                                ],
                                                [
                                                    -0.2,
                                                    -0.144
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.304,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -7.113,
                                                    -2.1
                                                ],
                                                [
                                                    -7.065,
                                                    -0.468
                                                ],
                                                [
                                                    -7.197,
                                                    -0.6
                                                ],
                                                [
                                                    -6.477,
                                                    -1.824
                                                ],
                                                [
                                                    -5.121,
                                                    -2.244
                                                ],
                                                [
                                                    -3.525,
                                                    -1.572
                                                ],
                                                [
                                                    -2.973,
                                                    0.168
                                                ],
                                                [
                                                    -2.973,
                                                    4.26
                                                ],
                                                [
                                                    -3.957,
                                                    4.26
                                                ],
                                                [
                                                    -3.957,
                                                    0.456
                                                ],
                                                [
                                                    -4.101,
                                                    -0.54
                                                ],
                                                [
                                                    -4.545,
                                                    -1.152
                                                ],
                                                [
                                                    -5.325,
                                                    -1.368
                                                ],
                                                [
                                                    -6.573,
                                                    -0.888
                                                ],
                                                [
                                                    -7.029,
                                                    0.456
                                                ],
                                                [
                                                    -7.029,
                                                    4.26
                                                ],
                                                [
                                                    -8.013,
                                                    4.26
                                                ],
                                                [
                                                    -8.013,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.064
                                                ],
                                                [
                                                    -0.136,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.232,
                                                    0.224
                                                ],
                                                [
                                                    0,
                                                    0.36
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.136
                                                ],
                                                [
                                                    0.072,
                                                    0.064
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    -0.232
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.161,
                                                    -4.26
                                                ],
                                                [
                                                    -0.161,
                                                    2.988
                                                ],
                                                [
                                                    -0.065,
                                                    3.288
                                                ],
                                                [
                                                    0.247,
                                                    3.384
                                                ],
                                                [
                                                    0.787,
                                                    3.384
                                                ],
                                                [
                                                    0.787,
                                                    4.26
                                                ],
                                                [
                                                    0.103,
                                                    4.26
                                                ],
                                                [
                                                    -0.809,
                                                    3.924
                                                ],
                                                [
                                                    -1.145,
                                                    3.036
                                                ],
                                                [
                                                    -1.145,
                                                    -4.26
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.178,
                                                    -2.1
                                                ],
                                                [
                                                    3.178,
                                                    4.26
                                                ],
                                                [
                                                    2.194,
                                                    4.26
                                                ],
                                                [
                                                    2.194,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.202,
                                                    -4.236
                                                ],
                                                [
                                                    3.202,
                                                    -3.096
                                                ],
                                                [
                                                    2.17,
                                                    -3.096
                                                ],
                                                [
                                                    2.17,
                                                    -4.236
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0.272
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.368,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.712
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0.264
                                                ],
                                                [
                                                    0.2,
                                                    0.136
                                                ],
                                                [
                                                    0.32,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.584
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.104,
                                                    -0.544
                                                ],
                                                [
                                                    0.376,
                                                    -0.28
                                                ],
                                                [
                                                    0.696,
                                                    0
                                                ],
                                                [
                                                    0.368,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.4
                                                ],
                                                [
                                                    -0.096,
                                                    -0.272
                                                ],
                                                [
                                                    -0.2,
                                                    -0.144
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.304,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.941,
                                                    -2.1
                                                ],
                                                [
                                                    5.989,
                                                    -0.468
                                                ],
                                                [
                                                    5.857,
                                                    -0.6
                                                ],
                                                [
                                                    6.577,
                                                    -1.824
                                                ],
                                                [
                                                    7.933,
                                                    -2.244
                                                ],
                                                [
                                                    9.529,
                                                    -1.572
                                                ],
                                                [
                                                    10.081,
                                                    0.168
                                                ],
                                                [
                                                    10.081,
                                                    4.26
                                                ],
                                                [
                                                    9.097,
                                                    4.26
                                                ],
                                                [
                                                    9.097,
                                                    0.456
                                                ],
                                                [
                                                    8.953,
                                                    -0.54
                                                ],
                                                [
                                                    8.509,
                                                    -1.152
                                                ],
                                                [
                                                    7.729,
                                                    -1.368
                                                ],
                                                [
                                                    6.481,
                                                    -0.888
                                                ],
                                                [
                                                    6.025,
                                                    0.456
                                                ],
                                                [
                                                    6.025,
                                                    4.26
                                                ],
                                                [
                                                    5.042,
                                                    4.26
                                                ],
                                                [
                                                    5.042,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.672
                                                ],
                                                [
                                                    -0.24,
                                                    0.496
                                                ],
                                                [
                                                    -0.431,
                                                    0.272
                                                ],
                                                [
                                                    -0.584,
                                                    0
                                                ],
                                                [
                                                    -0.4,
                                                    -0.224
                                                ],
                                                [
                                                    -0.248,
                                                    -0.48
                                                ],
                                                [
                                                    -0.032,
                                                    -0.72
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    -0.368
                                                ],
                                                [
                                                    -0.544,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.192
                                                ],
                                                [
                                                    -0.144,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.488,
                                                    -0.352
                                                ],
                                                [
                                                    0.616,
                                                    0
                                                ],
                                                [
                                                    0.44,
                                                    0.272
                                                ],
                                                [
                                                    0.24,
                                                    0.496
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.672
                                                ],
                                                [
                                                    0.24,
                                                    -0.504
                                                ],
                                                [
                                                    0.44,
                                                    -0.272
                                                ],
                                                [
                                                    0.496,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    0.224
                                                ],
                                                [
                                                    0.256,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.048,
                                                    0.656
                                                ],
                                                [
                                                    0.328,
                                                    0.36
                                                ],
                                                [
                                                    0.353,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.184,
                                                    0.592
                                                ],
                                                [
                                                    -0.488,
                                                    0.352
                                                ],
                                                [
                                                    -0.584,
                                                    0
                                                ],
                                                [
                                                    -0.431,
                                                    -0.272
                                                ],
                                                [
                                                    -0.24,
                                                    -0.504
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.417,
                                                    1.08
                                                ],
                                                [
                                                    11.777,
                                                    -0.672
                                                ],
                                                [
                                                    12.785,
                                                    -1.836
                                                ],
                                                [
                                                    14.321,
                                                    -2.244
                                                ],
                                                [
                                                    15.665,
                                                    -1.908
                                                ],
                                                [
                                                    16.649,
                                                    -0.852
                                                ],
                                                [
                                                    17.081,
                                                    0.948
                                                ],
                                                [
                                                    17.093,
                                                    1.392
                                                ],
                                                [
                                                    12.461,
                                                    1.392
                                                ],
                                                [
                                                    13.013,
                                                    2.928
                                                ],
                                                [
                                                    14.321,
                                                    3.468
                                                ],
                                                [
                                                    15.281,
                                                    3.18
                                                ],
                                                [
                                                    15.929,
                                                    2.388
                                                ],
                                                [
                                                    16.985,
                                                    2.46
                                                ],
                                                [
                                                    15.977,
                                                    3.876
                                                ],
                                                [
                                                    14.321,
                                                    4.404
                                                ],
                                                [
                                                    12.785,
                                                    3.996
                                                ],
                                                [
                                                    11.777,
                                                    2.844
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    0.288
                                                ],
                                                [
                                                    0.432,
                                                    0
                                                ],
                                                [
                                                    0.312,
                                                    -0.32
                                                ],
                                                [
                                                    0.088,
                                                    -0.584
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.088,
                                                    -0.632
                                                ],
                                                [
                                                    -0.304,
                                                    -0.296
                                                ],
                                                [
                                                    -0.512,
                                                    0
                                                ],
                                                [
                                                    -0.312,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    16.013,
                                                    0.516
                                                ],
                                                [
                                                    15.425,
                                                    -0.864
                                                ],
                                                [
                                                    14.321,
                                                    -1.308
                                                ],
                                                [
                                                    13.085,
                                                    -0.828
                                                ],
                                                [
                                                    12.485,
                                                    0.516
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9333,
                                            0.9255,
                                            0.9255
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            94.682,
                                            43.24
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.485
                                                ],
                                                [
                                                    2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.485
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.485
                                                ],
                                                [
                                                    -2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.485
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -4.5
                                                ],
                                                [
                                                    4.5,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    4.5
                                                ],
                                                [
                                                    -4.5,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.1216,
                                            0.7569,
                                            0.4196
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            64.5,
                                            43.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.811,
                                                    0.512
                                                ],
                                                [
                                                    0.437,
                                                    0.896
                                                ],
                                                [
                                                    0,
                                                    1.12
                                                ],
                                                [
                                                    -0.427,
                                                    0.907
                                                ],
                                                [
                                                    -0.811,
                                                    0.512
                                                ],
                                                [
                                                    -1.077,
                                                    0
                                                ],
                                                [
                                                    -0.811,
                                                    -0.523
                                                ],
                                                [
                                                    -0.427,
                                                    -0.907
                                                ],
                                                [
                                                    0,
                                                    -1.12
                                                ],
                                                [
                                                    0.373,
                                                    -0.853
                                                ],
                                                [
                                                    0.672,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.077,
                                                    0
                                                ],
                                                [
                                                    -0.8,
                                                    -0.523
                                                ],
                                                [
                                                    -0.437,
                                                    -0.896
                                                ],
                                                [
                                                    0,
                                                    -1.12
                                                ],
                                                [
                                                    0.437,
                                                    -0.907
                                                ],
                                                [
                                                    0.811,
                                                    -0.523
                                                ],
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.811,
                                                    0.512
                                                ],
                                                [
                                                    0.427,
                                                    0.907
                                                ],
                                                [
                                                    0,
                                                    1.024
                                                ],
                                                [
                                                    -0.363,
                                                    0.843
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.64,
                                                    0.245
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -45.291,
                                                    5.544
                                                ],
                                                [
                                                    -48.123,
                                                    4.776
                                                ],
                                                [
                                                    -49.979,
                                                    2.648
                                                ],
                                                [
                                                    -50.635,
                                                    -0.376
                                                ],
                                                [
                                                    -49.995,
                                                    -3.416
                                                ],
                                                [
                                                    -48.123,
                                                    -5.544
                                                ],
                                                [
                                                    -45.291,
                                                    -6.328
                                                ],
                                                [
                                                    -42.443,
                                                    -5.544
                                                ],
                                                [
                                                    -40.587,
                                                    -3.416
                                                ],
                                                [
                                                    -39.947,
                                                    -0.376
                                                ],
                                                [
                                                    -40.507,
                                                    2.44
                                                ],
                                                [
                                                    -42.059,
                                                    4.488
                                                ],
                                                [
                                                    -40.603,
                                                    6.328
                                                ],
                                                [
                                                    -42.331,
                                                    6.328
                                                ],
                                                [
                                                    -43.227,
                                                    5.176
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.779
                                                ],
                                                [
                                                    -0.245,
                                                    -0.629
                                                ],
                                                [
                                                    -0.491,
                                                    -0.373
                                                ],
                                                [
                                                    -0.704,
                                                    0
                                                ],
                                                [
                                                    -0.245,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.203,
                                                    0.576
                                                ],
                                                [
                                                    0,
                                                    0.693
                                                ],
                                                [
                                                    0.245,
                                                    0.619
                                                ],
                                                [
                                                    0.491,
                                                    0.373
                                                ],
                                                [
                                                    0.725,
                                                    0
                                                ],
                                                [
                                                    0.491,
                                                    -0.384
                                                ],
                                                [
                                                    0.245,
                                                    -0.629
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.768
                                                ],
                                                [
                                                    0.245,
                                                    0.619
                                                ],
                                                [
                                                    0.491,
                                                    0.373
                                                ],
                                                [
                                                    0.32,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.373
                                                ],
                                                [
                                                    0.213,
                                                    -0.587
                                                ],
                                                [
                                                    0,
                                                    -0.779
                                                ],
                                                [
                                                    -0.235,
                                                    -0.629
                                                ],
                                                [
                                                    -0.48,
                                                    -0.384
                                                ],
                                                [
                                                    -0.715,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    0.373
                                                ],
                                                [
                                                    -0.245,
                                                    0.619
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -48.555,
                                                    -0.376
                                                ],
                                                [
                                                    -48.187,
                                                    1.72
                                                ],
                                                [
                                                    -47.083,
                                                    3.208
                                                ],
                                                [
                                                    -45.291,
                                                    3.768
                                                ],
                                                [
                                                    -44.443,
                                                    3.656
                                                ],
                                                [
                                                    -46.011,
                                                    1.656
                                                ],
                                                [
                                                    -44.283,
                                                    1.656
                                                ],
                                                [
                                                    -43.275,
                                                    2.968
                                                ],
                                                [
                                                    -42.347,
                                                    1.544
                                                ],
                                                [
                                                    -42.027,
                                                    -0.376
                                                ],
                                                [
                                                    -42.395,
                                                    -2.472
                                                ],
                                                [
                                                    -43.483,
                                                    -3.976
                                                ],
                                                [
                                                    -45.291,
                                                    -4.552
                                                ],
                                                [
                                                    -47.099,
                                                    -3.976
                                                ],
                                                [
                                                    -48.187,
                                                    -2.472
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.491,
                                                    -0.384
                                                ],
                                                [
                                                    0.704,
                                                    0
                                                ],
                                                [
                                                    0.502,
                                                    0.587
                                                ],
                                                [
                                                    0,
                                                    0.971
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.096,
                                                    -0.32
                                                ],
                                                [
                                                    -0.202,
                                                    -0.171
                                                ],
                                                [
                                                    -0.362,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.138,
                                                    0.811
                                                ],
                                                [
                                                    -0.49,
                                                    0.373
                                                ],
                                                [
                                                    -0.906,
                                                    0
                                                ],
                                                [
                                                    -0.501,
                                                    -0.587
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.512
                                                ],
                                                [
                                                    0.107,
                                                    0.32
                                                ],
                                                [
                                                    0.214,
                                                    0.16
                                                ],
                                                [
                                                    0.555,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -32.526,
                                                    5.288
                                                ],
                                                [
                                                    -32.574,
                                                    2.984
                                                ],
                                                [
                                                    -32.318,
                                                    3.128
                                                ],
                                                [
                                                    -33.262,
                                                    4.92
                                                ],
                                                [
                                                    -35.054,
                                                    5.48
                                                ],
                                                [
                                                    -37.166,
                                                    4.6
                                                ],
                                                [
                                                    -37.918,
                                                    2.264
                                                ],
                                                [
                                                    -37.918,
                                                    -3.192
                                                ],
                                                [
                                                    -35.934,
                                                    -3.192
                                                ],
                                                [
                                                    -35.934,
                                                    1.624
                                                ],
                                                [
                                                    -35.79,
                                                    2.872
                                                ],
                                                [
                                                    -35.326,
                                                    3.608
                                                ],
                                                [
                                                    -34.462,
                                                    3.848
                                                ],
                                                [
                                                    -33.15,
                                                    3.288
                                                ],
                                                [
                                                    -32.67,
                                                    1.624
                                                ],
                                                [
                                                    -32.67,
                                                    -3.192
                                                ],
                                                [
                                                    -30.686,
                                                    -3.192
                                                ],
                                                [
                                                    -30.686,
                                                    5.288
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.832,
                                                    0
                                                ],
                                                [
                                                    0.63,
                                                    0.363
                                                ],
                                                [
                                                    0.352,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    -0.341,
                                                    0.661
                                                ],
                                                [
                                                    -0.618,
                                                    0.363
                                                ],
                                                [
                                                    -0.832,
                                                    0
                                                ],
                                                [
                                                    -0.629,
                                                    -0.363
                                                ],
                                                [
                                                    -0.341,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.342,
                                                    -0.672
                                                ],
                                                [
                                                    0.63,
                                                    -0.363
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.832,
                                                    0
                                                ],
                                                [
                                                    -0.618,
                                                    -0.363
                                                ],
                                                [
                                                    -0.341,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.352,
                                                    -0.672
                                                ],
                                                [
                                                    0.63,
                                                    -0.363
                                                ],
                                                [
                                                    0.832,
                                                    0
                                                ],
                                                [
                                                    0.63,
                                                    0.363
                                                ],
                                                [
                                                    0.342,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    -0.341,
                                                    0.672
                                                ],
                                                [
                                                    -0.629,
                                                    0.363
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -24.648,
                                                    5.48
                                                ],
                                                [
                                                    -26.84,
                                                    4.936
                                                ],
                                                [
                                                    -28.296,
                                                    3.384
                                                ],
                                                [
                                                    -28.808,
                                                    1.048
                                                ],
                                                [
                                                    -28.296,
                                                    -1.288
                                                ],
                                                [
                                                    -26.84,
                                                    -2.84
                                                ],
                                                [
                                                    -24.648,
                                                    -3.384
                                                ],
                                                [
                                                    -22.456,
                                                    -2.84
                                                ],
                                                [
                                                    -21,
                                                    -1.288
                                                ],
                                                [
                                                    -20.488,
                                                    1.048
                                                ],
                                                [
                                                    -21,
                                                    3.384
                                                ],
                                                [
                                                    -22.456,
                                                    4.936
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.672,
                                                    0
                                                ],
                                                [
                                                    -0.362,
                                                    0.491
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    0.363,
                                                    0.491
                                                ],
                                                [
                                                    0.683,
                                                    0
                                                ],
                                                [
                                                    0.374,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.885
                                                ],
                                                [
                                                    -0.362,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.683,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.885
                                                ],
                                                [
                                                    -0.362,
                                                    -0.491
                                                ],
                                                [
                                                    -0.672,
                                                    0
                                                ],
                                                [
                                                    -0.362,
                                                    0.491
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    0.374,
                                                    0.491
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -24.648,
                                                    3.848
                                                ],
                                                [
                                                    -23.08,
                                                    3.112
                                                ],
                                                [
                                                    -22.536,
                                                    1.048
                                                ],
                                                [
                                                    -23.08,
                                                    -1.016
                                                ],
                                                [
                                                    -24.648,
                                                    -1.752
                                                ],
                                                [
                                                    -26.216,
                                                    -1.016
                                                ],
                                                [
                                                    -26.76,
                                                    1.048
                                                ],
                                                [
                                                    -26.216,
                                                    3.112
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -16.749,
                                                    -6.072
                                                ],
                                                [
                                                    -16.749,
                                                    0.696
                                                ],
                                                [
                                                    -13.245,
                                                    -3.192
                                                ],
                                                [
                                                    -10.781,
                                                    -3.192
                                                ],
                                                [
                                                    -14.093,
                                                    0.328
                                                ],
                                                [
                                                    -10.637,
                                                    5.288
                                                ],
                                                [
                                                    -12.877,
                                                    5.288
                                                ],
                                                [
                                                    -15.389,
                                                    1.528
                                                ],
                                                [
                                                    -16.749,
                                                    3
                                                ],
                                                [
                                                    -16.749,
                                                    5.288
                                                ],
                                                [
                                                    -18.733,
                                                    5.288
                                                ],
                                                [
                                                    -18.733,
                                                    -6.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -6.702,
                                                    -6.072
                                                ],
                                                [
                                                    -6.702,
                                                    0.696
                                                ],
                                                [
                                                    -3.198,
                                                    -3.192
                                                ],
                                                [
                                                    -0.734,
                                                    -3.192
                                                ],
                                                [
                                                    -4.046,
                                                    0.328
                                                ],
                                                [
                                                    -0.59,
                                                    5.288
                                                ],
                                                [
                                                    -2.83,
                                                    5.288
                                                ],
                                                [
                                                    -5.342,
                                                    1.528
                                                ],
                                                [
                                                    -6.702,
                                                    3
                                                ],
                                                [
                                                    -6.702,
                                                    5.288
                                                ],
                                                [
                                                    -8.686,
                                                    5.288
                                                ],
                                                [
                                                    -8.686,
                                                    -6.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.63,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.086,
                                                    -0.096
                                                ],
                                                [
                                                    -0.171,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    0.053
                                                ],
                                                [
                                                    0.224,
                                                    0.192
                                                ],
                                                [
                                                    0.032,
                                                    0.395
                                                ],
                                                [
                                                    0.48,
                                                    -0.277
                                                ],
                                                [
                                                    0.693,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.246,
                                                    0.331
                                                ],
                                                [
                                                    -0.448,
                                                    0.192
                                                ],
                                                [
                                                    -0.736,
                                                    0.139
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.277,
                                                    0.309
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    -0.245
                                                ],
                                                [
                                                    0.106,
                                                    -0.459
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.17,
                                                    -0.875
                                                ],
                                                [
                                                    0.65,
                                                    -0.491
                                                ],
                                                [
                                                    1.216,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    0.619
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.224
                                                ],
                                                [
                                                    0.096,
                                                    0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.011
                                                ],
                                                [
                                                    -0.288,
                                                    -0.053
                                                ],
                                                [
                                                    -0.224,
                                                    -0.192
                                                ],
                                                [
                                                    -0.214,
                                                    0.437
                                                ],
                                                [
                                                    -0.48,
                                                    0.277
                                                ],
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.533
                                                ],
                                                [
                                                    0.256,
                                                    -0.331
                                                ],
                                                [
                                                    0.458,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.011,
                                                    -0.651
                                                ],
                                                [
                                                    -0.278,
                                                    -0.32
                                                ],
                                                [
                                                    -0.448,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.821,
                                                    -0.616
                                                ],
                                                [
                                                    2.053,
                                                    -2.648
                                                ],
                                                [
                                                    4.565,
                                                    -3.384
                                                ],
                                                [
                                                    7.333,
                                                    -2.456
                                                ],
                                                [
                                                    8.277,
                                                    0.248
                                                ],
                                                [
                                                    8.277,
                                                    3.208
                                                ],
                                                [
                                                    8.405,
                                                    3.688
                                                ],
                                                [
                                                    8.805,
                                                    3.816
                                                ],
                                                [
                                                    9.125,
                                                    3.816
                                                ],
                                                [
                                                    9.125,
                                                    5.288
                                                ],
                                                [
                                                    8.629,
                                                    5.304
                                                ],
                                                [
                                                    8.565,
                                                    5.304
                                                ],
                                                [
                                                    7.685,
                                                    5.24
                                                ],
                                                [
                                                    6.917,
                                                    4.872
                                                ],
                                                [
                                                    6.533,
                                                    3.992
                                                ],
                                                [
                                                    5.493,
                                                    5.064
                                                ],
                                                [
                                                    3.733,
                                                    5.48
                                                ],
                                                [
                                                    1.541,
                                                    4.824
                                                ],
                                                [
                                                    0.677,
                                                    3.064
                                                ],
                                                [
                                                    1.045,
                                                    1.768
                                                ],
                                                [
                                                    2.101,
                                                    0.984
                                                ],
                                                [
                                                    3.893,
                                                    0.488
                                                ],
                                                [
                                                    6.277,
                                                    0.008
                                                ],
                                                [
                                                    5.845,
                                                    -1.432
                                                ],
                                                [
                                                    4.565,
                                                    -1.912
                                                ],
                                                [
                                                    3.445,
                                                    -1.544
                                                ],
                                                [
                                                    2.853,
                                                    -0.504
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.288
                                                ],
                                                [
                                                    -0.256,
                                                    -0.203
                                                ],
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    0.192
                                                ],
                                                [
                                                    -0.171,
                                                    0.384
                                                ],
                                                [
                                                    0,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.075
                                                ],
                                                [
                                                    0.138,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.309
                                                ],
                                                [
                                                    0.266,
                                                    0.192
                                                ],
                                                [
                                                    0.394,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.192
                                                ],
                                                [
                                                    0.181,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.075
                                                ],
                                                [
                                                    -0.214,
                                                    0.075
                                                ],
                                                [
                                                    -0.139,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.725,
                                                    3
                                                ],
                                                [
                                                    3.109,
                                                    3.768
                                                ],
                                                [
                                                    4.245,
                                                    4.056
                                                ],
                                                [
                                                    5.301,
                                                    3.768
                                                ],
                                                [
                                                    6.037,
                                                    2.904
                                                ],
                                                [
                                                    6.309,
                                                    1.48
                                                ],
                                                [
                                                    6.309,
                                                    1.4
                                                ],
                                                [
                                                    4.677,
                                                    1.688
                                                ],
                                                [
                                                    4.389,
                                                    1.736
                                                ],
                                                [
                                                    3.461,
                                                    1.96
                                                ],
                                                [
                                                    2.933,
                                                    2.328
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    14.739,
                                                    -6.072
                                                ],
                                                [
                                                    16.755,
                                                    -6.072
                                                ],
                                                [
                                                    16.755,
                                                    4.632
                                                ],
                                                [
                                                    15.651,
                                                    3.512
                                                ],
                                                [
                                                    22.163,
                                                    3.512
                                                ],
                                                [
                                                    22.163,
                                                    5.288
                                                ],
                                                [
                                                    14.739,
                                                    5.288
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.63,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.086,
                                                    -0.096
                                                ],
                                                [
                                                    -0.171,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    0.053
                                                ],
                                                [
                                                    0.224,
                                                    0.192
                                                ],
                                                [
                                                    0.032,
                                                    0.395
                                                ],
                                                [
                                                    0.48,
                                                    -0.277
                                                ],
                                                [
                                                    0.693,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.246,
                                                    0.331
                                                ],
                                                [
                                                    -0.448,
                                                    0.192
                                                ],
                                                [
                                                    -0.736,
                                                    0.139
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.277,
                                                    0.309
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    -0.245
                                                ],
                                                [
                                                    0.106,
                                                    -0.459
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.17,
                                                    -0.875
                                                ],
                                                [
                                                    0.65,
                                                    -0.491
                                                ],
                                                [
                                                    1.216,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    0.619
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.224
                                                ],
                                                [
                                                    0.096,
                                                    0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.011
                                                ],
                                                [
                                                    -0.288,
                                                    -0.053
                                                ],
                                                [
                                                    -0.224,
                                                    -0.192
                                                ],
                                                [
                                                    -0.214,
                                                    0.437
                                                ],
                                                [
                                                    -0.48,
                                                    0.277
                                                ],
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.533
                                                ],
                                                [
                                                    0.256,
                                                    -0.331
                                                ],
                                                [
                                                    0.458,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.011,
                                                    -0.651
                                                ],
                                                [
                                                    -0.278,
                                                    -0.32
                                                ],
                                                [
                                                    -0.448,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    23.618,
                                                    -0.616
                                                ],
                                                [
                                                    24.85,
                                                    -2.648
                                                ],
                                                [
                                                    27.362,
                                                    -3.384
                                                ],
                                                [
                                                    30.13,
                                                    -2.456
                                                ],
                                                [
                                                    31.074,
                                                    0.248
                                                ],
                                                [
                                                    31.074,
                                                    3.208
                                                ],
                                                [
                                                    31.202,
                                                    3.688
                                                ],
                                                [
                                                    31.602,
                                                    3.816
                                                ],
                                                [
                                                    31.922,
                                                    3.816
                                                ],
                                                [
                                                    31.922,
                                                    5.288
                                                ],
                                                [
                                                    31.426,
                                                    5.304
                                                ],
                                                [
                                                    31.362,
                                                    5.304
                                                ],
                                                [
                                                    30.482,
                                                    5.24
                                                ],
                                                [
                                                    29.714,
                                                    4.872
                                                ],
                                                [
                                                    29.33,
                                                    3.992
                                                ],
                                                [
                                                    28.29,
                                                    5.064
                                                ],
                                                [
                                                    26.53,
                                                    5.48
                                                ],
                                                [
                                                    24.338,
                                                    4.824
                                                ],
                                                [
                                                    23.474,
                                                    3.064
                                                ],
                                                [
                                                    23.842,
                                                    1.768
                                                ],
                                                [
                                                    24.898,
                                                    0.984
                                                ],
                                                [
                                                    26.69,
                                                    0.488
                                                ],
                                                [
                                                    29.074,
                                                    0.008
                                                ],
                                                [
                                                    28.642,
                                                    -1.432
                                                ],
                                                [
                                                    27.362,
                                                    -1.912
                                                ],
                                                [
                                                    26.242,
                                                    -1.544
                                                ],
                                                [
                                                    25.65,
                                                    -0.504
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.288
                                                ],
                                                [
                                                    -0.256,
                                                    -0.203
                                                ],
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    0.192
                                                ],
                                                [
                                                    -0.171,
                                                    0.384
                                                ],
                                                [
                                                    0,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.075
                                                ],
                                                [
                                                    0.138,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.309
                                                ],
                                                [
                                                    0.266,
                                                    0.192
                                                ],
                                                [
                                                    0.394,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.192
                                                ],
                                                [
                                                    0.181,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.075
                                                ],
                                                [
                                                    -0.214,
                                                    0.075
                                                ],
                                                [
                                                    -0.139,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.522,
                                                    3
                                                ],
                                                [
                                                    25.906,
                                                    3.768
                                                ],
                                                [
                                                    27.042,
                                                    4.056
                                                ],
                                                [
                                                    28.098,
                                                    3.768
                                                ],
                                                [
                                                    28.834,
                                                    2.904
                                                ],
                                                [
                                                    29.106,
                                                    1.48
                                                ],
                                                [
                                                    29.106,
                                                    1.4
                                                ],
                                                [
                                                    27.474,
                                                    1.688
                                                ],
                                                [
                                                    27.186,
                                                    1.736
                                                ],
                                                [
                                                    26.258,
                                                    1.96
                                                ],
                                                [
                                                    25.73,
                                                    2.328
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0.224
                                                ],
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.533,
                                                    -0.395
                                                ],
                                                [
                                                    -0.267,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    0.267,
                                                    -0.672
                                                ],
                                                [
                                                    0.544,
                                                    -0.395
                                                ],
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    0.235
                                                ],
                                                [
                                                    0.245,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.256,
                                                    -0.437
                                                ],
                                                [
                                                    0.427,
                                                    -0.224
                                                ],
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    0.395
                                                ],
                                                [
                                                    0.267,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    -0.267,
                                                    0.672
                                                ],
                                                [
                                                    -0.533,
                                                    0.395
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.437,
                                                    -0.245
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    35.595,
                                                    -6.072
                                                ],
                                                [
                                                    35.595,
                                                    -2.056
                                                ],
                                                [
                                                    36.619,
                                                    -3.048
                                                ],
                                                [
                                                    38.139,
                                                    -3.384
                                                ],
                                                [
                                                    40.107,
                                                    -2.792
                                                ],
                                                [
                                                    41.323,
                                                    -1.192
                                                ],
                                                [
                                                    41.723,
                                                    1.048
                                                ],
                                                [
                                                    41.323,
                                                    3.288
                                                ],
                                                [
                                                    40.107,
                                                    4.888
                                                ],
                                                [
                                                    38.139,
                                                    5.48
                                                ],
                                                [
                                                    36.555,
                                                    5.128
                                                ],
                                                [
                                                    35.531,
                                                    4.088
                                                ],
                                                [
                                                    35.483,
                                                    5.288
                                                ],
                                                [
                                                    33.611,
                                                    5.288
                                                ],
                                                [
                                                    33.611,
                                                    -6.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.533
                                                ],
                                                [
                                                    -0.149,
                                                    -0.427
                                                ],
                                                [
                                                    -0.309,
                                                    -0.256
                                                ],
                                                [
                                                    -0.48,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.533
                                                ],
                                                [
                                                    0,
                                                    0.789
                                                ],
                                                [
                                                    0.352,
                                                    0.544
                                                ],
                                                [
                                                    0.704,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.267
                                                ],
                                                [
                                                    0.149,
                                                    -0.427
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.501
                                                ],
                                                [
                                                    0.149,
                                                    0.427
                                                ],
                                                [
                                                    0.32,
                                                    0.256
                                                ],
                                                [
                                                    0.693,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.544
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.352,
                                                    -0.544
                                                ],
                                                [
                                                    -0.469,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    0.256
                                                ],
                                                [
                                                    -0.149,
                                                    0.427
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    35.467,
                                                    1.048
                                                ],
                                                [
                                                    35.691,
                                                    2.44
                                                ],
                                                [
                                                    36.379,
                                                    3.464
                                                ],
                                                [
                                                    37.579,
                                                    3.848
                                                ],
                                                [
                                                    39.147,
                                                    3.048
                                                ],
                                                [
                                                    39.691,
                                                    1.048
                                                ],
                                                [
                                                    39.163,
                                                    -1
                                                ],
                                                [
                                                    37.579,
                                                    -1.816
                                                ],
                                                [
                                                    36.395,
                                                    -1.416
                                                ],
                                                [
                                                    35.691,
                                                    -0.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.342,
                                                    0.245
                                                ],
                                                [
                                                    0.416,
                                                    0
                                                ],
                                                [
                                                    0.278,
                                                    -0.203
                                                ],
                                                [
                                                    0,
                                                    -0.331
                                                ],
                                                [
                                                    -0.32,
                                                    -0.181
                                                ],
                                                [
                                                    -0.512,
                                                    -0.096
                                                ],
                                                [
                                                    -0.512,
                                                    -0.203
                                                ],
                                                [
                                                    -0.266,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    -0.533
                                                ],
                                                [
                                                    0.32,
                                                    -0.363
                                                ],
                                                [
                                                    0.544,
                                                    -0.181
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.235
                                                ],
                                                [
                                                    0.342,
                                                    0.427
                                                ],
                                                [
                                                    0.054,
                                                    0.587
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.16,
                                                    -0.213
                                                ],
                                                [
                                                    -0.266,
                                                    -0.117
                                                ],
                                                [
                                                    -0.362,
                                                    0
                                                ],
                                                [
                                                    -0.309,
                                                    0.16
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    0.139,
                                                    0.139
                                                ],
                                                [
                                                    0.203,
                                                    0.064
                                                ],
                                                [
                                                    0.342,
                                                    0.075
                                                ],
                                                [
                                                    0.15,
                                                    0.043
                                                ],
                                                [
                                                    0.48,
                                                    0.181
                                                ],
                                                [
                                                    0.288,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.512
                                                ],
                                                [
                                                    -0.288,
                                                    0.405
                                                ],
                                                [
                                                    -0.533,
                                                    0.213
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.65,
                                                    -0.512
                                                ],
                                                [
                                                    -0.138,
                                                    -0.864
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.085,
                                                    -0.427
                                                ],
                                                [
                                                    -0.33,
                                                    -0.245
                                                ],
                                                [
                                                    -0.416,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    0.203
                                                ],
                                                [
                                                    0.011,
                                                    0.331
                                                ],
                                                [
                                                    0.32,
                                                    0.171
                                                ],
                                                [
                                                    0.811,
                                                    0.139
                                                ],
                                                [
                                                    0.512,
                                                    0.192
                                                ],
                                                [
                                                    0.278,
                                                    0.341
                                                ],
                                                [
                                                    0,
                                                    0.544
                                                ],
                                                [
                                                    -0.32,
                                                    0.363
                                                ],
                                                [
                                                    -0.533,
                                                    0.181
                                                ],
                                                [
                                                    -0.757,
                                                    0
                                                ],
                                                [
                                                    -0.586,
                                                    -0.235
                                                ],
                                                [
                                                    -0.33,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.054,
                                                    0.309
                                                ],
                                                [
                                                    0.171,
                                                    0.213
                                                ],
                                                [
                                                    0.267,
                                                    0.117
                                                ],
                                                [
                                                    0.416,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.16
                                                ],
                                                [
                                                    0,
                                                    -0.224
                                                ],
                                                [
                                                    -0.128,
                                                    -0.139
                                                ],
                                                [
                                                    -0.192,
                                                    -0.075
                                                ],
                                                [
                                                    -0.085,
                                                    -0.011
                                                ],
                                                [
                                                    -0.778,
                                                    -0.16
                                                ],
                                                [
                                                    -0.48,
                                                    -0.181
                                                ],
                                                [
                                                    -0.277,
                                                    -0.331
                                                ],
                                                [
                                                    0,
                                                    -0.544
                                                ],
                                                [
                                                    0.299,
                                                    -0.405
                                                ],
                                                [
                                                    0.544,
                                                    -0.224
                                                ],
                                                [
                                                    0.982,
                                                    0
                                                ],
                                                [
                                                    0.662,
                                                    0.501
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    48.523,
                                                    -0.488
                                                ],
                                                [
                                                    47.883,
                                                    -1.496
                                                ],
                                                [
                                                    46.763,
                                                    -1.864
                                                ],
                                                [
                                                    45.723,
                                                    -1.56
                                                ],
                                                [
                                                    45.323,
                                                    -0.76
                                                ],
                                                [
                                                    45.819,
                                                    0.008
                                                ],
                                                [
                                                    47.067,
                                                    0.408
                                                ],
                                                [
                                                    49.051,
                                                    0.92
                                                ],
                                                [
                                                    50.219,
                                                    1.72
                                                ],
                                                [
                                                    50.635,
                                                    3.032
                                                ],
                                                [
                                                    50.155,
                                                    4.392
                                                ],
                                                [
                                                    48.859,
                                                    5.208
                                                ],
                                                [
                                                    47.051,
                                                    5.48
                                                ],
                                                [
                                                    45.035,
                                                    5.128
                                                ],
                                                [
                                                    43.643,
                                                    4.136
                                                ],
                                                [
                                                    43.067,
                                                    2.6
                                                ],
                                                [
                                                    45.099,
                                                    2.488
                                                ],
                                                [
                                                    45.419,
                                                    3.272
                                                ],
                                                [
                                                    46.075,
                                                    3.768
                                                ],
                                                [
                                                    47.019,
                                                    3.944
                                                ],
                                                [
                                                    48.107,
                                                    3.704
                                                ],
                                                [
                                                    48.587,
                                                    2.968
                                                ],
                                                [
                                                    48.379,
                                                    2.424
                                                ],
                                                [
                                                    47.883,
                                                    2.12
                                                ],
                                                [
                                                    47.083,
                                                    1.896
                                                ],
                                                [
                                                    46.731,
                                                    1.816
                                                ],
                                                [
                                                    44.843,
                                                    1.304
                                                ],
                                                [
                                                    43.691,
                                                    0.552
                                                ],
                                                [
                                                    43.275,
                                                    -0.712
                                                ],
                                                [
                                                    43.707,
                                                    -2.136
                                                ],
                                                [
                                                    44.955,
                                                    -3.064
                                                ],
                                                [
                                                    46.875,
                                                    -3.4
                                                ],
                                                [
                                                    49.323,
                                                    -2.632
                                                ],
                                                [
                                                    50.523,
                                                    -0.584
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9216,
                                            0.9216,
                                            0.9216
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            111.339,
                                            23.212
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.125,
                                                    0.359
                                                ],
                                                [
                                                    0.321,
                                                    0.203
                                                ],
                                                [
                                                    0.378,
                                                    -0.042
                                                ],
                                                [
                                                    0.269,
                                                    -0.268
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    -0.325
                                                ],
                                                [
                                                    -0.127,
                                                    -0.307
                                                ],
                                                [
                                                    -0.276,
                                                    -0.184
                                                ],
                                                [
                                                    -0.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.08,
                                                    -0.041
                                                ],
                                                [
                                                    -0.052,
                                                    -0.073
                                                ],
                                                [
                                                    -0.012,
                                                    -0.089
                                                ],
                                                [
                                                    0.029,
                                                    -0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.125,
                                                    -0.359
                                                ],
                                                [
                                                    -0.322,
                                                    -0.202
                                                ],
                                                [
                                                    -0.378,
                                                    0.042
                                                ],
                                                [
                                                    -0.269,
                                                    0.268
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.065,
                                                    0.326
                                                ],
                                                [
                                                    0.127,
                                                    0.306
                                                ],
                                                [
                                                    0.275,
                                                    0.184
                                                ],
                                                [
                                                    0.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.08,
                                                    0.041
                                                ],
                                                [
                                                    0.051,
                                                    0.073
                                                ],
                                                [
                                                    0.012,
                                                    0.089
                                                ],
                                                [
                                                    -0.03,
                                                    0.085
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.127,
                                                    -0.359
                                                ],
                                                [
                                                    -0.125,
                                                    -0.359
                                                ],
                                                [
                                                    -0.321,
                                                    -0.203
                                                ],
                                                [
                                                    -0.377,
                                                    0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.234
                                                ],
                                                [
                                                    -0.064,
                                                    0.325
                                                ],
                                                [
                                                    0.126,
                                                    0.306
                                                ],
                                                [
                                                    0.276,
                                                    0.185
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0
                                                ],
                                                [
                                                    0.079,
                                                    0.041
                                                ],
                                                [
                                                    0.051,
                                                    0.073
                                                ],
                                                [
                                                    0.012,
                                                    0.088
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.126,
                                                    0.359
                                                ],
                                                [
                                                    0.125,
                                                    0.36
                                                ],
                                                [
                                                    0.321,
                                                    0.203
                                                ],
                                                [
                                                    0.378,
                                                    -0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.234,
                                                    -0.235
                                                ],
                                                [
                                                    0.064,
                                                    -0.325
                                                ],
                                                [
                                                    -0.127,
                                                    -0.306
                                                ],
                                                [
                                                    -0.276,
                                                    -0.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.09,
                                                    0
                                                ],
                                                [
                                                    -0.079,
                                                    -0.041
                                                ],
                                                [
                                                    -0.052,
                                                    -0.073
                                                ],
                                                [
                                                    -0.012,
                                                    -0.088
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.374,
                                                    -8.941
                                                ],
                                                [
                                                    4.377,
                                                    -10.049
                                                ],
                                                [
                                                    3.688,
                                                    -10.917
                                                ],
                                                [
                                                    2.608,
                                                    -11.165
                                                ],
                                                [
                                                    1.609,
                                                    -10.686
                                                ],
                                                [
                                                    -8.449,
                                                    -0.627
                                                ],
                                                [
                                                    -8.909,
                                                    0.231
                                                ],
                                                [
                                                    -8.813,
                                                    1.2
                                                ],
                                                [
                                                    -8.196,
                                                    1.952
                                                ],
                                                [
                                                    -7.265,
                                                    2.235
                                                ],
                                                [
                                                    -2.792,
                                                    2.235
                                                ],
                                                [
                                                    -2.535,
                                                    2.298
                                                ],
                                                [
                                                    -2.336,
                                                    2.471
                                                ],
                                                [
                                                    -2.239,
                                                    2.717
                                                ],
                                                [
                                                    -2.265,
                                                    2.98
                                                ],
                                                [
                                                    -4.375,
                                                    8.941
                                                ],
                                                [
                                                    -4.377,
                                                    10.049
                                                ],
                                                [
                                                    -3.687,
                                                    10.917
                                                ],
                                                [
                                                    -2.607,
                                                    11.165
                                                ],
                                                [
                                                    -1.608,
                                                    10.685
                                                ],
                                                [
                                                    8.451,
                                                    0.626
                                                ],
                                                [
                                                    8.909,
                                                    -0.233
                                                ],
                                                [
                                                    8.813,
                                                    -1.201
                                                ],
                                                [
                                                    8.196,
                                                    -1.953
                                                ],
                                                [
                                                    7.265,
                                                    -2.235
                                                ],
                                                [
                                                    2.798,
                                                    -2.235
                                                ],
                                                [
                                                    2.54,
                                                    -2.298
                                                ],
                                                [
                                                    2.341,
                                                    -2.471
                                                ],
                                                [
                                                    2.243,
                                                    -2.718
                                                ],
                                                [
                                                    2.27,
                                                    -2.981
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "gf",
                                    "nm": "Gradient Fill 1",
                                    "e": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            13.412
                                        ]
                                    },
                                    "g": {
                                        "p": 3,
                                        "k": {
                                            "a": 0,
                                            "k": [
                                                0,
                                                0.51372552,
                                                0.36078432,
                                                0.96078438,
                                                0.5,
                                                0.2941176635,
                                                0.6588235649999999,
                                                0.729411815,
                                                1,
                                                0.074509807,
                                                0.95686281,
                                                0.49803925
                                            ]
                                        }
                                    },
                                    "t": 1,
                                    "a": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "h": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            -13.412
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            36,
                                            32
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -10.493
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -19
                                                ],
                                                [
                                                    0,
                                                    -19
                                                ],
                                                [
                                                    19,
                                                    0
                                                ],
                                                [
                                                    19,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    19
                                                ],
                                                [
                                                    0,
                                                    19
                                                ],
                                                [
                                                    -19,
                                                    0
                                                ],
                                                [
                                                    -19,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.5255,
                                            0.3804,
                                            0.9529
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            36,
                                            32
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.624,
                                                    3.625
                                                ],
                                                [
                                                    -3.625,
                                                    -3.625
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.624,
                                                    3.625
                                                ],
                                                [
                                                    3.625,
                                                    -3.625
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.813
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            526.5,
                                            31.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    6.673
                                                ],
                                                [
                                                    6.673,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.673
                                                ],
                                                [
                                                    -6.673,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -6.673
                                                ],
                                                [
                                                    -6.673,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    6.673
                                                ],
                                                [
                                                    6.673,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -12.083
                                                ],
                                                [
                                                    -12.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    12.083
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.6863,
                                            0.5843,
                                            0.9961
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            526.5,
                                            31.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 8",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -13.255,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -13.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -13.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    13.255,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -278,
                                                    -7.5
                                                ],
                                                [
                                                    -254,
                                                    -31.5
                                                ],
                                                [
                                                    254,
                                                    -31.5
                                                ],
                                                [
                                                    278,
                                                    -7.5
                                                ],
                                                [
                                                    278,
                                                    31.5
                                                ],
                                                [
                                                    -278,
                                                    31.5
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            278,
                                            31.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "Comp_718",
            "id": "16",
            "fr": 60,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Comp_723",
                    "sr": 1,
                    "st": 0,
                    "op": 7463,
                    "ip": 0,
                    "ln": "34097",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                40.868,
                                40.834
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                1191,
                                1191
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 1202,
                    "h": 1201,
                    "refId": "17",
                    "ind": 1
                }
            ]
        },
        {
            "nm": "Comp_723",
            "id": "17",
            "fr": 60,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Shape Layer 4",
                    "sr": 1,
                    "st": 0,
                    "op": 7162,
                    "ip": 0,
                    "ln": "34096",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        100,
                                        100
                                    ],
                                    "t": 471.992
                                },
                                {
                                    "s": [
                                        100,
                                        60
                                    ],
                                    "t": 500.992
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                41,
                                41
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "rc",
                            "nm": "undefined",
                            "d": 1,
                            "p": {
                                "a": 0,
                                "k": [
                                    540,
                                    540
                                ]
                            },
                            "r": {
                                "a": 0,
                                "k": 60
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    1080,
                                    1080
                                ]
                            }
                        },
                        {
                            "ty": "fl",
                            "nm": "undefined",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100
                            }
                        }
                    ],
                    "ind": 1
                }
            ]
        }
    ]
};

//# sourceMappingURL=enterprise-ai-chatbot.914cabd2.js.map
